/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as NotFoundRouteImport } from './routes/not-found'
import { Route as PublicRoutesRouteImport } from './routes/_public-routes'
import { Route as PrivateRoutesRouteImport } from './routes/_private-routes'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PublicRoutesTiktokOnboardingRouteImport } from './routes/_public-routes/tiktok-onboarding'
import { Route as PublicRoutesTermsCombinedRouteImport } from './routes/_public-routes/terms-combined'
import { Route as PublicRoutesTermsRouteImport } from './routes/_public-routes/terms'
import { Route as PublicRoutesSignInRouteImport } from './routes/_public-routes/sign-in'
import { Route as PublicRoutesRedirect_toRouteImport } from './routes/_public-routes/redirect_to'
import { Route as PublicRoutesPrivacyRouteImport } from './routes/_public-routes/privacy'
import { Route as PrivateRoutesYoutubeCmsRouteImport } from './routes/_private-routes/youtube-cms'
import { Route as PrivateRoutesUserSettingsRouteImport } from './routes/_private-routes/user-settings'
import { Route as PrivateRoutesUserRouteImport } from './routes/_private-routes/user'
import { Route as PrivateRoutesTrendingRouteImport } from './routes/_private-routes/trending'
import { Route as PrivateRoutesToolsRouteImport } from './routes/_private-routes/tools'
import { Route as PrivateRoutesTiktokRouteImport } from './routes/_private-routes/tiktok'
import { Route as PrivateRoutesTalentAgencyRouteImport } from './routes/_private-routes/talent-agency'
import { Route as PrivateRoutesSettingsRouteImport } from './routes/_private-routes/settings'
import { Route as PrivateRoutesReportRouteImport } from './routes/_private-routes/report'
import { Route as PrivateRoutesPostsInsightRouteImport } from './routes/_private-routes/posts-insight'
import { Route as PrivateRoutesPostsRouteImport } from './routes/_private-routes/posts'
import { Route as PrivateRoutesPaymentsRouteImport } from './routes/_private-routes/payments'
import { Route as PrivateRoutesPartnerRouteImport } from './routes/_private-routes/partner'
import { Route as PrivateRoutesPackageRouteImport } from './routes/_private-routes/package'
import { Route as PrivateRoutesInfluencersRouteImport } from './routes/_private-routes/influencers'
import { Route as PrivateRoutesInfluencerRouteImport } from './routes/_private-routes/influencer'
import { Route as PrivateRoutesHashtagAnalyticsRouteImport } from './routes/_private-routes/hashtag-analytics'
import { Route as PrivateRoutesCampaignPostsDiscoveryRouteImport } from './routes/_private-routes/campaign-posts-discovery'
import { Route as PrivateRoutesAutoManagedRouteImport } from './routes/_private-routes/auto-managed'
import { Route as PrivateRoutesAssetPreviewRouteImport } from './routes/_private-routes/asset-preview'
import { Route as PrivateRoutesAnalyticsRouteImport } from './routes/_private-routes/analytics'
import { Route as PrivateRoutesAgencyRouteImport } from './routes/_private-routes/agency'
import { Route as PrivateRoutesAdvertiserRouteImport } from './routes/_private-routes/advertiser'
import { Route as PublicRoutesTiktokOnboardingIndexRouteImport } from './routes/_public-routes/tiktok-onboarding/index'
import { Route as PublicRoutesSignUpIndexRouteImport } from './routes/_public-routes/sign-up/index'
import { Route as PrivateRoutesYoutubeCmsIndexRouteImport } from './routes/_private-routes/youtube-cms/index'
import { Route as PrivateRoutesUserIndexRouteImport } from './routes/_private-routes/user/index'
import { Route as PrivateRoutesTrendingIndexRouteImport } from './routes/_private-routes/trending/index'
import { Route as PrivateRoutesToolsIndexRouteImport } from './routes/_private-routes/tools/index'
import { Route as PrivateRoutesTalentAgencyIndexRouteImport } from './routes/_private-routes/talent-agency/index'
import { Route as PrivateRoutesPromptsIndexRouteImport } from './routes/_private-routes/prompts/index'
import { Route as PrivateRoutesPostsInsightIndexRouteImport } from './routes/_private-routes/posts-insight/index'
import { Route as PrivateRoutesPartnerIndexRouteImport } from './routes/_private-routes/partner/index'
import { Route as PrivateRoutesPackageIndexRouteImport } from './routes/_private-routes/package/index'
import { Route as PrivateRoutesMarketplaceIndexRouteImport } from './routes/_private-routes/marketplace/index'
import { Route as PrivateRoutesInfluencersIndexRouteImport } from './routes/_private-routes/influencers/index'
import { Route as PrivateRoutesInfluencerIndexRouteImport } from './routes/_private-routes/influencer/index'
import { Route as PrivateRoutesHashtagAnalyticsIndexRouteImport } from './routes/_private-routes/hashtag-analytics/index'
import { Route as PrivateRoutesEngagementIndexRouteImport } from './routes/_private-routes/engagement/index'
import { Route as PrivateRoutesAutoManagedIndexRouteImport } from './routes/_private-routes/auto-managed/index'
import { Route as PrivateRoutesAnalyticsIndexRouteImport } from './routes/_private-routes/analytics/index'
import { Route as PrivateRoutesAgencyIndexRouteImport } from './routes/_private-routes/agency/index'
import { Route as PrivateRoutesAdvertiserIndexRouteImport } from './routes/_private-routes/advertiser/index'
import { Route as PrivateRoutesAccessIndexRouteImport } from './routes/_private-routes/access/index'
import { Route as PublicRoutesTiktokOnboardingSuccessRouteImport } from './routes/_public-routes/tiktok-onboarding/success'
import { Route as PublicRoutesTiktokOnboardingSelectPlanRouteImport } from './routes/_public-routes/tiktok-onboarding/select-plan'
import { Route as PublicRoutesTiktokOnboardingPasswordEnterRouteImport } from './routes/_public-routes/tiktok-onboarding/password-enter'
import { Route as PublicRoutesTiktokOnboardingAdAccountRouteImport } from './routes/_public-routes/tiktok-onboarding/ad-account'
import { Route as PublicRoutesSignUpSuccessRouteImport } from './routes/_public-routes/sign-up/success'
import { Route as PublicRoutesMkpReferralRouteImport } from './routes/_public-routes/mkp.referral'
import { Route as PublicRoutesEggReferralRouteImport } from './routes/_public-routes/egg.referral'
import { Route as PublicRoutesPasswordPassword_forgotRouteImport } from './routes/_public-routes/_password/password_forgot'
import { Route as PrivateRoutesYoutubeCmsRevenueRouteImport } from './routes/_private-routes/youtube-cms/revenue'
import { Route as PrivateRoutesYoutubeCmsInvoicesRouteImport } from './routes/_private-routes/youtube-cms/invoices'
import { Route as PrivateRoutesUserLinkedRouteImport } from './routes/_private-routes/user/linked'
import { Route as PrivateRoutesUserAddRouteImport } from './routes/_private-routes/user/add'
import { Route as PrivateRoutesUserIdRouteImport } from './routes/_private-routes/user/$id'
import { Route as PrivateRoutesTrendingPostsRouteImport } from './routes/_private-routes/trending/posts'
import { Route as PrivateRoutesTrendingInfluencersRouteImport } from './routes/_private-routes/trending/influencers'
import { Route as PrivateRoutesToolsVideoCompAiRouteImport } from './routes/_private-routes/tools/video-comp-ai'
import { Route as PrivateRoutesTiktokSubscriptionBillingRouteImport } from './routes/_private-routes/tiktok/subscription-billing'
import { Route as PrivateRoutesTiktokFailedPaymentRouteImport } from './routes/_private-routes/tiktok/failed-payment'
import { Route as PrivateRoutesTiktokCampaignsRouteImport } from './routes/_private-routes/tiktok/campaigns'
import { Route as PrivateRoutesTiktokBudgetAllocationRouteImport } from './routes/_private-routes/tiktok/budget-allocation'
import { Route as PrivateRoutesTiktokAdvertiserDetailsRouteImport } from './routes/_private-routes/tiktok/advertiser-details'
import { Route as PrivateRoutesTiktokAdCampaignReportRouteImport } from './routes/_private-routes/tiktok/ad-campaign-report'
import { Route as PrivateRoutesTiktokAdAccountsRouteImport } from './routes/_private-routes/tiktok/ad-accounts'
import { Route as PrivateRoutesTalentAgencyAddRouteImport } from './routes/_private-routes/talent-agency/add'
import { Route as PrivateRoutesTalentAgencyIdRouteImport } from './routes/_private-routes/talent-agency/$id'
import { Route as PrivateRoutesRedirectGoogleAuthRouteImport } from './routes/_private-routes/redirect/google-auth'
import { Route as PrivateRoutesPostsInsightIdRouteImport } from './routes/_private-routes/posts-insight/$id'
import { Route as PrivateRoutesPartnerIdRouteImport } from './routes/_private-routes/partner/$id'
import { Route as PrivateRoutesPackageAddRouteImport } from './routes/_private-routes/package/add'
import { Route as PrivateRoutesPackageIdRouteImport } from './routes/_private-routes/package/$id'
import { Route as PrivateRoutesMarketplaceReorderRouteImport } from './routes/_private-routes/marketplace/reorder'
import { Route as PrivateRoutesMarketplaceAddRouteImport } from './routes/_private-routes/marketplace/add'
import { Route as PrivateRoutesMarketplaceIdRouteImport } from './routes/_private-routes/marketplace/$id'
import { Route as PrivateRoutesInfluencersSearchRouteImport } from './routes/_private-routes/influencers/search'
import { Route as PrivateRoutesInfluencersProposalRouteImport } from './routes/_private-routes/influencers/proposal'
import { Route as PrivateRoutesInfluencerAddRouteImport } from './routes/_private-routes/influencer/add'
import { Route as PrivateRoutesInfluencerIdRouteImport } from './routes/_private-routes/influencer/$id'
import { Route as PrivateRoutesHashtagAnalyticsTiktokRouteImport } from './routes/_private-routes/hashtag-analytics/tiktok'
import { Route as PrivateRoutesHashtagAnalyticsInstagramRouteImport } from './routes/_private-routes/hashtag-analytics/instagram'
import { Route as PrivateRoutesEngagementAddRouteImport } from './routes/_private-routes/engagement/add'
import { Route as PrivateRoutesEngagementIdRouteImport } from './routes/_private-routes/engagement/$id'
import { Route as PrivateRoutesAutoManagedIdRouteImport } from './routes/_private-routes/auto-managed/$id'
import { Route as PrivateRoutesAnalyticsAddRouteImport } from './routes/_private-routes/analytics/add'
import { Route as PrivateRoutesAgencyAddRouteImport } from './routes/_private-routes/agency/add'
import { Route as PrivateRoutesAgencyIdRouteImport } from './routes/_private-routes/agency/$id'
import { Route as PrivateRoutesAdvertiserAddRouteImport } from './routes/_private-routes/advertiser/add'
import { Route as PrivateRoutesAdvertiserIdRouteImport } from './routes/_private-routes/advertiser/$id'
import { Route as PrivateRoutesAccessDeclinedRouteImport } from './routes/_private-routes/access/declined'
import { Route as PrivateRoutesAccessAuthorizedRouteImport } from './routes/_private-routes/access/authorized'
import { Route as PrivateRoutesYoutubeCmsRevenueIndexRouteImport } from './routes/_private-routes/youtube-cms/revenue/index'
import { Route as PrivateRoutesTiktokCampaignsIndexRouteImport } from './routes/_private-routes/tiktok/campaigns/index'
import { Route as PrivateRoutesTiktokAdCampaignReportIndexRouteImport } from './routes/_private-routes/tiktok/ad-campaign-report/index'
import { Route as PrivateRoutesTalentAgencyIdIndexRouteImport } from './routes/_private-routes/talent-agency/$id/index'
import { Route as PrivateRoutesPartnerIdIndexRouteImport } from './routes/_private-routes/partner/$id/index'
import { Route as PrivateRoutesPackageIdIndexRouteImport } from './routes/_private-routes/package/$id/index'
import { Route as PrivateRoutesMarketplaceAddIndexRouteImport } from './routes/_private-routes/marketplace/add/index'
import { Route as PrivateRoutesMarketplaceIdIndexRouteImport } from './routes/_private-routes/marketplace/$id/index'
import { Route as PrivateRoutesInfluencersSearchIndexRouteImport } from './routes/_private-routes/influencers/search/index'
import { Route as PrivateRoutesInfluencerIdIndexRouteImport } from './routes/_private-routes/influencer/$id/index'
import { Route as PrivateRoutesHashtagAnalyticsTiktokIndexRouteImport } from './routes/_private-routes/hashtag-analytics/tiktok/index'
import { Route as PrivateRoutesHashtagAnalyticsInstagramIndexRouteImport } from './routes/_private-routes/hashtag-analytics/instagram/index'
import { Route as PrivateRoutesEngagementIdIndexRouteImport } from './routes/_private-routes/engagement/$id/index'
import { Route as PrivateRoutesAutoManagedIdIndexRouteImport } from './routes/_private-routes/auto-managed/$id/index'
import { Route as PrivateRoutesAnalyticsBrandAccountIdIndexRouteImport } from './routes/_private-routes/analytics/$brandAccountId/index'
import { Route as PrivateRoutesAgencyIdIndexRouteImport } from './routes/_private-routes/agency/$id/index'
import { Route as PrivateRoutesAdvertiserIdIndexRouteImport } from './routes/_private-routes/advertiser/$id/index'
import { Route as PublicRoutesTiktokOnboardingPasswordRegisterTokenRouteImport } from './routes/_public-routes/tiktok-onboarding/password-register.$token'
import { Route as PublicRoutesPasswordPassword_resetTokenRouteImport } from './routes/_public-routes/_password/password_reset.$token'
import { Route as PublicRoutesPasswordPassword_registerTokenRouteImport } from './routes/_public-routes/_password/password_register.$token'
import { Route as PrivateRoutesYoutubeCmsRevenueConfirmedRouteImport } from './routes/_private-routes/youtube-cms/revenue/confirmed'
import { Route as PrivateRoutesYoutubeCmsRevenueCmsChannelIdRouteImport } from './routes/_private-routes/youtube-cms/revenue/$cmsChannelId'
import { Route as PrivateRoutesTiktokCampaignsReviewInfluencersRouteImport } from './routes/_private-routes/tiktok/campaigns/review-influencers'
import { Route as PrivateRoutesTiktokCampaignsAddRouteImport } from './routes/_private-routes/tiktok/campaigns/add'
import { Route as PrivateRoutesTiktokCampaignsIdRouteImport } from './routes/_private-routes/tiktok/campaigns/$id'
import { Route as PrivateRoutesTalentAgencyIdUsersRouteImport } from './routes/_private-routes/talent-agency/$id/users'
import { Route as PrivateRoutesTalentAgencyIdBusinessRouteImport } from './routes/_private-routes/talent-agency/$id/business'
import { Route as PrivateRoutesRedirectTalentSigninProviderRouteImport } from './routes/_private-routes/redirect/talent-signin.$provider'
import { Route as PrivateRoutesRedirectTalentAnalyticsConnectProviderRouteImport } from './routes/_private-routes/redirect/talent-analytics-connect.$provider'
import { Route as PrivateRoutesRedirectHiddenYoutubeListConnectRouteImport } from './routes/_private-routes/redirect/hidden.youtube-list-connect'
import { Route as PrivateRoutesRedirectConnectTiktokBusinessRouteImport } from './routes/_private-routes/redirect/connect.tiktok-business'
import { Route as PrivateRoutesRedirectAnalyticsSigninProviderRouteImport } from './routes/_private-routes/redirect/analytics-signin.$provider'
import { Route as PrivateRoutesRedirectAnalyticsListConnectProviderRouteImport } from './routes/_private-routes/redirect/analytics-list-connect.$provider'
import { Route as PrivateRoutesRedirectAnalyticsConnectProviderRouteImport } from './routes/_private-routes/redirect/analytics-connect.$provider'
import { Route as PrivateRoutesPostsInsightIdPostIdRouteImport } from './routes/_private-routes/posts-insight/$id.$postId'
import { Route as PrivateRoutesPartnerIdUsersRouteImport } from './routes/_private-routes/partner/$id/users'
import { Route as PrivateRoutesPartnerIdBusinessRouteImport } from './routes/_private-routes/partner/$id/business'
import { Route as PrivateRoutesPackageIdContentRouteImport } from './routes/_private-routes/package/$id/content'
import { Route as PrivateRoutesMarketplaceAddUrlTrackingRouteImport } from './routes/_private-routes/marketplace/add/url-tracking'
import { Route as PrivateRoutesMarketplaceAddSocialMediaTrackingRouteImport } from './routes/_private-routes/marketplace/add/social-media-tracking'
import { Route as PrivateRoutesMarketplaceAddReferralCodeTrackingRouteImport } from './routes/_private-routes/marketplace/add/referral-code-tracking'
import { Route as PrivateRoutesMarketplaceIdTrackingReferralCodesRouteImport } from './routes/_private-routes/marketplace/$id/tracking-referral-codes'
import { Route as PrivateRoutesMarketplaceIdTrackingRouteImport } from './routes/_private-routes/marketplace/$id/tracking'
import { Route as PrivateRoutesMarketplaceIdReportAffiliateRouteImport } from './routes/_private-routes/marketplace/$id/report-affiliate'
import { Route as PrivateRoutesMarketplaceIdReportRouteImport } from './routes/_private-routes/marketplace/$id/report'
import { Route as PrivateRoutesMarketplaceIdPostsRouteImport } from './routes/_private-routes/marketplace/$id/posts'
import { Route as PrivateRoutesMarketplaceIdJoinedInfluencersRouteImport } from './routes/_private-routes/marketplace/$id/joined-influencers'
import { Route as PrivateRoutesMarketplaceIdInfluencerRouteImport } from './routes/_private-routes/marketplace/$id/influencer'
import { Route as PrivateRoutesMarketplaceIdCommissionsRouteImport } from './routes/_private-routes/marketplace/$id/commissions'
import { Route as PrivateRoutesMarketplaceIdApplicantRouteImport } from './routes/_private-routes/marketplace/$id/applicant'
import { Route as PrivateRoutesInfluencersSearchYoutubeRouteImport } from './routes/_private-routes/influencers/search/youtube'
import { Route as PrivateRoutesInfluencersSearchXhsRouteImport } from './routes/_private-routes/influencers/search/xhs'
import { Route as PrivateRoutesInfluencersSearchTwitterRouteImport } from './routes/_private-routes/influencers/search/twitter'
import { Route as PrivateRoutesInfluencersSearchTiktokRouteImport } from './routes/_private-routes/influencers/search/tiktok'
import { Route as PrivateRoutesInfluencersSearchThreadsRouteImport } from './routes/_private-routes/influencers/search/threads'
import { Route as PrivateRoutesInfluencersSearchInstagramRouteImport } from './routes/_private-routes/influencers/search/instagram'
import { Route as PrivateRoutesInfluencersSearchFacebook_pageRouteImport } from './routes/_private-routes/influencers/search/facebook_page'
import { Route as PrivateRoutesInfluencersSearchFacebookRouteImport } from './routes/_private-routes/influencers/search/facebook'
import { Route as PrivateRoutesInfluencersSearchDouyinRouteImport } from './routes/_private-routes/influencers/search/douyin'
import { Route as PrivateRoutesInfluencerIdProfileRouteImport } from './routes/_private-routes/influencer/$id/profile'
import { Route as PrivateRoutesHashtagAnalyticsTiktokKeywordRouteImport } from './routes/_private-routes/hashtag-analytics/tiktok/keyword'
import { Route as PrivateRoutesHashtagAnalyticsTiktokHashtagRouteImport } from './routes/_private-routes/hashtag-analytics/tiktok/hashtag'
import { Route as PrivateRoutesHashtagAnalyticsInstagramCountryIdRouteImport } from './routes/_private-routes/hashtag-analytics/instagram/$countryId'
import { Route as PrivateRoutesEngagementIdTrackingReferralCodesRouteImport } from './routes/_private-routes/engagement/$id/tracking-referral-codes'
import { Route as PrivateRoutesEngagementIdTrackingRouteImport } from './routes/_private-routes/engagement/$id/tracking'
import { Route as PrivateRoutesEngagementIdReportRouteImport } from './routes/_private-routes/engagement/$id/report'
import { Route as PrivateRoutesEngagementIdProposalRouteImport } from './routes/_private-routes/engagement/$id/proposal'
import { Route as PrivateRoutesEngagementIdPostsRouteImport } from './routes/_private-routes/engagement/$id/posts'
import { Route as PrivateRoutesEngagementIdInfluencerRouteImport } from './routes/_private-routes/engagement/$id/influencer'
import { Route as PrivateRoutesAutoManagedIdReportRouteImport } from './routes/_private-routes/auto-managed/$id/report'
import { Route as PrivateRoutesAutoManagedIdJoinedInfluencersRouteImport } from './routes/_private-routes/auto-managed/$id/joined-influencers'
import { Route as PrivateRoutesAutoManagedIdCommissionsRouteImport } from './routes/_private-routes/auto-managed/$id/commissions'
import { Route as PrivateRoutesAgencyIdUsersRouteImport } from './routes/_private-routes/agency/$id/users'
import { Route as PrivateRoutesAgencyIdBusinessRouteImport } from './routes/_private-routes/agency/$id/business'
import { Route as PrivateRoutesAdvertiserIdUsersRouteImport } from './routes/_private-routes/advertiser/$id/users'
import { Route as PrivateRoutesAdvertiserIdBudgetAllocationRouteImport } from './routes/_private-routes/advertiser/$id/budget-allocation'
import { Route as PrivateRoutesTiktokCampaignsIdIndexRouteImport } from './routes/_private-routes/tiktok/campaigns/$id/index'
import { Route as PrivateRoutesTiktokAdCampaignReportIdIndexRouteImport } from './routes/_private-routes/tiktok/ad-campaign-report/$id/index'
import { Route as PrivateRoutesPackageIdContentIndexRouteImport } from './routes/_private-routes/package/$id/content/index'
import { Route as PrivateRoutesMarketplaceAddECommerceIndexRouteImport } from './routes/_private-routes/marketplace/add/e-commerce/index'
import { Route as PrivateRoutesMarketplaceIdPostsIndexRouteImport } from './routes/_private-routes/marketplace/$id/posts/index'
import { Route as PrivateRoutesInfluencerIdProfileIndexRouteImport } from './routes/_private-routes/influencer/$id/profile/index'
import { Route as PrivateRoutesHashtagAnalyticsTiktokKeywordIndexRouteImport } from './routes/_private-routes/hashtag-analytics/tiktok/keyword/index'
import { Route as PrivateRoutesHashtagAnalyticsTiktokHashtagIndexRouteImport } from './routes/_private-routes/hashtag-analytics/tiktok/hashtag/index'
import { Route as PrivateRoutesEngagementIdPostsIndexRouteImport } from './routes/_private-routes/engagement/$id/posts/index'
import { Route as PrivateRoutesEngagementIdInfluencerIndexRouteImport } from './routes/_private-routes/engagement/$id/influencer/index'
import { Route as PrivateRoutesTiktokCampaignsIdReportRouteImport } from './routes/_private-routes/tiktok/campaigns/$id/report'
import { Route as PrivateRoutesTiktokCampaignsIdPostsRouteImport } from './routes/_private-routes/tiktok/campaigns/$id/posts'
import { Route as PrivateRoutesTiktokCampaignsIdInfluencersRouteImport } from './routes/_private-routes/tiktok/campaigns/$id/influencers'
import { Route as PrivateRoutesTiktokAdCampaignReportIdGroupIdRouteImport } from './routes/_private-routes/tiktok/ad-campaign-report/$id/$groupId'
import { Route as PrivateRoutesPackageIdContentSearchRouteImport } from './routes/_private-routes/package/$id/content/search'
import { Route as PrivateRoutesPackageIdContentListRouteImport } from './routes/_private-routes/package/$id/content/list'
import { Route as PrivateRoutesMarketplaceAddECommerceAutoMangedCampaignIdRouteImport } from './routes/_private-routes/marketplace/add/e-commerce/$autoMangedCampaignId'
import { Route as PrivateRoutesMarketplaceIdPostsPostIdRouteImport } from './routes/_private-routes/marketplace/$id/posts/$postId'
import { Route as PrivateRoutesInfluencerIdProfileCompareRouteImport } from './routes/_private-routes/influencer/$id/profile/compare'
import { Route as PrivateRoutesInfluencerIdProfileCampaignsRouteImport } from './routes/_private-routes/influencer/$id/profile/campaigns'
import { Route as PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_tags_rankingRouteImport } from './routes/_private-routes/influencer/$id/$socialMediaAccountId/youtube_tags_ranking'
import { Route as PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_compare_feed_videosRouteImport } from './routes/_private-routes/influencer/$id/$socialMediaAccountId/youtube_compare_feed_videos'
import { Route as PrivateRoutesInfluencerIdSocialMediaAccountIdXhs_video_postsRouteImport } from './routes/_private-routes/influencer/$id/$socialMediaAccountId/xhs_video_posts'
import { Route as PrivateRoutesInfluencerIdSocialMediaAccountIdXhs_picture_postsRouteImport } from './routes/_private-routes/influencer/$id/$socialMediaAccountId/xhs_picture_posts'
import { Route as PrivateRoutesInfluencerIdSocialMediaAccountIdTwitter_feed_postsRouteImport } from './routes/_private-routes/influencer/$id/$socialMediaAccountId/twitter_feed_posts'
import { Route as PrivateRoutesInfluencerIdSocialMediaAccountIdSponsored_youtube_feed_postsRouteImport } from './routes/_private-routes/influencer/$id/$socialMediaAccountId/sponsored_youtube_feed_posts'
import { Route as PrivateRoutesInfluencerIdSocialMediaAccountIdSponsored_feed_postsRouteImport } from './routes/_private-routes/influencer/$id/$socialMediaAccountId/sponsored_feed_posts'
import { Route as PrivateRoutesInfluencerIdSocialMediaAccountIdShortsRouteImport } from './routes/_private-routes/influencer/$id/$socialMediaAccountId/shorts'
import { Route as PrivateRoutesInfluencerIdSocialMediaAccountIdScraping_feed_postsRouteImport } from './routes/_private-routes/influencer/$id/$socialMediaAccountId/scraping_feed_posts'
import { Route as PrivateRoutesInfluencerIdSocialMediaAccountIdInstagram_story_postRouteImport } from './routes/_private-routes/influencer/$id/$socialMediaAccountId/instagram_story_post'
import { Route as PrivateRoutesInfluencerIdSocialMediaAccountIdInstagram_reel_postRouteImport } from './routes/_private-routes/influencer/$id/$socialMediaAccountId/instagram_reel_post'
import { Route as PrivateRoutesInfluencerIdSocialMediaAccountIdInstagram_feed_postRouteImport } from './routes/_private-routes/influencer/$id/$socialMediaAccountId/instagram_feed_post'
import { Route as PrivateRoutesInfluencerIdSocialMediaAccountIdFeed_videosRouteImport } from './routes/_private-routes/influencer/$id/$socialMediaAccountId/feed_videos'
import { Route as PrivateRoutesInfluencerIdSocialMediaAccountIdFacebook_feed_postRouteImport } from './routes/_private-routes/influencer/$id/$socialMediaAccountId/facebook_feed_post'
import { Route as PrivateRoutesHashtagAnalyticsTiktokKeywordCountryIdRouteImport } from './routes/_private-routes/hashtag-analytics/tiktok/keyword/$countryId'
import { Route as PrivateRoutesHashtagAnalyticsTiktokHashtagCountryIdRouteImport } from './routes/_private-routes/hashtag-analytics/tiktok/hashtag/$countryId'
import { Route as PrivateRoutesEngagementIdPostsAddRouteImport } from './routes/_private-routes/engagement/$id/posts/add'
import { Route as PrivateRoutesEngagementIdPostsPostIdRouteImport } from './routes/_private-routes/engagement/$id/posts/$postId'
import { Route as PrivateRoutesEngagementIdInfluencerYoutubeRouteImport } from './routes/_private-routes/engagement/$id/influencer/youtube'
import { Route as PrivateRoutesEngagementIdInfluencerXhsRouteImport } from './routes/_private-routes/engagement/$id/influencer/xhs'
import { Route as PrivateRoutesEngagementIdInfluencerTwitterRouteImport } from './routes/_private-routes/engagement/$id/influencer/twitter'
import { Route as PrivateRoutesEngagementIdInfluencerTiktokRouteImport } from './routes/_private-routes/engagement/$id/influencer/tiktok'
import { Route as PrivateRoutesEngagementIdInfluencerThreadsRouteImport } from './routes/_private-routes/engagement/$id/influencer/threads'
import { Route as PrivateRoutesEngagementIdInfluencerPostsRouteImport } from './routes/_private-routes/engagement/$id/influencer/posts'
import { Route as PrivateRoutesEngagementIdInfluencerPackagesRouteImport } from './routes/_private-routes/engagement/$id/influencer/packages'
import { Route as PrivateRoutesEngagementIdInfluencerInstagramRouteImport } from './routes/_private-routes/engagement/$id/influencer/instagram'
import { Route as PrivateRoutesEngagementIdInfluencerFacebook_pageRouteImport } from './routes/_private-routes/engagement/$id/influencer/facebook_page'
import { Route as PrivateRoutesEngagementIdInfluencerFacebookRouteImport } from './routes/_private-routes/engagement/$id/influencer/facebook'
import { Route as PrivateRoutesEngagementIdInfluencerDouyinRouteImport } from './routes/_private-routes/engagement/$id/influencer/douyin'
import { Route as PrivateRoutesEngagementIdInfluencerCampaignsRouteImport } from './routes/_private-routes/engagement/$id/influencer/campaigns'
import { Route as PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRouteImport } from './routes/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId'
import { Route as PrivateRoutesTiktokCampaignsIdPostsIndexRouteImport } from './routes/_private-routes/tiktok/campaigns/$id/posts/index'
import { Route as PrivateRoutesPackageIdContentSearchIndexRouteImport } from './routes/_private-routes/package/$id/content/search/index'
import { Route as PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_compare_feed_videosIndexRouteImport } from './routes/_private-routes/influencer/$id/$socialMediaAccountId/youtube_compare_feed_videos/index'
import { Route as PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdIndexRouteImport } from './routes/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/index'
import { Route as PrivateRoutesTiktokCampaignsIdPostsPostIdRouteImport } from './routes/_private-routes/tiktok/campaigns/$id/posts/$postId'
import { Route as PrivateRoutesPackageIdContentSearchYoutubeRouteImport } from './routes/_private-routes/package/$id/content/search/youtube'
import { Route as PrivateRoutesPackageIdContentSearchXhsRouteImport } from './routes/_private-routes/package/$id/content/search/xhs'
import { Route as PrivateRoutesPackageIdContentSearchTwitterRouteImport } from './routes/_private-routes/package/$id/content/search/twitter'
import { Route as PrivateRoutesPackageIdContentSearchTiktokRouteImport } from './routes/_private-routes/package/$id/content/search/tiktok'
import { Route as PrivateRoutesPackageIdContentSearchThreadsRouteImport } from './routes/_private-routes/package/$id/content/search/threads'
import { Route as PrivateRoutesPackageIdContentSearchInstagramRouteImport } from './routes/_private-routes/package/$id/content/search/instagram'
import { Route as PrivateRoutesPackageIdContentSearchFacebook_pageRouteImport } from './routes/_private-routes/package/$id/content/search/facebook_page'
import { Route as PrivateRoutesPackageIdContentSearchFacebookRouteImport } from './routes/_private-routes/package/$id/content/search/facebook'
import { Route as PrivateRoutesPackageIdContentSearchDouyinRouteImport } from './routes/_private-routes/package/$id/content/search/douyin'
import { Route as PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_compare_feed_videosCompareIdRouteImport } from './routes/_private-routes/influencer/$id/$socialMediaAccountId/youtube_compare_feed_videos/$compareId'
import { Route as PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdUgcRouteImport } from './routes/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/ugc'
import { Route as PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdTrendRouteImport } from './routes/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/trend'
import { Route as PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdHashtagRouteImport } from './routes/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/hashtag'
import { Route as PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionIndexRouteImport } from './routes/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/interaction/index'
import { Route as PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardIndexRouteImport } from './routes/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/index'
import { Route as PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdCompareIndexRouteImport } from './routes/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/compare/index'
import { Route as PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionTagged_postsRouteImport } from './routes/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/interaction/tagged_posts'
import { Route as PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionMentioned_postsRouteImport } from './routes/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/interaction/mentioned_posts'
import { Route as PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionBrandAmbassadorsRouteImport } from './routes/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/interaction/brand-ambassadors'
import { Route as PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardYoutube_commentsRouteImport } from './routes/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/youtube_comments'
import { Route as PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardTwitter_feed_postsRouteImport } from './routes/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/twitter_feed_posts'
import { Route as PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardTag_ranking_listRouteImport } from './routes/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/tag_ranking_list'
import { Route as PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardShortsRouteImport } from './routes/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/shorts'
import { Route as PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_story_postRouteImport } from './routes/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/instagram_story_post'
import { Route as PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_reel_postRouteImport } from './routes/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/instagram_reel_post'
import { Route as PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_feed_postRouteImport } from './routes/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/instagram_feed_post'
import { Route as PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_commentsRouteImport } from './routes/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/instagram_comments'
import { Route as PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardFeed_videosRouteImport } from './routes/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/feed_videos'
import { Route as PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardFacebook_feed_postRouteImport } from './routes/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/facebook_feed_post'
import { Route as PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdCompareYoutube_compare_feed_videosRouteImport } from './routes/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/compare/youtube_compare_feed_videos'
import { Route as PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdCompareInstagram_compare_feed_postRouteImport } from './routes/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/compare/instagram_compare_feed_post'

const NotFoundRoute = NotFoundRouteImport.update({
  id: '/not-found',
  path: '/not-found',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoutesRoute = PublicRoutesRouteImport.update({
  id: '/_public-routes',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivateRoutesRoute = PrivateRoutesRouteImport.update({
  id: '/_private-routes',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoutesTiktokOnboardingRoute =
  PublicRoutesTiktokOnboardingRouteImport.update({
    id: '/tiktok-onboarding',
    path: '/tiktok-onboarding',
    getParentRoute: () => PublicRoutesRoute,
  } as any)
const PublicRoutesTermsCombinedRoute =
  PublicRoutesTermsCombinedRouteImport.update({
    id: '/terms-combined',
    path: '/terms-combined',
    getParentRoute: () => PublicRoutesRoute,
  } as any)
const PublicRoutesTermsRoute = PublicRoutesTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => PublicRoutesRoute,
} as any)
const PublicRoutesSignInRoute = PublicRoutesSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => PublicRoutesRoute,
} as any)
const PublicRoutesRedirect_toRoute = PublicRoutesRedirect_toRouteImport.update({
  id: '/redirect_to',
  path: '/redirect_to',
  getParentRoute: () => PublicRoutesRoute,
} as any)
const PublicRoutesPrivacyRoute = PublicRoutesPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => PublicRoutesRoute,
} as any)
const PrivateRoutesYoutubeCmsRoute = PrivateRoutesYoutubeCmsRouteImport.update({
  id: '/youtube-cms',
  path: '/youtube-cms',
  getParentRoute: () => PrivateRoutesRoute,
} as any)
const PrivateRoutesUserSettingsRoute =
  PrivateRoutesUserSettingsRouteImport.update({
    id: '/user-settings',
    path: '/user-settings',
    getParentRoute: () => PrivateRoutesRoute,
  } as any)
const PrivateRoutesUserRoute = PrivateRoutesUserRouteImport.update({
  id: '/user',
  path: '/user',
  getParentRoute: () => PrivateRoutesRoute,
} as any)
const PrivateRoutesTrendingRoute = PrivateRoutesTrendingRouteImport.update({
  id: '/trending',
  path: '/trending',
  getParentRoute: () => PrivateRoutesRoute,
} as any)
const PrivateRoutesToolsRoute = PrivateRoutesToolsRouteImport.update({
  id: '/tools',
  path: '/tools',
  getParentRoute: () => PrivateRoutesRoute,
} as any)
const PrivateRoutesTiktokRoute = PrivateRoutesTiktokRouteImport.update({
  id: '/tiktok',
  path: '/tiktok',
  getParentRoute: () => PrivateRoutesRoute,
} as any)
const PrivateRoutesTalentAgencyRoute =
  PrivateRoutesTalentAgencyRouteImport.update({
    id: '/talent-agency',
    path: '/talent-agency',
    getParentRoute: () => PrivateRoutesRoute,
  } as any)
const PrivateRoutesSettingsRoute = PrivateRoutesSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => PrivateRoutesRoute,
} as any)
const PrivateRoutesReportRoute = PrivateRoutesReportRouteImport.update({
  id: '/report',
  path: '/report',
  getParentRoute: () => PrivateRoutesRoute,
} as any)
const PrivateRoutesPostsInsightRoute =
  PrivateRoutesPostsInsightRouteImport.update({
    id: '/posts-insight',
    path: '/posts-insight',
    getParentRoute: () => PrivateRoutesRoute,
  } as any)
const PrivateRoutesPostsRoute = PrivateRoutesPostsRouteImport.update({
  id: '/posts',
  path: '/posts',
  getParentRoute: () => PrivateRoutesRoute,
} as any)
const PrivateRoutesPaymentsRoute = PrivateRoutesPaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => PrivateRoutesRoute,
} as any)
const PrivateRoutesPartnerRoute = PrivateRoutesPartnerRouteImport.update({
  id: '/partner',
  path: '/partner',
  getParentRoute: () => PrivateRoutesRoute,
} as any)
const PrivateRoutesPackageRoute = PrivateRoutesPackageRouteImport.update({
  id: '/package',
  path: '/package',
  getParentRoute: () => PrivateRoutesRoute,
} as any)
const PrivateRoutesInfluencersRoute =
  PrivateRoutesInfluencersRouteImport.update({
    id: '/influencers',
    path: '/influencers',
    getParentRoute: () => PrivateRoutesRoute,
  } as any)
const PrivateRoutesInfluencerRoute = PrivateRoutesInfluencerRouteImport.update({
  id: '/influencer',
  path: '/influencer',
  getParentRoute: () => PrivateRoutesRoute,
} as any)
const PrivateRoutesHashtagAnalyticsRoute =
  PrivateRoutesHashtagAnalyticsRouteImport.update({
    id: '/hashtag-analytics',
    path: '/hashtag-analytics',
    getParentRoute: () => PrivateRoutesRoute,
  } as any)
const PrivateRoutesCampaignPostsDiscoveryRoute =
  PrivateRoutesCampaignPostsDiscoveryRouteImport.update({
    id: '/campaign-posts-discovery',
    path: '/campaign-posts-discovery',
    getParentRoute: () => PrivateRoutesRoute,
  } as any)
const PrivateRoutesAutoManagedRoute =
  PrivateRoutesAutoManagedRouteImport.update({
    id: '/auto-managed',
    path: '/auto-managed',
    getParentRoute: () => PrivateRoutesRoute,
  } as any)
const PrivateRoutesAssetPreviewRoute =
  PrivateRoutesAssetPreviewRouteImport.update({
    id: '/asset-preview',
    path: '/asset-preview',
    getParentRoute: () => PrivateRoutesRoute,
  } as any)
const PrivateRoutesAnalyticsRoute = PrivateRoutesAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => PrivateRoutesRoute,
} as any)
const PrivateRoutesAgencyRoute = PrivateRoutesAgencyRouteImport.update({
  id: '/agency',
  path: '/agency',
  getParentRoute: () => PrivateRoutesRoute,
} as any)
const PrivateRoutesAdvertiserRoute = PrivateRoutesAdvertiserRouteImport.update({
  id: '/advertiser',
  path: '/advertiser',
  getParentRoute: () => PrivateRoutesRoute,
} as any)
const PublicRoutesTiktokOnboardingIndexRoute =
  PublicRoutesTiktokOnboardingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PublicRoutesTiktokOnboardingRoute,
  } as any)
const PublicRoutesSignUpIndexRoute = PublicRoutesSignUpIndexRouteImport.update({
  id: '/sign-up/',
  path: '/sign-up/',
  getParentRoute: () => PublicRoutesRoute,
} as any)
const PrivateRoutesYoutubeCmsIndexRoute =
  PrivateRoutesYoutubeCmsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateRoutesYoutubeCmsRoute,
  } as any)
const PrivateRoutesUserIndexRoute = PrivateRoutesUserIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PrivateRoutesUserRoute,
} as any)
const PrivateRoutesTrendingIndexRoute =
  PrivateRoutesTrendingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateRoutesTrendingRoute,
  } as any)
const PrivateRoutesToolsIndexRoute = PrivateRoutesToolsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PrivateRoutesToolsRoute,
} as any)
const PrivateRoutesTalentAgencyIndexRoute =
  PrivateRoutesTalentAgencyIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateRoutesTalentAgencyRoute,
  } as any)
const PrivateRoutesPromptsIndexRoute =
  PrivateRoutesPromptsIndexRouteImport.update({
    id: '/prompts/',
    path: '/prompts/',
    getParentRoute: () => PrivateRoutesRoute,
  } as any)
const PrivateRoutesPostsInsightIndexRoute =
  PrivateRoutesPostsInsightIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateRoutesPostsInsightRoute,
  } as any)
const PrivateRoutesPartnerIndexRoute =
  PrivateRoutesPartnerIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateRoutesPartnerRoute,
  } as any)
const PrivateRoutesPackageIndexRoute =
  PrivateRoutesPackageIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateRoutesPackageRoute,
  } as any)
const PrivateRoutesMarketplaceIndexRoute =
  PrivateRoutesMarketplaceIndexRouteImport.update({
    id: '/marketplace/',
    path: '/marketplace/',
    getParentRoute: () => PrivateRoutesRoute,
  } as any)
const PrivateRoutesInfluencersIndexRoute =
  PrivateRoutesInfluencersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateRoutesInfluencersRoute,
  } as any)
const PrivateRoutesInfluencerIndexRoute =
  PrivateRoutesInfluencerIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateRoutesInfluencerRoute,
  } as any)
const PrivateRoutesHashtagAnalyticsIndexRoute =
  PrivateRoutesHashtagAnalyticsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateRoutesHashtagAnalyticsRoute,
  } as any)
const PrivateRoutesEngagementIndexRoute =
  PrivateRoutesEngagementIndexRouteImport.update({
    id: '/engagement/',
    path: '/engagement/',
    getParentRoute: () => PrivateRoutesRoute,
  } as any)
const PrivateRoutesAutoManagedIndexRoute =
  PrivateRoutesAutoManagedIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateRoutesAutoManagedRoute,
  } as any)
const PrivateRoutesAnalyticsIndexRoute =
  PrivateRoutesAnalyticsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateRoutesAnalyticsRoute,
  } as any)
const PrivateRoutesAgencyIndexRoute =
  PrivateRoutesAgencyIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateRoutesAgencyRoute,
  } as any)
const PrivateRoutesAdvertiserIndexRoute =
  PrivateRoutesAdvertiserIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateRoutesAdvertiserRoute,
  } as any)
const PrivateRoutesAccessIndexRoute =
  PrivateRoutesAccessIndexRouteImport.update({
    id: '/access/',
    path: '/access/',
    getParentRoute: () => PrivateRoutesRoute,
  } as any)
const PublicRoutesTiktokOnboardingSuccessRoute =
  PublicRoutesTiktokOnboardingSuccessRouteImport.update({
    id: '/success',
    path: '/success',
    getParentRoute: () => PublicRoutesTiktokOnboardingRoute,
  } as any)
const PublicRoutesTiktokOnboardingSelectPlanRoute =
  PublicRoutesTiktokOnboardingSelectPlanRouteImport.update({
    id: '/select-plan',
    path: '/select-plan',
    getParentRoute: () => PublicRoutesTiktokOnboardingRoute,
  } as any)
const PublicRoutesTiktokOnboardingPasswordEnterRoute =
  PublicRoutesTiktokOnboardingPasswordEnterRouteImport.update({
    id: '/password-enter',
    path: '/password-enter',
    getParentRoute: () => PublicRoutesTiktokOnboardingRoute,
  } as any)
const PublicRoutesTiktokOnboardingAdAccountRoute =
  PublicRoutesTiktokOnboardingAdAccountRouteImport.update({
    id: '/ad-account',
    path: '/ad-account',
    getParentRoute: () => PublicRoutesTiktokOnboardingRoute,
  } as any)
const PublicRoutesSignUpSuccessRoute =
  PublicRoutesSignUpSuccessRouteImport.update({
    id: '/sign-up/success',
    path: '/sign-up/success',
    getParentRoute: () => PublicRoutesRoute,
  } as any)
const PublicRoutesMkpReferralRoute = PublicRoutesMkpReferralRouteImport.update({
  id: '/mkp/referral',
  path: '/mkp/referral',
  getParentRoute: () => PublicRoutesRoute,
} as any)
const PublicRoutesEggReferralRoute = PublicRoutesEggReferralRouteImport.update({
  id: '/egg/referral',
  path: '/egg/referral',
  getParentRoute: () => PublicRoutesRoute,
} as any)
const PublicRoutesPasswordPassword_forgotRoute =
  PublicRoutesPasswordPassword_forgotRouteImport.update({
    id: '/_password/password_forgot',
    path: '/password_forgot',
    getParentRoute: () => PublicRoutesRoute,
  } as any)
const PrivateRoutesYoutubeCmsRevenueRoute =
  PrivateRoutesYoutubeCmsRevenueRouteImport.update({
    id: '/revenue',
    path: '/revenue',
    getParentRoute: () => PrivateRoutesYoutubeCmsRoute,
  } as any)
const PrivateRoutesYoutubeCmsInvoicesRoute =
  PrivateRoutesYoutubeCmsInvoicesRouteImport.update({
    id: '/invoices',
    path: '/invoices',
    getParentRoute: () => PrivateRoutesYoutubeCmsRoute,
  } as any)
const PrivateRoutesUserLinkedRoute = PrivateRoutesUserLinkedRouteImport.update({
  id: '/linked',
  path: '/linked',
  getParentRoute: () => PrivateRoutesUserRoute,
} as any)
const PrivateRoutesUserAddRoute = PrivateRoutesUserAddRouteImport.update({
  id: '/add',
  path: '/add',
  getParentRoute: () => PrivateRoutesUserRoute,
} as any)
const PrivateRoutesUserIdRoute = PrivateRoutesUserIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => PrivateRoutesUserRoute,
} as any)
const PrivateRoutesTrendingPostsRoute =
  PrivateRoutesTrendingPostsRouteImport.update({
    id: '/posts',
    path: '/posts',
    getParentRoute: () => PrivateRoutesTrendingRoute,
  } as any)
const PrivateRoutesTrendingInfluencersRoute =
  PrivateRoutesTrendingInfluencersRouteImport.update({
    id: '/influencers',
    path: '/influencers',
    getParentRoute: () => PrivateRoutesTrendingRoute,
  } as any)
const PrivateRoutesToolsVideoCompAiRoute =
  PrivateRoutesToolsVideoCompAiRouteImport.update({
    id: '/video-comp-ai',
    path: '/video-comp-ai',
    getParentRoute: () => PrivateRoutesToolsRoute,
  } as any)
const PrivateRoutesTiktokSubscriptionBillingRoute =
  PrivateRoutesTiktokSubscriptionBillingRouteImport.update({
    id: '/subscription-billing',
    path: '/subscription-billing',
    getParentRoute: () => PrivateRoutesTiktokRoute,
  } as any)
const PrivateRoutesTiktokFailedPaymentRoute =
  PrivateRoutesTiktokFailedPaymentRouteImport.update({
    id: '/failed-payment',
    path: '/failed-payment',
    getParentRoute: () => PrivateRoutesTiktokRoute,
  } as any)
const PrivateRoutesTiktokCampaignsRoute =
  PrivateRoutesTiktokCampaignsRouteImport.update({
    id: '/campaigns',
    path: '/campaigns',
    getParentRoute: () => PrivateRoutesTiktokRoute,
  } as any)
const PrivateRoutesTiktokBudgetAllocationRoute =
  PrivateRoutesTiktokBudgetAllocationRouteImport.update({
    id: '/budget-allocation',
    path: '/budget-allocation',
    getParentRoute: () => PrivateRoutesTiktokRoute,
  } as any)
const PrivateRoutesTiktokAdvertiserDetailsRoute =
  PrivateRoutesTiktokAdvertiserDetailsRouteImport.update({
    id: '/advertiser-details',
    path: '/advertiser-details',
    getParentRoute: () => PrivateRoutesTiktokRoute,
  } as any)
const PrivateRoutesTiktokAdCampaignReportRoute =
  PrivateRoutesTiktokAdCampaignReportRouteImport.update({
    id: '/ad-campaign-report',
    path: '/ad-campaign-report',
    getParentRoute: () => PrivateRoutesTiktokRoute,
  } as any)
const PrivateRoutesTiktokAdAccountsRoute =
  PrivateRoutesTiktokAdAccountsRouteImport.update({
    id: '/ad-accounts',
    path: '/ad-accounts',
    getParentRoute: () => PrivateRoutesTiktokRoute,
  } as any)
const PrivateRoutesTalentAgencyAddRoute =
  PrivateRoutesTalentAgencyAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => PrivateRoutesTalentAgencyRoute,
  } as any)
const PrivateRoutesTalentAgencyIdRoute =
  PrivateRoutesTalentAgencyIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => PrivateRoutesTalentAgencyRoute,
  } as any)
const PrivateRoutesRedirectGoogleAuthRoute =
  PrivateRoutesRedirectGoogleAuthRouteImport.update({
    id: '/redirect/google-auth',
    path: '/redirect/google-auth',
    getParentRoute: () => PrivateRoutesRoute,
  } as any)
const PrivateRoutesPostsInsightIdRoute =
  PrivateRoutesPostsInsightIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => PrivateRoutesPostsInsightRoute,
  } as any)
const PrivateRoutesPartnerIdRoute = PrivateRoutesPartnerIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => PrivateRoutesPartnerRoute,
} as any)
const PrivateRoutesPackageAddRoute = PrivateRoutesPackageAddRouteImport.update({
  id: '/add',
  path: '/add',
  getParentRoute: () => PrivateRoutesPackageRoute,
} as any)
const PrivateRoutesPackageIdRoute = PrivateRoutesPackageIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => PrivateRoutesPackageRoute,
} as any)
const PrivateRoutesMarketplaceReorderRoute =
  PrivateRoutesMarketplaceReorderRouteImport.update({
    id: '/marketplace/reorder',
    path: '/marketplace/reorder',
    getParentRoute: () => PrivateRoutesRoute,
  } as any)
const PrivateRoutesMarketplaceAddRoute =
  PrivateRoutesMarketplaceAddRouteImport.update({
    id: '/marketplace/add',
    path: '/marketplace/add',
    getParentRoute: () => PrivateRoutesRoute,
  } as any)
const PrivateRoutesMarketplaceIdRoute =
  PrivateRoutesMarketplaceIdRouteImport.update({
    id: '/marketplace/$id',
    path: '/marketplace/$id',
    getParentRoute: () => PrivateRoutesRoute,
  } as any)
const PrivateRoutesInfluencersSearchRoute =
  PrivateRoutesInfluencersSearchRouteImport.update({
    id: '/search',
    path: '/search',
    getParentRoute: () => PrivateRoutesInfluencersRoute,
  } as any)
const PrivateRoutesInfluencersProposalRoute =
  PrivateRoutesInfluencersProposalRouteImport.update({
    id: '/proposal',
    path: '/proposal',
    getParentRoute: () => PrivateRoutesInfluencersRoute,
  } as any)
const PrivateRoutesInfluencerAddRoute =
  PrivateRoutesInfluencerAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => PrivateRoutesInfluencerRoute,
  } as any)
const PrivateRoutesInfluencerIdRoute =
  PrivateRoutesInfluencerIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => PrivateRoutesInfluencerRoute,
  } as any)
const PrivateRoutesHashtagAnalyticsTiktokRoute =
  PrivateRoutesHashtagAnalyticsTiktokRouteImport.update({
    id: '/tiktok',
    path: '/tiktok',
    getParentRoute: () => PrivateRoutesHashtagAnalyticsRoute,
  } as any)
const PrivateRoutesHashtagAnalyticsInstagramRoute =
  PrivateRoutesHashtagAnalyticsInstagramRouteImport.update({
    id: '/instagram',
    path: '/instagram',
    getParentRoute: () => PrivateRoutesHashtagAnalyticsRoute,
  } as any)
const PrivateRoutesEngagementAddRoute =
  PrivateRoutesEngagementAddRouteImport.update({
    id: '/engagement/add',
    path: '/engagement/add',
    getParentRoute: () => PrivateRoutesRoute,
  } as any)
const PrivateRoutesEngagementIdRoute =
  PrivateRoutesEngagementIdRouteImport.update({
    id: '/engagement/$id',
    path: '/engagement/$id',
    getParentRoute: () => PrivateRoutesRoute,
  } as any)
const PrivateRoutesAutoManagedIdRoute =
  PrivateRoutesAutoManagedIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => PrivateRoutesAutoManagedRoute,
  } as any)
const PrivateRoutesAnalyticsAddRoute =
  PrivateRoutesAnalyticsAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => PrivateRoutesAnalyticsRoute,
  } as any)
const PrivateRoutesAgencyAddRoute = PrivateRoutesAgencyAddRouteImport.update({
  id: '/add',
  path: '/add',
  getParentRoute: () => PrivateRoutesAgencyRoute,
} as any)
const PrivateRoutesAgencyIdRoute = PrivateRoutesAgencyIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => PrivateRoutesAgencyRoute,
} as any)
const PrivateRoutesAdvertiserAddRoute =
  PrivateRoutesAdvertiserAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => PrivateRoutesAdvertiserRoute,
  } as any)
const PrivateRoutesAdvertiserIdRoute =
  PrivateRoutesAdvertiserIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => PrivateRoutesAdvertiserRoute,
  } as any)
const PrivateRoutesAccessDeclinedRoute =
  PrivateRoutesAccessDeclinedRouteImport.update({
    id: '/access/declined',
    path: '/access/declined',
    getParentRoute: () => PrivateRoutesRoute,
  } as any)
const PrivateRoutesAccessAuthorizedRoute =
  PrivateRoutesAccessAuthorizedRouteImport.update({
    id: '/access/authorized',
    path: '/access/authorized',
    getParentRoute: () => PrivateRoutesRoute,
  } as any)
const PrivateRoutesYoutubeCmsRevenueIndexRoute =
  PrivateRoutesYoutubeCmsRevenueIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateRoutesYoutubeCmsRevenueRoute,
  } as any)
const PrivateRoutesTiktokCampaignsIndexRoute =
  PrivateRoutesTiktokCampaignsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateRoutesTiktokCampaignsRoute,
  } as any)
const PrivateRoutesTiktokAdCampaignReportIndexRoute =
  PrivateRoutesTiktokAdCampaignReportIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateRoutesTiktokAdCampaignReportRoute,
  } as any)
const PrivateRoutesTalentAgencyIdIndexRoute =
  PrivateRoutesTalentAgencyIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateRoutesTalentAgencyIdRoute,
  } as any)
const PrivateRoutesPartnerIdIndexRoute =
  PrivateRoutesPartnerIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateRoutesPartnerIdRoute,
  } as any)
const PrivateRoutesPackageIdIndexRoute =
  PrivateRoutesPackageIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateRoutesPackageIdRoute,
  } as any)
const PrivateRoutesMarketplaceAddIndexRoute =
  PrivateRoutesMarketplaceAddIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateRoutesMarketplaceAddRoute,
  } as any)
const PrivateRoutesMarketplaceIdIndexRoute =
  PrivateRoutesMarketplaceIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateRoutesMarketplaceIdRoute,
  } as any)
const PrivateRoutesInfluencersSearchIndexRoute =
  PrivateRoutesInfluencersSearchIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateRoutesInfluencersSearchRoute,
  } as any)
const PrivateRoutesInfluencerIdIndexRoute =
  PrivateRoutesInfluencerIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateRoutesInfluencerIdRoute,
  } as any)
const PrivateRoutesHashtagAnalyticsTiktokIndexRoute =
  PrivateRoutesHashtagAnalyticsTiktokIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateRoutesHashtagAnalyticsTiktokRoute,
  } as any)
const PrivateRoutesHashtagAnalyticsInstagramIndexRoute =
  PrivateRoutesHashtagAnalyticsInstagramIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateRoutesHashtagAnalyticsInstagramRoute,
  } as any)
const PrivateRoutesEngagementIdIndexRoute =
  PrivateRoutesEngagementIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateRoutesEngagementIdRoute,
  } as any)
const PrivateRoutesAutoManagedIdIndexRoute =
  PrivateRoutesAutoManagedIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateRoutesAutoManagedIdRoute,
  } as any)
const PrivateRoutesAnalyticsBrandAccountIdIndexRoute =
  PrivateRoutesAnalyticsBrandAccountIdIndexRouteImport.update({
    id: '/$brandAccountId/',
    path: '/$brandAccountId/',
    getParentRoute: () => PrivateRoutesAnalyticsRoute,
  } as any)
const PrivateRoutesAgencyIdIndexRoute =
  PrivateRoutesAgencyIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateRoutesAgencyIdRoute,
  } as any)
const PrivateRoutesAdvertiserIdIndexRoute =
  PrivateRoutesAdvertiserIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateRoutesAdvertiserIdRoute,
  } as any)
const PublicRoutesTiktokOnboardingPasswordRegisterTokenRoute =
  PublicRoutesTiktokOnboardingPasswordRegisterTokenRouteImport.update({
    id: '/password-register/$token',
    path: '/password-register/$token',
    getParentRoute: () => PublicRoutesTiktokOnboardingRoute,
  } as any)
const PublicRoutesPasswordPassword_resetTokenRoute =
  PublicRoutesPasswordPassword_resetTokenRouteImport.update({
    id: '/_password/password_reset/$token',
    path: '/password_reset/$token',
    getParentRoute: () => PublicRoutesRoute,
  } as any)
const PublicRoutesPasswordPassword_registerTokenRoute =
  PublicRoutesPasswordPassword_registerTokenRouteImport.update({
    id: '/_password/password_register/$token',
    path: '/password_register/$token',
    getParentRoute: () => PublicRoutesRoute,
  } as any)
const PrivateRoutesYoutubeCmsRevenueConfirmedRoute =
  PrivateRoutesYoutubeCmsRevenueConfirmedRouteImport.update({
    id: '/confirmed',
    path: '/confirmed',
    getParentRoute: () => PrivateRoutesYoutubeCmsRevenueRoute,
  } as any)
const PrivateRoutesYoutubeCmsRevenueCmsChannelIdRoute =
  PrivateRoutesYoutubeCmsRevenueCmsChannelIdRouteImport.update({
    id: '/$cmsChannelId',
    path: '/$cmsChannelId',
    getParentRoute: () => PrivateRoutesYoutubeCmsRevenueRoute,
  } as any)
const PrivateRoutesTiktokCampaignsReviewInfluencersRoute =
  PrivateRoutesTiktokCampaignsReviewInfluencersRouteImport.update({
    id: '/review-influencers',
    path: '/review-influencers',
    getParentRoute: () => PrivateRoutesTiktokCampaignsRoute,
  } as any)
const PrivateRoutesTiktokCampaignsAddRoute =
  PrivateRoutesTiktokCampaignsAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => PrivateRoutesTiktokCampaignsRoute,
  } as any)
const PrivateRoutesTiktokCampaignsIdRoute =
  PrivateRoutesTiktokCampaignsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => PrivateRoutesTiktokCampaignsRoute,
  } as any)
const PrivateRoutesTalentAgencyIdUsersRoute =
  PrivateRoutesTalentAgencyIdUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => PrivateRoutesTalentAgencyIdRoute,
  } as any)
const PrivateRoutesTalentAgencyIdBusinessRoute =
  PrivateRoutesTalentAgencyIdBusinessRouteImport.update({
    id: '/business',
    path: '/business',
    getParentRoute: () => PrivateRoutesTalentAgencyIdRoute,
  } as any)
const PrivateRoutesRedirectTalentSigninProviderRoute =
  PrivateRoutesRedirectTalentSigninProviderRouteImport.update({
    id: '/redirect/talent-signin/$provider',
    path: '/redirect/talent-signin/$provider',
    getParentRoute: () => PrivateRoutesRoute,
  } as any)
const PrivateRoutesRedirectTalentAnalyticsConnectProviderRoute =
  PrivateRoutesRedirectTalentAnalyticsConnectProviderRouteImport.update({
    id: '/redirect/talent-analytics-connect/$provider',
    path: '/redirect/talent-analytics-connect/$provider',
    getParentRoute: () => PrivateRoutesRoute,
  } as any)
const PrivateRoutesRedirectHiddenYoutubeListConnectRoute =
  PrivateRoutesRedirectHiddenYoutubeListConnectRouteImport.update({
    id: '/redirect/hidden/youtube-list-connect',
    path: '/redirect/hidden/youtube-list-connect',
    getParentRoute: () => PrivateRoutesRoute,
  } as any)
const PrivateRoutesRedirectConnectTiktokBusinessRoute =
  PrivateRoutesRedirectConnectTiktokBusinessRouteImport.update({
    id: '/redirect/connect/tiktok-business',
    path: '/redirect/connect/tiktok-business',
    getParentRoute: () => PrivateRoutesRoute,
  } as any)
const PrivateRoutesRedirectAnalyticsSigninProviderRoute =
  PrivateRoutesRedirectAnalyticsSigninProviderRouteImport.update({
    id: '/redirect/analytics-signin/$provider',
    path: '/redirect/analytics-signin/$provider',
    getParentRoute: () => PrivateRoutesRoute,
  } as any)
const PrivateRoutesRedirectAnalyticsListConnectProviderRoute =
  PrivateRoutesRedirectAnalyticsListConnectProviderRouteImport.update({
    id: '/redirect/analytics-list-connect/$provider',
    path: '/redirect/analytics-list-connect/$provider',
    getParentRoute: () => PrivateRoutesRoute,
  } as any)
const PrivateRoutesRedirectAnalyticsConnectProviderRoute =
  PrivateRoutesRedirectAnalyticsConnectProviderRouteImport.update({
    id: '/redirect/analytics-connect/$provider',
    path: '/redirect/analytics-connect/$provider',
    getParentRoute: () => PrivateRoutesRoute,
  } as any)
const PrivateRoutesPostsInsightIdPostIdRoute =
  PrivateRoutesPostsInsightIdPostIdRouteImport.update({
    id: '/$postId',
    path: '/$postId',
    getParentRoute: () => PrivateRoutesPostsInsightIdRoute,
  } as any)
const PrivateRoutesPartnerIdUsersRoute =
  PrivateRoutesPartnerIdUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => PrivateRoutesPartnerIdRoute,
  } as any)
const PrivateRoutesPartnerIdBusinessRoute =
  PrivateRoutesPartnerIdBusinessRouteImport.update({
    id: '/business',
    path: '/business',
    getParentRoute: () => PrivateRoutesPartnerIdRoute,
  } as any)
const PrivateRoutesPackageIdContentRoute =
  PrivateRoutesPackageIdContentRouteImport.update({
    id: '/content',
    path: '/content',
    getParentRoute: () => PrivateRoutesPackageIdRoute,
  } as any)
const PrivateRoutesMarketplaceAddUrlTrackingRoute =
  PrivateRoutesMarketplaceAddUrlTrackingRouteImport.update({
    id: '/url-tracking',
    path: '/url-tracking',
    getParentRoute: () => PrivateRoutesMarketplaceAddRoute,
  } as any)
const PrivateRoutesMarketplaceAddSocialMediaTrackingRoute =
  PrivateRoutesMarketplaceAddSocialMediaTrackingRouteImport.update({
    id: '/social-media-tracking',
    path: '/social-media-tracking',
    getParentRoute: () => PrivateRoutesMarketplaceAddRoute,
  } as any)
const PrivateRoutesMarketplaceAddReferralCodeTrackingRoute =
  PrivateRoutesMarketplaceAddReferralCodeTrackingRouteImport.update({
    id: '/referral-code-tracking',
    path: '/referral-code-tracking',
    getParentRoute: () => PrivateRoutesMarketplaceAddRoute,
  } as any)
const PrivateRoutesMarketplaceIdTrackingReferralCodesRoute =
  PrivateRoutesMarketplaceIdTrackingReferralCodesRouteImport.update({
    id: '/tracking-referral-codes',
    path: '/tracking-referral-codes',
    getParentRoute: () => PrivateRoutesMarketplaceIdRoute,
  } as any)
const PrivateRoutesMarketplaceIdTrackingRoute =
  PrivateRoutesMarketplaceIdTrackingRouteImport.update({
    id: '/tracking',
    path: '/tracking',
    getParentRoute: () => PrivateRoutesMarketplaceIdRoute,
  } as any)
const PrivateRoutesMarketplaceIdReportAffiliateRoute =
  PrivateRoutesMarketplaceIdReportAffiliateRouteImport.update({
    id: '/report-affiliate',
    path: '/report-affiliate',
    getParentRoute: () => PrivateRoutesMarketplaceIdRoute,
  } as any)
const PrivateRoutesMarketplaceIdReportRoute =
  PrivateRoutesMarketplaceIdReportRouteImport.update({
    id: '/report',
    path: '/report',
    getParentRoute: () => PrivateRoutesMarketplaceIdRoute,
  } as any)
const PrivateRoutesMarketplaceIdPostsRoute =
  PrivateRoutesMarketplaceIdPostsRouteImport.update({
    id: '/posts',
    path: '/posts',
    getParentRoute: () => PrivateRoutesMarketplaceIdRoute,
  } as any)
const PrivateRoutesMarketplaceIdJoinedInfluencersRoute =
  PrivateRoutesMarketplaceIdJoinedInfluencersRouteImport.update({
    id: '/joined-influencers',
    path: '/joined-influencers',
    getParentRoute: () => PrivateRoutesMarketplaceIdRoute,
  } as any)
const PrivateRoutesMarketplaceIdInfluencerRoute =
  PrivateRoutesMarketplaceIdInfluencerRouteImport.update({
    id: '/influencer',
    path: '/influencer',
    getParentRoute: () => PrivateRoutesMarketplaceIdRoute,
  } as any)
const PrivateRoutesMarketplaceIdCommissionsRoute =
  PrivateRoutesMarketplaceIdCommissionsRouteImport.update({
    id: '/commissions',
    path: '/commissions',
    getParentRoute: () => PrivateRoutesMarketplaceIdRoute,
  } as any)
const PrivateRoutesMarketplaceIdApplicantRoute =
  PrivateRoutesMarketplaceIdApplicantRouteImport.update({
    id: '/applicant',
    path: '/applicant',
    getParentRoute: () => PrivateRoutesMarketplaceIdRoute,
  } as any)
const PrivateRoutesInfluencersSearchYoutubeRoute =
  PrivateRoutesInfluencersSearchYoutubeRouteImport.update({
    id: '/youtube',
    path: '/youtube',
    getParentRoute: () => PrivateRoutesInfluencersSearchRoute,
  } as any)
const PrivateRoutesInfluencersSearchXhsRoute =
  PrivateRoutesInfluencersSearchXhsRouteImport.update({
    id: '/xhs',
    path: '/xhs',
    getParentRoute: () => PrivateRoutesInfluencersSearchRoute,
  } as any)
const PrivateRoutesInfluencersSearchTwitterRoute =
  PrivateRoutesInfluencersSearchTwitterRouteImport.update({
    id: '/twitter',
    path: '/twitter',
    getParentRoute: () => PrivateRoutesInfluencersSearchRoute,
  } as any)
const PrivateRoutesInfluencersSearchTiktokRoute =
  PrivateRoutesInfluencersSearchTiktokRouteImport.update({
    id: '/tiktok',
    path: '/tiktok',
    getParentRoute: () => PrivateRoutesInfluencersSearchRoute,
  } as any)
const PrivateRoutesInfluencersSearchThreadsRoute =
  PrivateRoutesInfluencersSearchThreadsRouteImport.update({
    id: '/threads',
    path: '/threads',
    getParentRoute: () => PrivateRoutesInfluencersSearchRoute,
  } as any)
const PrivateRoutesInfluencersSearchInstagramRoute =
  PrivateRoutesInfluencersSearchInstagramRouteImport.update({
    id: '/instagram',
    path: '/instagram',
    getParentRoute: () => PrivateRoutesInfluencersSearchRoute,
  } as any)
const PrivateRoutesInfluencersSearchFacebook_pageRoute =
  PrivateRoutesInfluencersSearchFacebook_pageRouteImport.update({
    id: '/facebook_page',
    path: '/facebook_page',
    getParentRoute: () => PrivateRoutesInfluencersSearchRoute,
  } as any)
const PrivateRoutesInfluencersSearchFacebookRoute =
  PrivateRoutesInfluencersSearchFacebookRouteImport.update({
    id: '/facebook',
    path: '/facebook',
    getParentRoute: () => PrivateRoutesInfluencersSearchRoute,
  } as any)
const PrivateRoutesInfluencersSearchDouyinRoute =
  PrivateRoutesInfluencersSearchDouyinRouteImport.update({
    id: '/douyin',
    path: '/douyin',
    getParentRoute: () => PrivateRoutesInfluencersSearchRoute,
  } as any)
const PrivateRoutesInfluencerIdProfileRoute =
  PrivateRoutesInfluencerIdProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => PrivateRoutesInfluencerIdRoute,
  } as any)
const PrivateRoutesHashtagAnalyticsTiktokKeywordRoute =
  PrivateRoutesHashtagAnalyticsTiktokKeywordRouteImport.update({
    id: '/keyword',
    path: '/keyword',
    getParentRoute: () => PrivateRoutesHashtagAnalyticsTiktokRoute,
  } as any)
const PrivateRoutesHashtagAnalyticsTiktokHashtagRoute =
  PrivateRoutesHashtagAnalyticsTiktokHashtagRouteImport.update({
    id: '/hashtag',
    path: '/hashtag',
    getParentRoute: () => PrivateRoutesHashtagAnalyticsTiktokRoute,
  } as any)
const PrivateRoutesHashtagAnalyticsInstagramCountryIdRoute =
  PrivateRoutesHashtagAnalyticsInstagramCountryIdRouteImport.update({
    id: '/$countryId',
    path: '/$countryId',
    getParentRoute: () => PrivateRoutesHashtagAnalyticsInstagramRoute,
  } as any)
const PrivateRoutesEngagementIdTrackingReferralCodesRoute =
  PrivateRoutesEngagementIdTrackingReferralCodesRouteImport.update({
    id: '/tracking-referral-codes',
    path: '/tracking-referral-codes',
    getParentRoute: () => PrivateRoutesEngagementIdRoute,
  } as any)
const PrivateRoutesEngagementIdTrackingRoute =
  PrivateRoutesEngagementIdTrackingRouteImport.update({
    id: '/tracking',
    path: '/tracking',
    getParentRoute: () => PrivateRoutesEngagementIdRoute,
  } as any)
const PrivateRoutesEngagementIdReportRoute =
  PrivateRoutesEngagementIdReportRouteImport.update({
    id: '/report',
    path: '/report',
    getParentRoute: () => PrivateRoutesEngagementIdRoute,
  } as any)
const PrivateRoutesEngagementIdProposalRoute =
  PrivateRoutesEngagementIdProposalRouteImport.update({
    id: '/proposal',
    path: '/proposal',
    getParentRoute: () => PrivateRoutesEngagementIdRoute,
  } as any)
const PrivateRoutesEngagementIdPostsRoute =
  PrivateRoutesEngagementIdPostsRouteImport.update({
    id: '/posts',
    path: '/posts',
    getParentRoute: () => PrivateRoutesEngagementIdRoute,
  } as any)
const PrivateRoutesEngagementIdInfluencerRoute =
  PrivateRoutesEngagementIdInfluencerRouteImport.update({
    id: '/influencer',
    path: '/influencer',
    getParentRoute: () => PrivateRoutesEngagementIdRoute,
  } as any)
const PrivateRoutesAutoManagedIdReportRoute =
  PrivateRoutesAutoManagedIdReportRouteImport.update({
    id: '/report',
    path: '/report',
    getParentRoute: () => PrivateRoutesAutoManagedIdRoute,
  } as any)
const PrivateRoutesAutoManagedIdJoinedInfluencersRoute =
  PrivateRoutesAutoManagedIdJoinedInfluencersRouteImport.update({
    id: '/joined-influencers',
    path: '/joined-influencers',
    getParentRoute: () => PrivateRoutesAutoManagedIdRoute,
  } as any)
const PrivateRoutesAutoManagedIdCommissionsRoute =
  PrivateRoutesAutoManagedIdCommissionsRouteImport.update({
    id: '/commissions',
    path: '/commissions',
    getParentRoute: () => PrivateRoutesAutoManagedIdRoute,
  } as any)
const PrivateRoutesAgencyIdUsersRoute =
  PrivateRoutesAgencyIdUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => PrivateRoutesAgencyIdRoute,
  } as any)
const PrivateRoutesAgencyIdBusinessRoute =
  PrivateRoutesAgencyIdBusinessRouteImport.update({
    id: '/business',
    path: '/business',
    getParentRoute: () => PrivateRoutesAgencyIdRoute,
  } as any)
const PrivateRoutesAdvertiserIdUsersRoute =
  PrivateRoutesAdvertiserIdUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => PrivateRoutesAdvertiserIdRoute,
  } as any)
const PrivateRoutesAdvertiserIdBudgetAllocationRoute =
  PrivateRoutesAdvertiserIdBudgetAllocationRouteImport.update({
    id: '/budget-allocation',
    path: '/budget-allocation',
    getParentRoute: () => PrivateRoutesAdvertiserIdRoute,
  } as any)
const PrivateRoutesTiktokCampaignsIdIndexRoute =
  PrivateRoutesTiktokCampaignsIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateRoutesTiktokCampaignsIdRoute,
  } as any)
const PrivateRoutesTiktokAdCampaignReportIdIndexRoute =
  PrivateRoutesTiktokAdCampaignReportIdIndexRouteImport.update({
    id: '/$id/',
    path: '/$id/',
    getParentRoute: () => PrivateRoutesTiktokAdCampaignReportRoute,
  } as any)
const PrivateRoutesPackageIdContentIndexRoute =
  PrivateRoutesPackageIdContentIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateRoutesPackageIdContentRoute,
  } as any)
const PrivateRoutesMarketplaceAddECommerceIndexRoute =
  PrivateRoutesMarketplaceAddECommerceIndexRouteImport.update({
    id: '/e-commerce/',
    path: '/e-commerce/',
    getParentRoute: () => PrivateRoutesMarketplaceAddRoute,
  } as any)
const PrivateRoutesMarketplaceIdPostsIndexRoute =
  PrivateRoutesMarketplaceIdPostsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateRoutesMarketplaceIdPostsRoute,
  } as any)
const PrivateRoutesInfluencerIdProfileIndexRoute =
  PrivateRoutesInfluencerIdProfileIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateRoutesInfluencerIdProfileRoute,
  } as any)
const PrivateRoutesHashtagAnalyticsTiktokKeywordIndexRoute =
  PrivateRoutesHashtagAnalyticsTiktokKeywordIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateRoutesHashtagAnalyticsTiktokKeywordRoute,
  } as any)
const PrivateRoutesHashtagAnalyticsTiktokHashtagIndexRoute =
  PrivateRoutesHashtagAnalyticsTiktokHashtagIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateRoutesHashtagAnalyticsTiktokHashtagRoute,
  } as any)
const PrivateRoutesEngagementIdPostsIndexRoute =
  PrivateRoutesEngagementIdPostsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateRoutesEngagementIdPostsRoute,
  } as any)
const PrivateRoutesEngagementIdInfluencerIndexRoute =
  PrivateRoutesEngagementIdInfluencerIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateRoutesEngagementIdInfluencerRoute,
  } as any)
const PrivateRoutesTiktokCampaignsIdReportRoute =
  PrivateRoutesTiktokCampaignsIdReportRouteImport.update({
    id: '/report',
    path: '/report',
    getParentRoute: () => PrivateRoutesTiktokCampaignsIdRoute,
  } as any)
const PrivateRoutesTiktokCampaignsIdPostsRoute =
  PrivateRoutesTiktokCampaignsIdPostsRouteImport.update({
    id: '/posts',
    path: '/posts',
    getParentRoute: () => PrivateRoutesTiktokCampaignsIdRoute,
  } as any)
const PrivateRoutesTiktokCampaignsIdInfluencersRoute =
  PrivateRoutesTiktokCampaignsIdInfluencersRouteImport.update({
    id: '/influencers',
    path: '/influencers',
    getParentRoute: () => PrivateRoutesTiktokCampaignsIdRoute,
  } as any)
const PrivateRoutesTiktokAdCampaignReportIdGroupIdRoute =
  PrivateRoutesTiktokAdCampaignReportIdGroupIdRouteImport.update({
    id: '/$id/$groupId',
    path: '/$id/$groupId',
    getParentRoute: () => PrivateRoutesTiktokAdCampaignReportRoute,
  } as any)
const PrivateRoutesPackageIdContentSearchRoute =
  PrivateRoutesPackageIdContentSearchRouteImport.update({
    id: '/search',
    path: '/search',
    getParentRoute: () => PrivateRoutesPackageIdContentRoute,
  } as any)
const PrivateRoutesPackageIdContentListRoute =
  PrivateRoutesPackageIdContentListRouteImport.update({
    id: '/list',
    path: '/list',
    getParentRoute: () => PrivateRoutesPackageIdContentRoute,
  } as any)
const PrivateRoutesMarketplaceAddECommerceAutoMangedCampaignIdRoute =
  PrivateRoutesMarketplaceAddECommerceAutoMangedCampaignIdRouteImport.update({
    id: '/e-commerce/$autoMangedCampaignId',
    path: '/e-commerce/$autoMangedCampaignId',
    getParentRoute: () => PrivateRoutesMarketplaceAddRoute,
  } as any)
const PrivateRoutesMarketplaceIdPostsPostIdRoute =
  PrivateRoutesMarketplaceIdPostsPostIdRouteImport.update({
    id: '/$postId',
    path: '/$postId',
    getParentRoute: () => PrivateRoutesMarketplaceIdPostsRoute,
  } as any)
const PrivateRoutesInfluencerIdProfileCompareRoute =
  PrivateRoutesInfluencerIdProfileCompareRouteImport.update({
    id: '/compare',
    path: '/compare',
    getParentRoute: () => PrivateRoutesInfluencerIdProfileRoute,
  } as any)
const PrivateRoutesInfluencerIdProfileCampaignsRoute =
  PrivateRoutesInfluencerIdProfileCampaignsRouteImport.update({
    id: '/campaigns',
    path: '/campaigns',
    getParentRoute: () => PrivateRoutesInfluencerIdProfileRoute,
  } as any)
const PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_tags_rankingRoute =
  PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_tags_rankingRouteImport.update(
    {
      id: '/$socialMediaAccountId/youtube_tags_ranking',
      path: '/$socialMediaAccountId/youtube_tags_ranking',
      getParentRoute: () => PrivateRoutesInfluencerIdRoute,
    } as any,
  )
const PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_compare_feed_videosRoute =
  PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_compare_feed_videosRouteImport.update(
    {
      id: '/$socialMediaAccountId/youtube_compare_feed_videos',
      path: '/$socialMediaAccountId/youtube_compare_feed_videos',
      getParentRoute: () => PrivateRoutesInfluencerIdRoute,
    } as any,
  )
const PrivateRoutesInfluencerIdSocialMediaAccountIdXhs_video_postsRoute =
  PrivateRoutesInfluencerIdSocialMediaAccountIdXhs_video_postsRouteImport.update(
    {
      id: '/$socialMediaAccountId/xhs_video_posts',
      path: '/$socialMediaAccountId/xhs_video_posts',
      getParentRoute: () => PrivateRoutesInfluencerIdRoute,
    } as any,
  )
const PrivateRoutesInfluencerIdSocialMediaAccountIdXhs_picture_postsRoute =
  PrivateRoutesInfluencerIdSocialMediaAccountIdXhs_picture_postsRouteImport.update(
    {
      id: '/$socialMediaAccountId/xhs_picture_posts',
      path: '/$socialMediaAccountId/xhs_picture_posts',
      getParentRoute: () => PrivateRoutesInfluencerIdRoute,
    } as any,
  )
const PrivateRoutesInfluencerIdSocialMediaAccountIdTwitter_feed_postsRoute =
  PrivateRoutesInfluencerIdSocialMediaAccountIdTwitter_feed_postsRouteImport.update(
    {
      id: '/$socialMediaAccountId/twitter_feed_posts',
      path: '/$socialMediaAccountId/twitter_feed_posts',
      getParentRoute: () => PrivateRoutesInfluencerIdRoute,
    } as any,
  )
const PrivateRoutesInfluencerIdSocialMediaAccountIdSponsored_youtube_feed_postsRoute =
  PrivateRoutesInfluencerIdSocialMediaAccountIdSponsored_youtube_feed_postsRouteImport.update(
    {
      id: '/$socialMediaAccountId/sponsored_youtube_feed_posts',
      path: '/$socialMediaAccountId/sponsored_youtube_feed_posts',
      getParentRoute: () => PrivateRoutesInfluencerIdRoute,
    } as any,
  )
const PrivateRoutesInfluencerIdSocialMediaAccountIdSponsored_feed_postsRoute =
  PrivateRoutesInfluencerIdSocialMediaAccountIdSponsored_feed_postsRouteImport.update(
    {
      id: '/$socialMediaAccountId/sponsored_feed_posts',
      path: '/$socialMediaAccountId/sponsored_feed_posts',
      getParentRoute: () => PrivateRoutesInfluencerIdRoute,
    } as any,
  )
const PrivateRoutesInfluencerIdSocialMediaAccountIdShortsRoute =
  PrivateRoutesInfluencerIdSocialMediaAccountIdShortsRouteImport.update({
    id: '/$socialMediaAccountId/shorts',
    path: '/$socialMediaAccountId/shorts',
    getParentRoute: () => PrivateRoutesInfluencerIdRoute,
  } as any)
const PrivateRoutesInfluencerIdSocialMediaAccountIdScraping_feed_postsRoute =
  PrivateRoutesInfluencerIdSocialMediaAccountIdScraping_feed_postsRouteImport.update(
    {
      id: '/$socialMediaAccountId/scraping_feed_posts',
      path: '/$socialMediaAccountId/scraping_feed_posts',
      getParentRoute: () => PrivateRoutesInfluencerIdRoute,
    } as any,
  )
const PrivateRoutesInfluencerIdSocialMediaAccountIdInstagram_story_postRoute =
  PrivateRoutesInfluencerIdSocialMediaAccountIdInstagram_story_postRouteImport.update(
    {
      id: '/$socialMediaAccountId/instagram_story_post',
      path: '/$socialMediaAccountId/instagram_story_post',
      getParentRoute: () => PrivateRoutesInfluencerIdRoute,
    } as any,
  )
const PrivateRoutesInfluencerIdSocialMediaAccountIdInstagram_reel_postRoute =
  PrivateRoutesInfluencerIdSocialMediaAccountIdInstagram_reel_postRouteImport.update(
    {
      id: '/$socialMediaAccountId/instagram_reel_post',
      path: '/$socialMediaAccountId/instagram_reel_post',
      getParentRoute: () => PrivateRoutesInfluencerIdRoute,
    } as any,
  )
const PrivateRoutesInfluencerIdSocialMediaAccountIdInstagram_feed_postRoute =
  PrivateRoutesInfluencerIdSocialMediaAccountIdInstagram_feed_postRouteImport.update(
    {
      id: '/$socialMediaAccountId/instagram_feed_post',
      path: '/$socialMediaAccountId/instagram_feed_post',
      getParentRoute: () => PrivateRoutesInfluencerIdRoute,
    } as any,
  )
const PrivateRoutesInfluencerIdSocialMediaAccountIdFeed_videosRoute =
  PrivateRoutesInfluencerIdSocialMediaAccountIdFeed_videosRouteImport.update({
    id: '/$socialMediaAccountId/feed_videos',
    path: '/$socialMediaAccountId/feed_videos',
    getParentRoute: () => PrivateRoutesInfluencerIdRoute,
  } as any)
const PrivateRoutesInfluencerIdSocialMediaAccountIdFacebook_feed_postRoute =
  PrivateRoutesInfluencerIdSocialMediaAccountIdFacebook_feed_postRouteImport.update(
    {
      id: '/$socialMediaAccountId/facebook_feed_post',
      path: '/$socialMediaAccountId/facebook_feed_post',
      getParentRoute: () => PrivateRoutesInfluencerIdRoute,
    } as any,
  )
const PrivateRoutesHashtagAnalyticsTiktokKeywordCountryIdRoute =
  PrivateRoutesHashtagAnalyticsTiktokKeywordCountryIdRouteImport.update({
    id: '/$countryId',
    path: '/$countryId',
    getParentRoute: () => PrivateRoutesHashtagAnalyticsTiktokKeywordRoute,
  } as any)
const PrivateRoutesHashtagAnalyticsTiktokHashtagCountryIdRoute =
  PrivateRoutesHashtagAnalyticsTiktokHashtagCountryIdRouteImport.update({
    id: '/$countryId',
    path: '/$countryId',
    getParentRoute: () => PrivateRoutesHashtagAnalyticsTiktokHashtagRoute,
  } as any)
const PrivateRoutesEngagementIdPostsAddRoute =
  PrivateRoutesEngagementIdPostsAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => PrivateRoutesEngagementIdPostsRoute,
  } as any)
const PrivateRoutesEngagementIdPostsPostIdRoute =
  PrivateRoutesEngagementIdPostsPostIdRouteImport.update({
    id: '/$postId',
    path: '/$postId',
    getParentRoute: () => PrivateRoutesEngagementIdPostsRoute,
  } as any)
const PrivateRoutesEngagementIdInfluencerYoutubeRoute =
  PrivateRoutesEngagementIdInfluencerYoutubeRouteImport.update({
    id: '/youtube',
    path: '/youtube',
    getParentRoute: () => PrivateRoutesEngagementIdInfluencerRoute,
  } as any)
const PrivateRoutesEngagementIdInfluencerXhsRoute =
  PrivateRoutesEngagementIdInfluencerXhsRouteImport.update({
    id: '/xhs',
    path: '/xhs',
    getParentRoute: () => PrivateRoutesEngagementIdInfluencerRoute,
  } as any)
const PrivateRoutesEngagementIdInfluencerTwitterRoute =
  PrivateRoutesEngagementIdInfluencerTwitterRouteImport.update({
    id: '/twitter',
    path: '/twitter',
    getParentRoute: () => PrivateRoutesEngagementIdInfluencerRoute,
  } as any)
const PrivateRoutesEngagementIdInfluencerTiktokRoute =
  PrivateRoutesEngagementIdInfluencerTiktokRouteImport.update({
    id: '/tiktok',
    path: '/tiktok',
    getParentRoute: () => PrivateRoutesEngagementIdInfluencerRoute,
  } as any)
const PrivateRoutesEngagementIdInfluencerThreadsRoute =
  PrivateRoutesEngagementIdInfluencerThreadsRouteImport.update({
    id: '/threads',
    path: '/threads',
    getParentRoute: () => PrivateRoutesEngagementIdInfluencerRoute,
  } as any)
const PrivateRoutesEngagementIdInfluencerPostsRoute =
  PrivateRoutesEngagementIdInfluencerPostsRouteImport.update({
    id: '/posts',
    path: '/posts',
    getParentRoute: () => PrivateRoutesEngagementIdInfluencerRoute,
  } as any)
const PrivateRoutesEngagementIdInfluencerPackagesRoute =
  PrivateRoutesEngagementIdInfluencerPackagesRouteImport.update({
    id: '/packages',
    path: '/packages',
    getParentRoute: () => PrivateRoutesEngagementIdInfluencerRoute,
  } as any)
const PrivateRoutesEngagementIdInfluencerInstagramRoute =
  PrivateRoutesEngagementIdInfluencerInstagramRouteImport.update({
    id: '/instagram',
    path: '/instagram',
    getParentRoute: () => PrivateRoutesEngagementIdInfluencerRoute,
  } as any)
const PrivateRoutesEngagementIdInfluencerFacebook_pageRoute =
  PrivateRoutesEngagementIdInfluencerFacebook_pageRouteImport.update({
    id: '/facebook_page',
    path: '/facebook_page',
    getParentRoute: () => PrivateRoutesEngagementIdInfluencerRoute,
  } as any)
const PrivateRoutesEngagementIdInfluencerFacebookRoute =
  PrivateRoutesEngagementIdInfluencerFacebookRouteImport.update({
    id: '/facebook',
    path: '/facebook',
    getParentRoute: () => PrivateRoutesEngagementIdInfluencerRoute,
  } as any)
const PrivateRoutesEngagementIdInfluencerDouyinRoute =
  PrivateRoutesEngagementIdInfluencerDouyinRouteImport.update({
    id: '/douyin',
    path: '/douyin',
    getParentRoute: () => PrivateRoutesEngagementIdInfluencerRoute,
  } as any)
const PrivateRoutesEngagementIdInfluencerCampaignsRoute =
  PrivateRoutesEngagementIdInfluencerCampaignsRouteImport.update({
    id: '/campaigns',
    path: '/campaigns',
    getParentRoute: () => PrivateRoutesEngagementIdInfluencerRoute,
  } as any)
const PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute =
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRouteImport.update(
    {
      id: '/$brandAccountId/$socialMedia/$socialMediaAccountId',
      path: '/$brandAccountId/$socialMedia/$socialMediaAccountId',
      getParentRoute: () => PrivateRoutesAnalyticsRoute,
    } as any,
  )
const PrivateRoutesTiktokCampaignsIdPostsIndexRoute =
  PrivateRoutesTiktokCampaignsIdPostsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateRoutesTiktokCampaignsIdPostsRoute,
  } as any)
const PrivateRoutesPackageIdContentSearchIndexRoute =
  PrivateRoutesPackageIdContentSearchIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateRoutesPackageIdContentSearchRoute,
  } as any)
const PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_compare_feed_videosIndexRoute =
  PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_compare_feed_videosIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_compare_feed_videosRoute,
    } as any,
  )
const PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdIndexRoute =
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute,
    } as any,
  )
const PrivateRoutesTiktokCampaignsIdPostsPostIdRoute =
  PrivateRoutesTiktokCampaignsIdPostsPostIdRouteImport.update({
    id: '/$postId',
    path: '/$postId',
    getParentRoute: () => PrivateRoutesTiktokCampaignsIdPostsRoute,
  } as any)
const PrivateRoutesPackageIdContentSearchYoutubeRoute =
  PrivateRoutesPackageIdContentSearchYoutubeRouteImport.update({
    id: '/youtube',
    path: '/youtube',
    getParentRoute: () => PrivateRoutesPackageIdContentSearchRoute,
  } as any)
const PrivateRoutesPackageIdContentSearchXhsRoute =
  PrivateRoutesPackageIdContentSearchXhsRouteImport.update({
    id: '/xhs',
    path: '/xhs',
    getParentRoute: () => PrivateRoutesPackageIdContentSearchRoute,
  } as any)
const PrivateRoutesPackageIdContentSearchTwitterRoute =
  PrivateRoutesPackageIdContentSearchTwitterRouteImport.update({
    id: '/twitter',
    path: '/twitter',
    getParentRoute: () => PrivateRoutesPackageIdContentSearchRoute,
  } as any)
const PrivateRoutesPackageIdContentSearchTiktokRoute =
  PrivateRoutesPackageIdContentSearchTiktokRouteImport.update({
    id: '/tiktok',
    path: '/tiktok',
    getParentRoute: () => PrivateRoutesPackageIdContentSearchRoute,
  } as any)
const PrivateRoutesPackageIdContentSearchThreadsRoute =
  PrivateRoutesPackageIdContentSearchThreadsRouteImport.update({
    id: '/threads',
    path: '/threads',
    getParentRoute: () => PrivateRoutesPackageIdContentSearchRoute,
  } as any)
const PrivateRoutesPackageIdContentSearchInstagramRoute =
  PrivateRoutesPackageIdContentSearchInstagramRouteImport.update({
    id: '/instagram',
    path: '/instagram',
    getParentRoute: () => PrivateRoutesPackageIdContentSearchRoute,
  } as any)
const PrivateRoutesPackageIdContentSearchFacebook_pageRoute =
  PrivateRoutesPackageIdContentSearchFacebook_pageRouteImport.update({
    id: '/facebook_page',
    path: '/facebook_page',
    getParentRoute: () => PrivateRoutesPackageIdContentSearchRoute,
  } as any)
const PrivateRoutesPackageIdContentSearchFacebookRoute =
  PrivateRoutesPackageIdContentSearchFacebookRouteImport.update({
    id: '/facebook',
    path: '/facebook',
    getParentRoute: () => PrivateRoutesPackageIdContentSearchRoute,
  } as any)
const PrivateRoutesPackageIdContentSearchDouyinRoute =
  PrivateRoutesPackageIdContentSearchDouyinRouteImport.update({
    id: '/douyin',
    path: '/douyin',
    getParentRoute: () => PrivateRoutesPackageIdContentSearchRoute,
  } as any)
const PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_compare_feed_videosCompareIdRoute =
  PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_compare_feed_videosCompareIdRouteImport.update(
    {
      id: '/$compareId',
      path: '/$compareId',
      getParentRoute: () =>
        PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_compare_feed_videosRoute,
    } as any,
  )
const PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdUgcRoute =
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdUgcRouteImport.update(
    {
      id: '/ugc',
      path: '/ugc',
      getParentRoute: () =>
        PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute,
    } as any,
  )
const PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdTrendRoute =
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdTrendRouteImport.update(
    {
      id: '/trend',
      path: '/trend',
      getParentRoute: () =>
        PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute,
    } as any,
  )
const PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdHashtagRoute =
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdHashtagRouteImport.update(
    {
      id: '/hashtag',
      path: '/hashtag',
      getParentRoute: () =>
        PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute,
    } as any,
  )
const PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionIndexRoute =
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionIndexRouteImport.update(
    {
      id: '/interaction/',
      path: '/interaction/',
      getParentRoute: () =>
        PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute,
    } as any,
  )
const PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardIndexRoute =
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardIndexRouteImport.update(
    {
      id: '/dashboard/',
      path: '/dashboard/',
      getParentRoute: () =>
        PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute,
    } as any,
  )
const PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdCompareIndexRoute =
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdCompareIndexRouteImport.update(
    {
      id: '/compare/',
      path: '/compare/',
      getParentRoute: () =>
        PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute,
    } as any,
  )
const PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionTagged_postsRoute =
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionTagged_postsRouteImport.update(
    {
      id: '/interaction/tagged_posts',
      path: '/interaction/tagged_posts',
      getParentRoute: () =>
        PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute,
    } as any,
  )
const PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionMentioned_postsRoute =
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionMentioned_postsRouteImport.update(
    {
      id: '/interaction/mentioned_posts',
      path: '/interaction/mentioned_posts',
      getParentRoute: () =>
        PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute,
    } as any,
  )
const PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionBrandAmbassadorsRoute =
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionBrandAmbassadorsRouteImport.update(
    {
      id: '/interaction/brand-ambassadors',
      path: '/interaction/brand-ambassadors',
      getParentRoute: () =>
        PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute,
    } as any,
  )
const PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardYoutube_commentsRoute =
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardYoutube_commentsRouteImport.update(
    {
      id: '/dashboard/youtube_comments',
      path: '/dashboard/youtube_comments',
      getParentRoute: () =>
        PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute,
    } as any,
  )
const PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardTwitter_feed_postsRoute =
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardTwitter_feed_postsRouteImport.update(
    {
      id: '/dashboard/twitter_feed_posts',
      path: '/dashboard/twitter_feed_posts',
      getParentRoute: () =>
        PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute,
    } as any,
  )
const PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardTag_ranking_listRoute =
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardTag_ranking_listRouteImport.update(
    {
      id: '/dashboard/tag_ranking_list',
      path: '/dashboard/tag_ranking_list',
      getParentRoute: () =>
        PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute,
    } as any,
  )
const PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardShortsRoute =
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardShortsRouteImport.update(
    {
      id: '/dashboard/shorts',
      path: '/dashboard/shorts',
      getParentRoute: () =>
        PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute,
    } as any,
  )
const PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_story_postRoute =
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_story_postRouteImport.update(
    {
      id: '/dashboard/instagram_story_post',
      path: '/dashboard/instagram_story_post',
      getParentRoute: () =>
        PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute,
    } as any,
  )
const PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_reel_postRoute =
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_reel_postRouteImport.update(
    {
      id: '/dashboard/instagram_reel_post',
      path: '/dashboard/instagram_reel_post',
      getParentRoute: () =>
        PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute,
    } as any,
  )
const PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_feed_postRoute =
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_feed_postRouteImport.update(
    {
      id: '/dashboard/instagram_feed_post',
      path: '/dashboard/instagram_feed_post',
      getParentRoute: () =>
        PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute,
    } as any,
  )
const PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_commentsRoute =
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_commentsRouteImport.update(
    {
      id: '/dashboard/instagram_comments',
      path: '/dashboard/instagram_comments',
      getParentRoute: () =>
        PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute,
    } as any,
  )
const PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardFeed_videosRoute =
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardFeed_videosRouteImport.update(
    {
      id: '/dashboard/feed_videos',
      path: '/dashboard/feed_videos',
      getParentRoute: () =>
        PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute,
    } as any,
  )
const PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardFacebook_feed_postRoute =
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardFacebook_feed_postRouteImport.update(
    {
      id: '/dashboard/facebook_feed_post',
      path: '/dashboard/facebook_feed_post',
      getParentRoute: () =>
        PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute,
    } as any,
  )
const PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdCompareYoutube_compare_feed_videosRoute =
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdCompareYoutube_compare_feed_videosRouteImport.update(
    {
      id: '/compare/youtube_compare_feed_videos',
      path: '/compare/youtube_compare_feed_videos',
      getParentRoute: () =>
        PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute,
    } as any,
  )
const PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdCompareInstagram_compare_feed_postRoute =
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdCompareInstagram_compare_feed_postRouteImport.update(
    {
      id: '/compare/instagram_compare_feed_post',
      path: '/compare/instagram_compare_feed_post',
      getParentRoute: () =>
        PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/not-found': typeof NotFoundRoute
  '/advertiser': typeof PrivateRoutesAdvertiserRouteWithChildren
  '/agency': typeof PrivateRoutesAgencyRouteWithChildren
  '/analytics': typeof PrivateRoutesAnalyticsRouteWithChildren
  '/asset-preview': typeof PrivateRoutesAssetPreviewRoute
  '/auto-managed': typeof PrivateRoutesAutoManagedRouteWithChildren
  '/campaign-posts-discovery': typeof PrivateRoutesCampaignPostsDiscoveryRoute
  '/hashtag-analytics': typeof PrivateRoutesHashtagAnalyticsRouteWithChildren
  '/influencer': typeof PrivateRoutesInfluencerRouteWithChildren
  '/influencers': typeof PrivateRoutesInfluencersRouteWithChildren
  '/package': typeof PrivateRoutesPackageRouteWithChildren
  '/partner': typeof PrivateRoutesPartnerRouteWithChildren
  '/payments': typeof PrivateRoutesPaymentsRoute
  '/posts': typeof PrivateRoutesPostsRoute
  '/posts-insight': typeof PrivateRoutesPostsInsightRouteWithChildren
  '/report': typeof PrivateRoutesReportRoute
  '/settings': typeof PrivateRoutesSettingsRoute
  '/talent-agency': typeof PrivateRoutesTalentAgencyRouteWithChildren
  '/tiktok': typeof PrivateRoutesTiktokRouteWithChildren
  '/tools': typeof PrivateRoutesToolsRouteWithChildren
  '/trending': typeof PrivateRoutesTrendingRouteWithChildren
  '/user': typeof PrivateRoutesUserRouteWithChildren
  '/user-settings': typeof PrivateRoutesUserSettingsRoute
  '/youtube-cms': typeof PrivateRoutesYoutubeCmsRouteWithChildren
  '/privacy': typeof PublicRoutesPrivacyRoute
  '/redirect_to': typeof PublicRoutesRedirect_toRoute
  '/sign-in': typeof PublicRoutesSignInRoute
  '/terms': typeof PublicRoutesTermsRoute
  '/terms-combined': typeof PublicRoutesTermsCombinedRoute
  '/tiktok-onboarding': typeof PublicRoutesTiktokOnboardingRouteWithChildren
  '/access/authorized': typeof PrivateRoutesAccessAuthorizedRoute
  '/access/declined': typeof PrivateRoutesAccessDeclinedRoute
  '/advertiser/$id': typeof PrivateRoutesAdvertiserIdRouteWithChildren
  '/advertiser/add': typeof PrivateRoutesAdvertiserAddRoute
  '/agency/$id': typeof PrivateRoutesAgencyIdRouteWithChildren
  '/agency/add': typeof PrivateRoutesAgencyAddRoute
  '/analytics/add': typeof PrivateRoutesAnalyticsAddRoute
  '/auto-managed/$id': typeof PrivateRoutesAutoManagedIdRouteWithChildren
  '/engagement/$id': typeof PrivateRoutesEngagementIdRouteWithChildren
  '/engagement/add': typeof PrivateRoutesEngagementAddRoute
  '/hashtag-analytics/instagram': typeof PrivateRoutesHashtagAnalyticsInstagramRouteWithChildren
  '/hashtag-analytics/tiktok': typeof PrivateRoutesHashtagAnalyticsTiktokRouteWithChildren
  '/influencer/$id': typeof PrivateRoutesInfluencerIdRouteWithChildren
  '/influencer/add': typeof PrivateRoutesInfluencerAddRoute
  '/influencers/proposal': typeof PrivateRoutesInfluencersProposalRoute
  '/influencers/search': typeof PrivateRoutesInfluencersSearchRouteWithChildren
  '/marketplace/$id': typeof PrivateRoutesMarketplaceIdRouteWithChildren
  '/marketplace/add': typeof PrivateRoutesMarketplaceAddRouteWithChildren
  '/marketplace/reorder': typeof PrivateRoutesMarketplaceReorderRoute
  '/package/$id': typeof PrivateRoutesPackageIdRouteWithChildren
  '/package/add': typeof PrivateRoutesPackageAddRoute
  '/partner/$id': typeof PrivateRoutesPartnerIdRouteWithChildren
  '/posts-insight/$id': typeof PrivateRoutesPostsInsightIdRouteWithChildren
  '/redirect/google-auth': typeof PrivateRoutesRedirectGoogleAuthRoute
  '/talent-agency/$id': typeof PrivateRoutesTalentAgencyIdRouteWithChildren
  '/talent-agency/add': typeof PrivateRoutesTalentAgencyAddRoute
  '/tiktok/ad-accounts': typeof PrivateRoutesTiktokAdAccountsRoute
  '/tiktok/ad-campaign-report': typeof PrivateRoutesTiktokAdCampaignReportRouteWithChildren
  '/tiktok/advertiser-details': typeof PrivateRoutesTiktokAdvertiserDetailsRoute
  '/tiktok/budget-allocation': typeof PrivateRoutesTiktokBudgetAllocationRoute
  '/tiktok/campaigns': typeof PrivateRoutesTiktokCampaignsRouteWithChildren
  '/tiktok/failed-payment': typeof PrivateRoutesTiktokFailedPaymentRoute
  '/tiktok/subscription-billing': typeof PrivateRoutesTiktokSubscriptionBillingRoute
  '/tools/video-comp-ai': typeof PrivateRoutesToolsVideoCompAiRoute
  '/trending/influencers': typeof PrivateRoutesTrendingInfluencersRoute
  '/trending/posts': typeof PrivateRoutesTrendingPostsRoute
  '/user/$id': typeof PrivateRoutesUserIdRoute
  '/user/add': typeof PrivateRoutesUserAddRoute
  '/user/linked': typeof PrivateRoutesUserLinkedRoute
  '/youtube-cms/invoices': typeof PrivateRoutesYoutubeCmsInvoicesRoute
  '/youtube-cms/revenue': typeof PrivateRoutesYoutubeCmsRevenueRouteWithChildren
  '/password_forgot': typeof PublicRoutesPasswordPassword_forgotRoute
  '/egg/referral': typeof PublicRoutesEggReferralRoute
  '/mkp/referral': typeof PublicRoutesMkpReferralRoute
  '/sign-up/success': typeof PublicRoutesSignUpSuccessRoute
  '/tiktok-onboarding/ad-account': typeof PublicRoutesTiktokOnboardingAdAccountRoute
  '/tiktok-onboarding/password-enter': typeof PublicRoutesTiktokOnboardingPasswordEnterRoute
  '/tiktok-onboarding/select-plan': typeof PublicRoutesTiktokOnboardingSelectPlanRoute
  '/tiktok-onboarding/success': typeof PublicRoutesTiktokOnboardingSuccessRoute
  '/access': typeof PrivateRoutesAccessIndexRoute
  '/advertiser/': typeof PrivateRoutesAdvertiserIndexRoute
  '/agency/': typeof PrivateRoutesAgencyIndexRoute
  '/analytics/': typeof PrivateRoutesAnalyticsIndexRoute
  '/auto-managed/': typeof PrivateRoutesAutoManagedIndexRoute
  '/engagement': typeof PrivateRoutesEngagementIndexRoute
  '/hashtag-analytics/': typeof PrivateRoutesHashtagAnalyticsIndexRoute
  '/influencer/': typeof PrivateRoutesInfluencerIndexRoute
  '/influencers/': typeof PrivateRoutesInfluencersIndexRoute
  '/marketplace': typeof PrivateRoutesMarketplaceIndexRoute
  '/package/': typeof PrivateRoutesPackageIndexRoute
  '/partner/': typeof PrivateRoutesPartnerIndexRoute
  '/posts-insight/': typeof PrivateRoutesPostsInsightIndexRoute
  '/prompts': typeof PrivateRoutesPromptsIndexRoute
  '/talent-agency/': typeof PrivateRoutesTalentAgencyIndexRoute
  '/tools/': typeof PrivateRoutesToolsIndexRoute
  '/trending/': typeof PrivateRoutesTrendingIndexRoute
  '/user/': typeof PrivateRoutesUserIndexRoute
  '/youtube-cms/': typeof PrivateRoutesYoutubeCmsIndexRoute
  '/sign-up': typeof PublicRoutesSignUpIndexRoute
  '/tiktok-onboarding/': typeof PublicRoutesTiktokOnboardingIndexRoute
  '/advertiser/$id/budget-allocation': typeof PrivateRoutesAdvertiserIdBudgetAllocationRoute
  '/advertiser/$id/users': typeof PrivateRoutesAdvertiserIdUsersRoute
  '/agency/$id/business': typeof PrivateRoutesAgencyIdBusinessRoute
  '/agency/$id/users': typeof PrivateRoutesAgencyIdUsersRoute
  '/auto-managed/$id/commissions': typeof PrivateRoutesAutoManagedIdCommissionsRoute
  '/auto-managed/$id/joined-influencers': typeof PrivateRoutesAutoManagedIdJoinedInfluencersRoute
  '/auto-managed/$id/report': typeof PrivateRoutesAutoManagedIdReportRoute
  '/engagement/$id/influencer': typeof PrivateRoutesEngagementIdInfluencerRouteWithChildren
  '/engagement/$id/posts': typeof PrivateRoutesEngagementIdPostsRouteWithChildren
  '/engagement/$id/proposal': typeof PrivateRoutesEngagementIdProposalRoute
  '/engagement/$id/report': typeof PrivateRoutesEngagementIdReportRoute
  '/engagement/$id/tracking': typeof PrivateRoutesEngagementIdTrackingRoute
  '/engagement/$id/tracking-referral-codes': typeof PrivateRoutesEngagementIdTrackingReferralCodesRoute
  '/hashtag-analytics/instagram/$countryId': typeof PrivateRoutesHashtagAnalyticsInstagramCountryIdRoute
  '/hashtag-analytics/tiktok/hashtag': typeof PrivateRoutesHashtagAnalyticsTiktokHashtagRouteWithChildren
  '/hashtag-analytics/tiktok/keyword': typeof PrivateRoutesHashtagAnalyticsTiktokKeywordRouteWithChildren
  '/influencer/$id/profile': typeof PrivateRoutesInfluencerIdProfileRouteWithChildren
  '/influencers/search/douyin': typeof PrivateRoutesInfluencersSearchDouyinRoute
  '/influencers/search/facebook': typeof PrivateRoutesInfluencersSearchFacebookRoute
  '/influencers/search/facebook_page': typeof PrivateRoutesInfluencersSearchFacebook_pageRoute
  '/influencers/search/instagram': typeof PrivateRoutesInfluencersSearchInstagramRoute
  '/influencers/search/threads': typeof PrivateRoutesInfluencersSearchThreadsRoute
  '/influencers/search/tiktok': typeof PrivateRoutesInfluencersSearchTiktokRoute
  '/influencers/search/twitter': typeof PrivateRoutesInfluencersSearchTwitterRoute
  '/influencers/search/xhs': typeof PrivateRoutesInfluencersSearchXhsRoute
  '/influencers/search/youtube': typeof PrivateRoutesInfluencersSearchYoutubeRoute
  '/marketplace/$id/applicant': typeof PrivateRoutesMarketplaceIdApplicantRoute
  '/marketplace/$id/commissions': typeof PrivateRoutesMarketplaceIdCommissionsRoute
  '/marketplace/$id/influencer': typeof PrivateRoutesMarketplaceIdInfluencerRoute
  '/marketplace/$id/joined-influencers': typeof PrivateRoutesMarketplaceIdJoinedInfluencersRoute
  '/marketplace/$id/posts': typeof PrivateRoutesMarketplaceIdPostsRouteWithChildren
  '/marketplace/$id/report': typeof PrivateRoutesMarketplaceIdReportRoute
  '/marketplace/$id/report-affiliate': typeof PrivateRoutesMarketplaceIdReportAffiliateRoute
  '/marketplace/$id/tracking': typeof PrivateRoutesMarketplaceIdTrackingRoute
  '/marketplace/$id/tracking-referral-codes': typeof PrivateRoutesMarketplaceIdTrackingReferralCodesRoute
  '/marketplace/add/referral-code-tracking': typeof PrivateRoutesMarketplaceAddReferralCodeTrackingRoute
  '/marketplace/add/social-media-tracking': typeof PrivateRoutesMarketplaceAddSocialMediaTrackingRoute
  '/marketplace/add/url-tracking': typeof PrivateRoutesMarketplaceAddUrlTrackingRoute
  '/package/$id/content': typeof PrivateRoutesPackageIdContentRouteWithChildren
  '/partner/$id/business': typeof PrivateRoutesPartnerIdBusinessRoute
  '/partner/$id/users': typeof PrivateRoutesPartnerIdUsersRoute
  '/posts-insight/$id/$postId': typeof PrivateRoutesPostsInsightIdPostIdRoute
  '/redirect/analytics-connect/$provider': typeof PrivateRoutesRedirectAnalyticsConnectProviderRoute
  '/redirect/analytics-list-connect/$provider': typeof PrivateRoutesRedirectAnalyticsListConnectProviderRoute
  '/redirect/analytics-signin/$provider': typeof PrivateRoutesRedirectAnalyticsSigninProviderRoute
  '/redirect/connect/tiktok-business': typeof PrivateRoutesRedirectConnectTiktokBusinessRoute
  '/redirect/hidden/youtube-list-connect': typeof PrivateRoutesRedirectHiddenYoutubeListConnectRoute
  '/redirect/talent-analytics-connect/$provider': typeof PrivateRoutesRedirectTalentAnalyticsConnectProviderRoute
  '/redirect/talent-signin/$provider': typeof PrivateRoutesRedirectTalentSigninProviderRoute
  '/talent-agency/$id/business': typeof PrivateRoutesTalentAgencyIdBusinessRoute
  '/talent-agency/$id/users': typeof PrivateRoutesTalentAgencyIdUsersRoute
  '/tiktok/campaigns/$id': typeof PrivateRoutesTiktokCampaignsIdRouteWithChildren
  '/tiktok/campaigns/add': typeof PrivateRoutesTiktokCampaignsAddRoute
  '/tiktok/campaigns/review-influencers': typeof PrivateRoutesTiktokCampaignsReviewInfluencersRoute
  '/youtube-cms/revenue/$cmsChannelId': typeof PrivateRoutesYoutubeCmsRevenueCmsChannelIdRoute
  '/youtube-cms/revenue/confirmed': typeof PrivateRoutesYoutubeCmsRevenueConfirmedRoute
  '/password_register/$token': typeof PublicRoutesPasswordPassword_registerTokenRoute
  '/password_reset/$token': typeof PublicRoutesPasswordPassword_resetTokenRoute
  '/tiktok-onboarding/password-register/$token': typeof PublicRoutesTiktokOnboardingPasswordRegisterTokenRoute
  '/advertiser/$id/': typeof PrivateRoutesAdvertiserIdIndexRoute
  '/agency/$id/': typeof PrivateRoutesAgencyIdIndexRoute
  '/analytics/$brandAccountId': typeof PrivateRoutesAnalyticsBrandAccountIdIndexRoute
  '/auto-managed/$id/': typeof PrivateRoutesAutoManagedIdIndexRoute
  '/engagement/$id/': typeof PrivateRoutesEngagementIdIndexRoute
  '/hashtag-analytics/instagram/': typeof PrivateRoutesHashtagAnalyticsInstagramIndexRoute
  '/hashtag-analytics/tiktok/': typeof PrivateRoutesHashtagAnalyticsTiktokIndexRoute
  '/influencer/$id/': typeof PrivateRoutesInfluencerIdIndexRoute
  '/influencers/search/': typeof PrivateRoutesInfluencersSearchIndexRoute
  '/marketplace/$id/': typeof PrivateRoutesMarketplaceIdIndexRoute
  '/marketplace/add/': typeof PrivateRoutesMarketplaceAddIndexRoute
  '/package/$id/': typeof PrivateRoutesPackageIdIndexRoute
  '/partner/$id/': typeof PrivateRoutesPartnerIdIndexRoute
  '/talent-agency/$id/': typeof PrivateRoutesTalentAgencyIdIndexRoute
  '/tiktok/ad-campaign-report/': typeof PrivateRoutesTiktokAdCampaignReportIndexRoute
  '/tiktok/campaigns/': typeof PrivateRoutesTiktokCampaignsIndexRoute
  '/youtube-cms/revenue/': typeof PrivateRoutesYoutubeCmsRevenueIndexRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRouteWithChildren
  '/engagement/$id/influencer/campaigns': typeof PrivateRoutesEngagementIdInfluencerCampaignsRoute
  '/engagement/$id/influencer/douyin': typeof PrivateRoutesEngagementIdInfluencerDouyinRoute
  '/engagement/$id/influencer/facebook': typeof PrivateRoutesEngagementIdInfluencerFacebookRoute
  '/engagement/$id/influencer/facebook_page': typeof PrivateRoutesEngagementIdInfluencerFacebook_pageRoute
  '/engagement/$id/influencer/instagram': typeof PrivateRoutesEngagementIdInfluencerInstagramRoute
  '/engagement/$id/influencer/packages': typeof PrivateRoutesEngagementIdInfluencerPackagesRoute
  '/engagement/$id/influencer/posts': typeof PrivateRoutesEngagementIdInfluencerPostsRoute
  '/engagement/$id/influencer/threads': typeof PrivateRoutesEngagementIdInfluencerThreadsRoute
  '/engagement/$id/influencer/tiktok': typeof PrivateRoutesEngagementIdInfluencerTiktokRoute
  '/engagement/$id/influencer/twitter': typeof PrivateRoutesEngagementIdInfluencerTwitterRoute
  '/engagement/$id/influencer/xhs': typeof PrivateRoutesEngagementIdInfluencerXhsRoute
  '/engagement/$id/influencer/youtube': typeof PrivateRoutesEngagementIdInfluencerYoutubeRoute
  '/engagement/$id/posts/$postId': typeof PrivateRoutesEngagementIdPostsPostIdRoute
  '/engagement/$id/posts/add': typeof PrivateRoutesEngagementIdPostsAddRoute
  '/hashtag-analytics/tiktok/hashtag/$countryId': typeof PrivateRoutesHashtagAnalyticsTiktokHashtagCountryIdRoute
  '/hashtag-analytics/tiktok/keyword/$countryId': typeof PrivateRoutesHashtagAnalyticsTiktokKeywordCountryIdRoute
  '/influencer/$id/$socialMediaAccountId/facebook_feed_post': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdFacebook_feed_postRoute
  '/influencer/$id/$socialMediaAccountId/feed_videos': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdFeed_videosRoute
  '/influencer/$id/$socialMediaAccountId/instagram_feed_post': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdInstagram_feed_postRoute
  '/influencer/$id/$socialMediaAccountId/instagram_reel_post': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdInstagram_reel_postRoute
  '/influencer/$id/$socialMediaAccountId/instagram_story_post': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdInstagram_story_postRoute
  '/influencer/$id/$socialMediaAccountId/scraping_feed_posts': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdScraping_feed_postsRoute
  '/influencer/$id/$socialMediaAccountId/shorts': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdShortsRoute
  '/influencer/$id/$socialMediaAccountId/sponsored_feed_posts': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdSponsored_feed_postsRoute
  '/influencer/$id/$socialMediaAccountId/sponsored_youtube_feed_posts': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdSponsored_youtube_feed_postsRoute
  '/influencer/$id/$socialMediaAccountId/twitter_feed_posts': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdTwitter_feed_postsRoute
  '/influencer/$id/$socialMediaAccountId/xhs_picture_posts': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdXhs_picture_postsRoute
  '/influencer/$id/$socialMediaAccountId/xhs_video_posts': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdXhs_video_postsRoute
  '/influencer/$id/$socialMediaAccountId/youtube_compare_feed_videos': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_compare_feed_videosRouteWithChildren
  '/influencer/$id/$socialMediaAccountId/youtube_tags_ranking': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_tags_rankingRoute
  '/influencer/$id/profile/campaigns': typeof PrivateRoutesInfluencerIdProfileCampaignsRoute
  '/influencer/$id/profile/compare': typeof PrivateRoutesInfluencerIdProfileCompareRoute
  '/marketplace/$id/posts/$postId': typeof PrivateRoutesMarketplaceIdPostsPostIdRoute
  '/marketplace/add/e-commerce/$autoMangedCampaignId': typeof PrivateRoutesMarketplaceAddECommerceAutoMangedCampaignIdRoute
  '/package/$id/content/list': typeof PrivateRoutesPackageIdContentListRoute
  '/package/$id/content/search': typeof PrivateRoutesPackageIdContentSearchRouteWithChildren
  '/tiktok/ad-campaign-report/$id/$groupId': typeof PrivateRoutesTiktokAdCampaignReportIdGroupIdRoute
  '/tiktok/campaigns/$id/influencers': typeof PrivateRoutesTiktokCampaignsIdInfluencersRoute
  '/tiktok/campaigns/$id/posts': typeof PrivateRoutesTiktokCampaignsIdPostsRouteWithChildren
  '/tiktok/campaigns/$id/report': typeof PrivateRoutesTiktokCampaignsIdReportRoute
  '/engagement/$id/influencer/': typeof PrivateRoutesEngagementIdInfluencerIndexRoute
  '/engagement/$id/posts/': typeof PrivateRoutesEngagementIdPostsIndexRoute
  '/hashtag-analytics/tiktok/hashtag/': typeof PrivateRoutesHashtagAnalyticsTiktokHashtagIndexRoute
  '/hashtag-analytics/tiktok/keyword/': typeof PrivateRoutesHashtagAnalyticsTiktokKeywordIndexRoute
  '/influencer/$id/profile/': typeof PrivateRoutesInfluencerIdProfileIndexRoute
  '/marketplace/$id/posts/': typeof PrivateRoutesMarketplaceIdPostsIndexRoute
  '/marketplace/add/e-commerce': typeof PrivateRoutesMarketplaceAddECommerceIndexRoute
  '/package/$id/content/': typeof PrivateRoutesPackageIdContentIndexRoute
  '/tiktok/ad-campaign-report/$id': typeof PrivateRoutesTiktokAdCampaignReportIdIndexRoute
  '/tiktok/campaigns/$id/': typeof PrivateRoutesTiktokCampaignsIdIndexRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/hashtag': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdHashtagRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/trend': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdTrendRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/ugc': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdUgcRoute
  '/influencer/$id/$socialMediaAccountId/youtube_compare_feed_videos/$compareId': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_compare_feed_videosCompareIdRoute
  '/package/$id/content/search/douyin': typeof PrivateRoutesPackageIdContentSearchDouyinRoute
  '/package/$id/content/search/facebook': typeof PrivateRoutesPackageIdContentSearchFacebookRoute
  '/package/$id/content/search/facebook_page': typeof PrivateRoutesPackageIdContentSearchFacebook_pageRoute
  '/package/$id/content/search/instagram': typeof PrivateRoutesPackageIdContentSearchInstagramRoute
  '/package/$id/content/search/threads': typeof PrivateRoutesPackageIdContentSearchThreadsRoute
  '/package/$id/content/search/tiktok': typeof PrivateRoutesPackageIdContentSearchTiktokRoute
  '/package/$id/content/search/twitter': typeof PrivateRoutesPackageIdContentSearchTwitterRoute
  '/package/$id/content/search/xhs': typeof PrivateRoutesPackageIdContentSearchXhsRoute
  '/package/$id/content/search/youtube': typeof PrivateRoutesPackageIdContentSearchYoutubeRoute
  '/tiktok/campaigns/$id/posts/$postId': typeof PrivateRoutesTiktokCampaignsIdPostsPostIdRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdIndexRoute
  '/influencer/$id/$socialMediaAccountId/youtube_compare_feed_videos/': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_compare_feed_videosIndexRoute
  '/package/$id/content/search/': typeof PrivateRoutesPackageIdContentSearchIndexRoute
  '/tiktok/campaigns/$id/posts/': typeof PrivateRoutesTiktokCampaignsIdPostsIndexRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/compare/instagram_compare_feed_post': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdCompareInstagram_compare_feed_postRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/compare/youtube_compare_feed_videos': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdCompareYoutube_compare_feed_videosRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/facebook_feed_post': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardFacebook_feed_postRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/feed_videos': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardFeed_videosRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/instagram_comments': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_commentsRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/instagram_feed_post': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_feed_postRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/instagram_reel_post': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_reel_postRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/instagram_story_post': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_story_postRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/shorts': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardShortsRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/tag_ranking_list': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardTag_ranking_listRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/twitter_feed_posts': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardTwitter_feed_postsRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/youtube_comments': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardYoutube_commentsRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/interaction/brand-ambassadors': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionBrandAmbassadorsRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/interaction/mentioned_posts': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionMentioned_postsRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/interaction/tagged_posts': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionTagged_postsRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/compare': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdCompareIndexRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardIndexRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/interaction': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/not-found': typeof NotFoundRoute
  '/asset-preview': typeof PrivateRoutesAssetPreviewRoute
  '/campaign-posts-discovery': typeof PrivateRoutesCampaignPostsDiscoveryRoute
  '/payments': typeof PrivateRoutesPaymentsRoute
  '/posts': typeof PrivateRoutesPostsRoute
  '/report': typeof PrivateRoutesReportRoute
  '/settings': typeof PrivateRoutesSettingsRoute
  '/tiktok': typeof PrivateRoutesTiktokRouteWithChildren
  '/user-settings': typeof PrivateRoutesUserSettingsRoute
  '/privacy': typeof PublicRoutesPrivacyRoute
  '/redirect_to': typeof PublicRoutesRedirect_toRoute
  '/sign-in': typeof PublicRoutesSignInRoute
  '/terms': typeof PublicRoutesTermsRoute
  '/terms-combined': typeof PublicRoutesTermsCombinedRoute
  '/access/authorized': typeof PrivateRoutesAccessAuthorizedRoute
  '/access/declined': typeof PrivateRoutesAccessDeclinedRoute
  '/advertiser/add': typeof PrivateRoutesAdvertiserAddRoute
  '/agency/add': typeof PrivateRoutesAgencyAddRoute
  '/analytics/add': typeof PrivateRoutesAnalyticsAddRoute
  '/engagement/add': typeof PrivateRoutesEngagementAddRoute
  '/influencer/add': typeof PrivateRoutesInfluencerAddRoute
  '/influencers/proposal': typeof PrivateRoutesInfluencersProposalRoute
  '/marketplace/reorder': typeof PrivateRoutesMarketplaceReorderRoute
  '/package/add': typeof PrivateRoutesPackageAddRoute
  '/posts-insight/$id': typeof PrivateRoutesPostsInsightIdRouteWithChildren
  '/redirect/google-auth': typeof PrivateRoutesRedirectGoogleAuthRoute
  '/talent-agency/add': typeof PrivateRoutesTalentAgencyAddRoute
  '/tiktok/ad-accounts': typeof PrivateRoutesTiktokAdAccountsRoute
  '/tiktok/advertiser-details': typeof PrivateRoutesTiktokAdvertiserDetailsRoute
  '/tiktok/budget-allocation': typeof PrivateRoutesTiktokBudgetAllocationRoute
  '/tiktok/failed-payment': typeof PrivateRoutesTiktokFailedPaymentRoute
  '/tiktok/subscription-billing': typeof PrivateRoutesTiktokSubscriptionBillingRoute
  '/tools/video-comp-ai': typeof PrivateRoutesToolsVideoCompAiRoute
  '/trending/influencers': typeof PrivateRoutesTrendingInfluencersRoute
  '/trending/posts': typeof PrivateRoutesTrendingPostsRoute
  '/user/$id': typeof PrivateRoutesUserIdRoute
  '/user/add': typeof PrivateRoutesUserAddRoute
  '/user/linked': typeof PrivateRoutesUserLinkedRoute
  '/youtube-cms/invoices': typeof PrivateRoutesYoutubeCmsInvoicesRoute
  '/password_forgot': typeof PublicRoutesPasswordPassword_forgotRoute
  '/egg/referral': typeof PublicRoutesEggReferralRoute
  '/mkp/referral': typeof PublicRoutesMkpReferralRoute
  '/sign-up/success': typeof PublicRoutesSignUpSuccessRoute
  '/tiktok-onboarding/ad-account': typeof PublicRoutesTiktokOnboardingAdAccountRoute
  '/tiktok-onboarding/password-enter': typeof PublicRoutesTiktokOnboardingPasswordEnterRoute
  '/tiktok-onboarding/select-plan': typeof PublicRoutesTiktokOnboardingSelectPlanRoute
  '/tiktok-onboarding/success': typeof PublicRoutesTiktokOnboardingSuccessRoute
  '/access': typeof PrivateRoutesAccessIndexRoute
  '/advertiser': typeof PrivateRoutesAdvertiserIndexRoute
  '/agency': typeof PrivateRoutesAgencyIndexRoute
  '/analytics': typeof PrivateRoutesAnalyticsIndexRoute
  '/auto-managed': typeof PrivateRoutesAutoManagedIndexRoute
  '/engagement': typeof PrivateRoutesEngagementIndexRoute
  '/hashtag-analytics': typeof PrivateRoutesHashtagAnalyticsIndexRoute
  '/influencer': typeof PrivateRoutesInfluencerIndexRoute
  '/influencers': typeof PrivateRoutesInfluencersIndexRoute
  '/marketplace': typeof PrivateRoutesMarketplaceIndexRoute
  '/package': typeof PrivateRoutesPackageIndexRoute
  '/partner': typeof PrivateRoutesPartnerIndexRoute
  '/posts-insight': typeof PrivateRoutesPostsInsightIndexRoute
  '/prompts': typeof PrivateRoutesPromptsIndexRoute
  '/talent-agency': typeof PrivateRoutesTalentAgencyIndexRoute
  '/tools': typeof PrivateRoutesToolsIndexRoute
  '/trending': typeof PrivateRoutesTrendingIndexRoute
  '/user': typeof PrivateRoutesUserIndexRoute
  '/youtube-cms': typeof PrivateRoutesYoutubeCmsIndexRoute
  '/sign-up': typeof PublicRoutesSignUpIndexRoute
  '/tiktok-onboarding': typeof PublicRoutesTiktokOnboardingIndexRoute
  '/advertiser/$id/budget-allocation': typeof PrivateRoutesAdvertiserIdBudgetAllocationRoute
  '/advertiser/$id/users': typeof PrivateRoutesAdvertiserIdUsersRoute
  '/agency/$id/business': typeof PrivateRoutesAgencyIdBusinessRoute
  '/agency/$id/users': typeof PrivateRoutesAgencyIdUsersRoute
  '/auto-managed/$id/commissions': typeof PrivateRoutesAutoManagedIdCommissionsRoute
  '/auto-managed/$id/joined-influencers': typeof PrivateRoutesAutoManagedIdJoinedInfluencersRoute
  '/auto-managed/$id/report': typeof PrivateRoutesAutoManagedIdReportRoute
  '/engagement/$id/proposal': typeof PrivateRoutesEngagementIdProposalRoute
  '/engagement/$id/report': typeof PrivateRoutesEngagementIdReportRoute
  '/engagement/$id/tracking': typeof PrivateRoutesEngagementIdTrackingRoute
  '/engagement/$id/tracking-referral-codes': typeof PrivateRoutesEngagementIdTrackingReferralCodesRoute
  '/hashtag-analytics/instagram/$countryId': typeof PrivateRoutesHashtagAnalyticsInstagramCountryIdRoute
  '/influencers/search/douyin': typeof PrivateRoutesInfluencersSearchDouyinRoute
  '/influencers/search/facebook': typeof PrivateRoutesInfluencersSearchFacebookRoute
  '/influencers/search/facebook_page': typeof PrivateRoutesInfluencersSearchFacebook_pageRoute
  '/influencers/search/instagram': typeof PrivateRoutesInfluencersSearchInstagramRoute
  '/influencers/search/threads': typeof PrivateRoutesInfluencersSearchThreadsRoute
  '/influencers/search/tiktok': typeof PrivateRoutesInfluencersSearchTiktokRoute
  '/influencers/search/twitter': typeof PrivateRoutesInfluencersSearchTwitterRoute
  '/influencers/search/xhs': typeof PrivateRoutesInfluencersSearchXhsRoute
  '/influencers/search/youtube': typeof PrivateRoutesInfluencersSearchYoutubeRoute
  '/marketplace/$id/applicant': typeof PrivateRoutesMarketplaceIdApplicantRoute
  '/marketplace/$id/commissions': typeof PrivateRoutesMarketplaceIdCommissionsRoute
  '/marketplace/$id/influencer': typeof PrivateRoutesMarketplaceIdInfluencerRoute
  '/marketplace/$id/joined-influencers': typeof PrivateRoutesMarketplaceIdJoinedInfluencersRoute
  '/marketplace/$id/report': typeof PrivateRoutesMarketplaceIdReportRoute
  '/marketplace/$id/report-affiliate': typeof PrivateRoutesMarketplaceIdReportAffiliateRoute
  '/marketplace/$id/tracking': typeof PrivateRoutesMarketplaceIdTrackingRoute
  '/marketplace/$id/tracking-referral-codes': typeof PrivateRoutesMarketplaceIdTrackingReferralCodesRoute
  '/marketplace/add/referral-code-tracking': typeof PrivateRoutesMarketplaceAddReferralCodeTrackingRoute
  '/marketplace/add/social-media-tracking': typeof PrivateRoutesMarketplaceAddSocialMediaTrackingRoute
  '/marketplace/add/url-tracking': typeof PrivateRoutesMarketplaceAddUrlTrackingRoute
  '/partner/$id/business': typeof PrivateRoutesPartnerIdBusinessRoute
  '/partner/$id/users': typeof PrivateRoutesPartnerIdUsersRoute
  '/posts-insight/$id/$postId': typeof PrivateRoutesPostsInsightIdPostIdRoute
  '/redirect/analytics-connect/$provider': typeof PrivateRoutesRedirectAnalyticsConnectProviderRoute
  '/redirect/analytics-list-connect/$provider': typeof PrivateRoutesRedirectAnalyticsListConnectProviderRoute
  '/redirect/analytics-signin/$provider': typeof PrivateRoutesRedirectAnalyticsSigninProviderRoute
  '/redirect/connect/tiktok-business': typeof PrivateRoutesRedirectConnectTiktokBusinessRoute
  '/redirect/hidden/youtube-list-connect': typeof PrivateRoutesRedirectHiddenYoutubeListConnectRoute
  '/redirect/talent-analytics-connect/$provider': typeof PrivateRoutesRedirectTalentAnalyticsConnectProviderRoute
  '/redirect/talent-signin/$provider': typeof PrivateRoutesRedirectTalentSigninProviderRoute
  '/talent-agency/$id/business': typeof PrivateRoutesTalentAgencyIdBusinessRoute
  '/talent-agency/$id/users': typeof PrivateRoutesTalentAgencyIdUsersRoute
  '/tiktok/campaigns/add': typeof PrivateRoutesTiktokCampaignsAddRoute
  '/tiktok/campaigns/review-influencers': typeof PrivateRoutesTiktokCampaignsReviewInfluencersRoute
  '/youtube-cms/revenue/$cmsChannelId': typeof PrivateRoutesYoutubeCmsRevenueCmsChannelIdRoute
  '/youtube-cms/revenue/confirmed': typeof PrivateRoutesYoutubeCmsRevenueConfirmedRoute
  '/password_register/$token': typeof PublicRoutesPasswordPassword_registerTokenRoute
  '/password_reset/$token': typeof PublicRoutesPasswordPassword_resetTokenRoute
  '/tiktok-onboarding/password-register/$token': typeof PublicRoutesTiktokOnboardingPasswordRegisterTokenRoute
  '/advertiser/$id': typeof PrivateRoutesAdvertiserIdIndexRoute
  '/agency/$id': typeof PrivateRoutesAgencyIdIndexRoute
  '/analytics/$brandAccountId': typeof PrivateRoutesAnalyticsBrandAccountIdIndexRoute
  '/auto-managed/$id': typeof PrivateRoutesAutoManagedIdIndexRoute
  '/engagement/$id': typeof PrivateRoutesEngagementIdIndexRoute
  '/hashtag-analytics/instagram': typeof PrivateRoutesHashtagAnalyticsInstagramIndexRoute
  '/hashtag-analytics/tiktok': typeof PrivateRoutesHashtagAnalyticsTiktokIndexRoute
  '/influencer/$id': typeof PrivateRoutesInfluencerIdIndexRoute
  '/influencers/search': typeof PrivateRoutesInfluencersSearchIndexRoute
  '/marketplace/$id': typeof PrivateRoutesMarketplaceIdIndexRoute
  '/marketplace/add': typeof PrivateRoutesMarketplaceAddIndexRoute
  '/package/$id': typeof PrivateRoutesPackageIdIndexRoute
  '/partner/$id': typeof PrivateRoutesPartnerIdIndexRoute
  '/talent-agency/$id': typeof PrivateRoutesTalentAgencyIdIndexRoute
  '/tiktok/ad-campaign-report': typeof PrivateRoutesTiktokAdCampaignReportIndexRoute
  '/tiktok/campaigns': typeof PrivateRoutesTiktokCampaignsIndexRoute
  '/youtube-cms/revenue': typeof PrivateRoutesYoutubeCmsRevenueIndexRoute
  '/engagement/$id/influencer/campaigns': typeof PrivateRoutesEngagementIdInfluencerCampaignsRoute
  '/engagement/$id/influencer/douyin': typeof PrivateRoutesEngagementIdInfluencerDouyinRoute
  '/engagement/$id/influencer/facebook': typeof PrivateRoutesEngagementIdInfluencerFacebookRoute
  '/engagement/$id/influencer/facebook_page': typeof PrivateRoutesEngagementIdInfluencerFacebook_pageRoute
  '/engagement/$id/influencer/instagram': typeof PrivateRoutesEngagementIdInfluencerInstagramRoute
  '/engagement/$id/influencer/packages': typeof PrivateRoutesEngagementIdInfluencerPackagesRoute
  '/engagement/$id/influencer/posts': typeof PrivateRoutesEngagementIdInfluencerPostsRoute
  '/engagement/$id/influencer/threads': typeof PrivateRoutesEngagementIdInfluencerThreadsRoute
  '/engagement/$id/influencer/tiktok': typeof PrivateRoutesEngagementIdInfluencerTiktokRoute
  '/engagement/$id/influencer/twitter': typeof PrivateRoutesEngagementIdInfluencerTwitterRoute
  '/engagement/$id/influencer/xhs': typeof PrivateRoutesEngagementIdInfluencerXhsRoute
  '/engagement/$id/influencer/youtube': typeof PrivateRoutesEngagementIdInfluencerYoutubeRoute
  '/engagement/$id/posts/$postId': typeof PrivateRoutesEngagementIdPostsPostIdRoute
  '/engagement/$id/posts/add': typeof PrivateRoutesEngagementIdPostsAddRoute
  '/hashtag-analytics/tiktok/hashtag/$countryId': typeof PrivateRoutesHashtagAnalyticsTiktokHashtagCountryIdRoute
  '/hashtag-analytics/tiktok/keyword/$countryId': typeof PrivateRoutesHashtagAnalyticsTiktokKeywordCountryIdRoute
  '/influencer/$id/$socialMediaAccountId/facebook_feed_post': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdFacebook_feed_postRoute
  '/influencer/$id/$socialMediaAccountId/feed_videos': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdFeed_videosRoute
  '/influencer/$id/$socialMediaAccountId/instagram_feed_post': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdInstagram_feed_postRoute
  '/influencer/$id/$socialMediaAccountId/instagram_reel_post': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdInstagram_reel_postRoute
  '/influencer/$id/$socialMediaAccountId/instagram_story_post': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdInstagram_story_postRoute
  '/influencer/$id/$socialMediaAccountId/scraping_feed_posts': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdScraping_feed_postsRoute
  '/influencer/$id/$socialMediaAccountId/shorts': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdShortsRoute
  '/influencer/$id/$socialMediaAccountId/sponsored_feed_posts': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdSponsored_feed_postsRoute
  '/influencer/$id/$socialMediaAccountId/sponsored_youtube_feed_posts': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdSponsored_youtube_feed_postsRoute
  '/influencer/$id/$socialMediaAccountId/twitter_feed_posts': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdTwitter_feed_postsRoute
  '/influencer/$id/$socialMediaAccountId/xhs_picture_posts': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdXhs_picture_postsRoute
  '/influencer/$id/$socialMediaAccountId/xhs_video_posts': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdXhs_video_postsRoute
  '/influencer/$id/$socialMediaAccountId/youtube_tags_ranking': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_tags_rankingRoute
  '/influencer/$id/profile/campaigns': typeof PrivateRoutesInfluencerIdProfileCampaignsRoute
  '/influencer/$id/profile/compare': typeof PrivateRoutesInfluencerIdProfileCompareRoute
  '/marketplace/$id/posts/$postId': typeof PrivateRoutesMarketplaceIdPostsPostIdRoute
  '/marketplace/add/e-commerce/$autoMangedCampaignId': typeof PrivateRoutesMarketplaceAddECommerceAutoMangedCampaignIdRoute
  '/package/$id/content/list': typeof PrivateRoutesPackageIdContentListRoute
  '/tiktok/ad-campaign-report/$id/$groupId': typeof PrivateRoutesTiktokAdCampaignReportIdGroupIdRoute
  '/tiktok/campaigns/$id/influencers': typeof PrivateRoutesTiktokCampaignsIdInfluencersRoute
  '/tiktok/campaigns/$id/report': typeof PrivateRoutesTiktokCampaignsIdReportRoute
  '/engagement/$id/influencer': typeof PrivateRoutesEngagementIdInfluencerIndexRoute
  '/engagement/$id/posts': typeof PrivateRoutesEngagementIdPostsIndexRoute
  '/hashtag-analytics/tiktok/hashtag': typeof PrivateRoutesHashtagAnalyticsTiktokHashtagIndexRoute
  '/hashtag-analytics/tiktok/keyword': typeof PrivateRoutesHashtagAnalyticsTiktokKeywordIndexRoute
  '/influencer/$id/profile': typeof PrivateRoutesInfluencerIdProfileIndexRoute
  '/marketplace/$id/posts': typeof PrivateRoutesMarketplaceIdPostsIndexRoute
  '/marketplace/add/e-commerce': typeof PrivateRoutesMarketplaceAddECommerceIndexRoute
  '/package/$id/content': typeof PrivateRoutesPackageIdContentIndexRoute
  '/tiktok/ad-campaign-report/$id': typeof PrivateRoutesTiktokAdCampaignReportIdIndexRoute
  '/tiktok/campaigns/$id': typeof PrivateRoutesTiktokCampaignsIdIndexRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/hashtag': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdHashtagRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/trend': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdTrendRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/ugc': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdUgcRoute
  '/influencer/$id/$socialMediaAccountId/youtube_compare_feed_videos/$compareId': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_compare_feed_videosCompareIdRoute
  '/package/$id/content/search/douyin': typeof PrivateRoutesPackageIdContentSearchDouyinRoute
  '/package/$id/content/search/facebook': typeof PrivateRoutesPackageIdContentSearchFacebookRoute
  '/package/$id/content/search/facebook_page': typeof PrivateRoutesPackageIdContentSearchFacebook_pageRoute
  '/package/$id/content/search/instagram': typeof PrivateRoutesPackageIdContentSearchInstagramRoute
  '/package/$id/content/search/threads': typeof PrivateRoutesPackageIdContentSearchThreadsRoute
  '/package/$id/content/search/tiktok': typeof PrivateRoutesPackageIdContentSearchTiktokRoute
  '/package/$id/content/search/twitter': typeof PrivateRoutesPackageIdContentSearchTwitterRoute
  '/package/$id/content/search/xhs': typeof PrivateRoutesPackageIdContentSearchXhsRoute
  '/package/$id/content/search/youtube': typeof PrivateRoutesPackageIdContentSearchYoutubeRoute
  '/tiktok/campaigns/$id/posts/$postId': typeof PrivateRoutesTiktokCampaignsIdPostsPostIdRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdIndexRoute
  '/influencer/$id/$socialMediaAccountId/youtube_compare_feed_videos': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_compare_feed_videosIndexRoute
  '/package/$id/content/search': typeof PrivateRoutesPackageIdContentSearchIndexRoute
  '/tiktok/campaigns/$id/posts': typeof PrivateRoutesTiktokCampaignsIdPostsIndexRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/compare/instagram_compare_feed_post': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdCompareInstagram_compare_feed_postRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/compare/youtube_compare_feed_videos': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdCompareYoutube_compare_feed_videosRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/facebook_feed_post': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardFacebook_feed_postRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/feed_videos': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardFeed_videosRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/instagram_comments': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_commentsRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/instagram_feed_post': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_feed_postRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/instagram_reel_post': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_reel_postRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/instagram_story_post': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_story_postRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/shorts': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardShortsRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/tag_ranking_list': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardTag_ranking_listRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/twitter_feed_posts': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardTwitter_feed_postsRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/youtube_comments': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardYoutube_commentsRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/interaction/brand-ambassadors': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionBrandAmbassadorsRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/interaction/mentioned_posts': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionMentioned_postsRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/interaction/tagged_posts': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionTagged_postsRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/compare': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdCompareIndexRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardIndexRoute
  '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/interaction': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_private-routes': typeof PrivateRoutesRouteWithChildren
  '/_public-routes': typeof PublicRoutesRouteWithChildren
  '/not-found': typeof NotFoundRoute
  '/_private-routes/advertiser': typeof PrivateRoutesAdvertiserRouteWithChildren
  '/_private-routes/agency': typeof PrivateRoutesAgencyRouteWithChildren
  '/_private-routes/analytics': typeof PrivateRoutesAnalyticsRouteWithChildren
  '/_private-routes/asset-preview': typeof PrivateRoutesAssetPreviewRoute
  '/_private-routes/auto-managed': typeof PrivateRoutesAutoManagedRouteWithChildren
  '/_private-routes/campaign-posts-discovery': typeof PrivateRoutesCampaignPostsDiscoveryRoute
  '/_private-routes/hashtag-analytics': typeof PrivateRoutesHashtagAnalyticsRouteWithChildren
  '/_private-routes/influencer': typeof PrivateRoutesInfluencerRouteWithChildren
  '/_private-routes/influencers': typeof PrivateRoutesInfluencersRouteWithChildren
  '/_private-routes/package': typeof PrivateRoutesPackageRouteWithChildren
  '/_private-routes/partner': typeof PrivateRoutesPartnerRouteWithChildren
  '/_private-routes/payments': typeof PrivateRoutesPaymentsRoute
  '/_private-routes/posts': typeof PrivateRoutesPostsRoute
  '/_private-routes/posts-insight': typeof PrivateRoutesPostsInsightRouteWithChildren
  '/_private-routes/report': typeof PrivateRoutesReportRoute
  '/_private-routes/settings': typeof PrivateRoutesSettingsRoute
  '/_private-routes/talent-agency': typeof PrivateRoutesTalentAgencyRouteWithChildren
  '/_private-routes/tiktok': typeof PrivateRoutesTiktokRouteWithChildren
  '/_private-routes/tools': typeof PrivateRoutesToolsRouteWithChildren
  '/_private-routes/trending': typeof PrivateRoutesTrendingRouteWithChildren
  '/_private-routes/user': typeof PrivateRoutesUserRouteWithChildren
  '/_private-routes/user-settings': typeof PrivateRoutesUserSettingsRoute
  '/_private-routes/youtube-cms': typeof PrivateRoutesYoutubeCmsRouteWithChildren
  '/_public-routes/privacy': typeof PublicRoutesPrivacyRoute
  '/_public-routes/redirect_to': typeof PublicRoutesRedirect_toRoute
  '/_public-routes/sign-in': typeof PublicRoutesSignInRoute
  '/_public-routes/terms': typeof PublicRoutesTermsRoute
  '/_public-routes/terms-combined': typeof PublicRoutesTermsCombinedRoute
  '/_public-routes/tiktok-onboarding': typeof PublicRoutesTiktokOnboardingRouteWithChildren
  '/_private-routes/access/authorized': typeof PrivateRoutesAccessAuthorizedRoute
  '/_private-routes/access/declined': typeof PrivateRoutesAccessDeclinedRoute
  '/_private-routes/advertiser/$id': typeof PrivateRoutesAdvertiserIdRouteWithChildren
  '/_private-routes/advertiser/add': typeof PrivateRoutesAdvertiserAddRoute
  '/_private-routes/agency/$id': typeof PrivateRoutesAgencyIdRouteWithChildren
  '/_private-routes/agency/add': typeof PrivateRoutesAgencyAddRoute
  '/_private-routes/analytics/add': typeof PrivateRoutesAnalyticsAddRoute
  '/_private-routes/auto-managed/$id': typeof PrivateRoutesAutoManagedIdRouteWithChildren
  '/_private-routes/engagement/$id': typeof PrivateRoutesEngagementIdRouteWithChildren
  '/_private-routes/engagement/add': typeof PrivateRoutesEngagementAddRoute
  '/_private-routes/hashtag-analytics/instagram': typeof PrivateRoutesHashtagAnalyticsInstagramRouteWithChildren
  '/_private-routes/hashtag-analytics/tiktok': typeof PrivateRoutesHashtagAnalyticsTiktokRouteWithChildren
  '/_private-routes/influencer/$id': typeof PrivateRoutesInfluencerIdRouteWithChildren
  '/_private-routes/influencer/add': typeof PrivateRoutesInfluencerAddRoute
  '/_private-routes/influencers/proposal': typeof PrivateRoutesInfluencersProposalRoute
  '/_private-routes/influencers/search': typeof PrivateRoutesInfluencersSearchRouteWithChildren
  '/_private-routes/marketplace/$id': typeof PrivateRoutesMarketplaceIdRouteWithChildren
  '/_private-routes/marketplace/add': typeof PrivateRoutesMarketplaceAddRouteWithChildren
  '/_private-routes/marketplace/reorder': typeof PrivateRoutesMarketplaceReorderRoute
  '/_private-routes/package/$id': typeof PrivateRoutesPackageIdRouteWithChildren
  '/_private-routes/package/add': typeof PrivateRoutesPackageAddRoute
  '/_private-routes/partner/$id': typeof PrivateRoutesPartnerIdRouteWithChildren
  '/_private-routes/posts-insight/$id': typeof PrivateRoutesPostsInsightIdRouteWithChildren
  '/_private-routes/redirect/google-auth': typeof PrivateRoutesRedirectGoogleAuthRoute
  '/_private-routes/talent-agency/$id': typeof PrivateRoutesTalentAgencyIdRouteWithChildren
  '/_private-routes/talent-agency/add': typeof PrivateRoutesTalentAgencyAddRoute
  '/_private-routes/tiktok/ad-accounts': typeof PrivateRoutesTiktokAdAccountsRoute
  '/_private-routes/tiktok/ad-campaign-report': typeof PrivateRoutesTiktokAdCampaignReportRouteWithChildren
  '/_private-routes/tiktok/advertiser-details': typeof PrivateRoutesTiktokAdvertiserDetailsRoute
  '/_private-routes/tiktok/budget-allocation': typeof PrivateRoutesTiktokBudgetAllocationRoute
  '/_private-routes/tiktok/campaigns': typeof PrivateRoutesTiktokCampaignsRouteWithChildren
  '/_private-routes/tiktok/failed-payment': typeof PrivateRoutesTiktokFailedPaymentRoute
  '/_private-routes/tiktok/subscription-billing': typeof PrivateRoutesTiktokSubscriptionBillingRoute
  '/_private-routes/tools/video-comp-ai': typeof PrivateRoutesToolsVideoCompAiRoute
  '/_private-routes/trending/influencers': typeof PrivateRoutesTrendingInfluencersRoute
  '/_private-routes/trending/posts': typeof PrivateRoutesTrendingPostsRoute
  '/_private-routes/user/$id': typeof PrivateRoutesUserIdRoute
  '/_private-routes/user/add': typeof PrivateRoutesUserAddRoute
  '/_private-routes/user/linked': typeof PrivateRoutesUserLinkedRoute
  '/_private-routes/youtube-cms/invoices': typeof PrivateRoutesYoutubeCmsInvoicesRoute
  '/_private-routes/youtube-cms/revenue': typeof PrivateRoutesYoutubeCmsRevenueRouteWithChildren
  '/_public-routes/_password/password_forgot': typeof PublicRoutesPasswordPassword_forgotRoute
  '/_public-routes/egg/referral': typeof PublicRoutesEggReferralRoute
  '/_public-routes/mkp/referral': typeof PublicRoutesMkpReferralRoute
  '/_public-routes/sign-up/success': typeof PublicRoutesSignUpSuccessRoute
  '/_public-routes/tiktok-onboarding/ad-account': typeof PublicRoutesTiktokOnboardingAdAccountRoute
  '/_public-routes/tiktok-onboarding/password-enter': typeof PublicRoutesTiktokOnboardingPasswordEnterRoute
  '/_public-routes/tiktok-onboarding/select-plan': typeof PublicRoutesTiktokOnboardingSelectPlanRoute
  '/_public-routes/tiktok-onboarding/success': typeof PublicRoutesTiktokOnboardingSuccessRoute
  '/_private-routes/access/': typeof PrivateRoutesAccessIndexRoute
  '/_private-routes/advertiser/': typeof PrivateRoutesAdvertiserIndexRoute
  '/_private-routes/agency/': typeof PrivateRoutesAgencyIndexRoute
  '/_private-routes/analytics/': typeof PrivateRoutesAnalyticsIndexRoute
  '/_private-routes/auto-managed/': typeof PrivateRoutesAutoManagedIndexRoute
  '/_private-routes/engagement/': typeof PrivateRoutesEngagementIndexRoute
  '/_private-routes/hashtag-analytics/': typeof PrivateRoutesHashtagAnalyticsIndexRoute
  '/_private-routes/influencer/': typeof PrivateRoutesInfluencerIndexRoute
  '/_private-routes/influencers/': typeof PrivateRoutesInfluencersIndexRoute
  '/_private-routes/marketplace/': typeof PrivateRoutesMarketplaceIndexRoute
  '/_private-routes/package/': typeof PrivateRoutesPackageIndexRoute
  '/_private-routes/partner/': typeof PrivateRoutesPartnerIndexRoute
  '/_private-routes/posts-insight/': typeof PrivateRoutesPostsInsightIndexRoute
  '/_private-routes/prompts/': typeof PrivateRoutesPromptsIndexRoute
  '/_private-routes/talent-agency/': typeof PrivateRoutesTalentAgencyIndexRoute
  '/_private-routes/tools/': typeof PrivateRoutesToolsIndexRoute
  '/_private-routes/trending/': typeof PrivateRoutesTrendingIndexRoute
  '/_private-routes/user/': typeof PrivateRoutesUserIndexRoute
  '/_private-routes/youtube-cms/': typeof PrivateRoutesYoutubeCmsIndexRoute
  '/_public-routes/sign-up/': typeof PublicRoutesSignUpIndexRoute
  '/_public-routes/tiktok-onboarding/': typeof PublicRoutesTiktokOnboardingIndexRoute
  '/_private-routes/advertiser/$id/budget-allocation': typeof PrivateRoutesAdvertiserIdBudgetAllocationRoute
  '/_private-routes/advertiser/$id/users': typeof PrivateRoutesAdvertiserIdUsersRoute
  '/_private-routes/agency/$id/business': typeof PrivateRoutesAgencyIdBusinessRoute
  '/_private-routes/agency/$id/users': typeof PrivateRoutesAgencyIdUsersRoute
  '/_private-routes/auto-managed/$id/commissions': typeof PrivateRoutesAutoManagedIdCommissionsRoute
  '/_private-routes/auto-managed/$id/joined-influencers': typeof PrivateRoutesAutoManagedIdJoinedInfluencersRoute
  '/_private-routes/auto-managed/$id/report': typeof PrivateRoutesAutoManagedIdReportRoute
  '/_private-routes/engagement/$id/influencer': typeof PrivateRoutesEngagementIdInfluencerRouteWithChildren
  '/_private-routes/engagement/$id/posts': typeof PrivateRoutesEngagementIdPostsRouteWithChildren
  '/_private-routes/engagement/$id/proposal': typeof PrivateRoutesEngagementIdProposalRoute
  '/_private-routes/engagement/$id/report': typeof PrivateRoutesEngagementIdReportRoute
  '/_private-routes/engagement/$id/tracking': typeof PrivateRoutesEngagementIdTrackingRoute
  '/_private-routes/engagement/$id/tracking-referral-codes': typeof PrivateRoutesEngagementIdTrackingReferralCodesRoute
  '/_private-routes/hashtag-analytics/instagram/$countryId': typeof PrivateRoutesHashtagAnalyticsInstagramCountryIdRoute
  '/_private-routes/hashtag-analytics/tiktok/hashtag': typeof PrivateRoutesHashtagAnalyticsTiktokHashtagRouteWithChildren
  '/_private-routes/hashtag-analytics/tiktok/keyword': typeof PrivateRoutesHashtagAnalyticsTiktokKeywordRouteWithChildren
  '/_private-routes/influencer/$id/profile': typeof PrivateRoutesInfluencerIdProfileRouteWithChildren
  '/_private-routes/influencers/search/douyin': typeof PrivateRoutesInfluencersSearchDouyinRoute
  '/_private-routes/influencers/search/facebook': typeof PrivateRoutesInfluencersSearchFacebookRoute
  '/_private-routes/influencers/search/facebook_page': typeof PrivateRoutesInfluencersSearchFacebook_pageRoute
  '/_private-routes/influencers/search/instagram': typeof PrivateRoutesInfluencersSearchInstagramRoute
  '/_private-routes/influencers/search/threads': typeof PrivateRoutesInfluencersSearchThreadsRoute
  '/_private-routes/influencers/search/tiktok': typeof PrivateRoutesInfluencersSearchTiktokRoute
  '/_private-routes/influencers/search/twitter': typeof PrivateRoutesInfluencersSearchTwitterRoute
  '/_private-routes/influencers/search/xhs': typeof PrivateRoutesInfluencersSearchXhsRoute
  '/_private-routes/influencers/search/youtube': typeof PrivateRoutesInfluencersSearchYoutubeRoute
  '/_private-routes/marketplace/$id/applicant': typeof PrivateRoutesMarketplaceIdApplicantRoute
  '/_private-routes/marketplace/$id/commissions': typeof PrivateRoutesMarketplaceIdCommissionsRoute
  '/_private-routes/marketplace/$id/influencer': typeof PrivateRoutesMarketplaceIdInfluencerRoute
  '/_private-routes/marketplace/$id/joined-influencers': typeof PrivateRoutesMarketplaceIdJoinedInfluencersRoute
  '/_private-routes/marketplace/$id/posts': typeof PrivateRoutesMarketplaceIdPostsRouteWithChildren
  '/_private-routes/marketplace/$id/report': typeof PrivateRoutesMarketplaceIdReportRoute
  '/_private-routes/marketplace/$id/report-affiliate': typeof PrivateRoutesMarketplaceIdReportAffiliateRoute
  '/_private-routes/marketplace/$id/tracking': typeof PrivateRoutesMarketplaceIdTrackingRoute
  '/_private-routes/marketplace/$id/tracking-referral-codes': typeof PrivateRoutesMarketplaceIdTrackingReferralCodesRoute
  '/_private-routes/marketplace/add/referral-code-tracking': typeof PrivateRoutesMarketplaceAddReferralCodeTrackingRoute
  '/_private-routes/marketplace/add/social-media-tracking': typeof PrivateRoutesMarketplaceAddSocialMediaTrackingRoute
  '/_private-routes/marketplace/add/url-tracking': typeof PrivateRoutesMarketplaceAddUrlTrackingRoute
  '/_private-routes/package/$id/content': typeof PrivateRoutesPackageIdContentRouteWithChildren
  '/_private-routes/partner/$id/business': typeof PrivateRoutesPartnerIdBusinessRoute
  '/_private-routes/partner/$id/users': typeof PrivateRoutesPartnerIdUsersRoute
  '/_private-routes/posts-insight/$id/$postId': typeof PrivateRoutesPostsInsightIdPostIdRoute
  '/_private-routes/redirect/analytics-connect/$provider': typeof PrivateRoutesRedirectAnalyticsConnectProviderRoute
  '/_private-routes/redirect/analytics-list-connect/$provider': typeof PrivateRoutesRedirectAnalyticsListConnectProviderRoute
  '/_private-routes/redirect/analytics-signin/$provider': typeof PrivateRoutesRedirectAnalyticsSigninProviderRoute
  '/_private-routes/redirect/connect/tiktok-business': typeof PrivateRoutesRedirectConnectTiktokBusinessRoute
  '/_private-routes/redirect/hidden/youtube-list-connect': typeof PrivateRoutesRedirectHiddenYoutubeListConnectRoute
  '/_private-routes/redirect/talent-analytics-connect/$provider': typeof PrivateRoutesRedirectTalentAnalyticsConnectProviderRoute
  '/_private-routes/redirect/talent-signin/$provider': typeof PrivateRoutesRedirectTalentSigninProviderRoute
  '/_private-routes/talent-agency/$id/business': typeof PrivateRoutesTalentAgencyIdBusinessRoute
  '/_private-routes/talent-agency/$id/users': typeof PrivateRoutesTalentAgencyIdUsersRoute
  '/_private-routes/tiktok/campaigns/$id': typeof PrivateRoutesTiktokCampaignsIdRouteWithChildren
  '/_private-routes/tiktok/campaigns/add': typeof PrivateRoutesTiktokCampaignsAddRoute
  '/_private-routes/tiktok/campaigns/review-influencers': typeof PrivateRoutesTiktokCampaignsReviewInfluencersRoute
  '/_private-routes/youtube-cms/revenue/$cmsChannelId': typeof PrivateRoutesYoutubeCmsRevenueCmsChannelIdRoute
  '/_private-routes/youtube-cms/revenue/confirmed': typeof PrivateRoutesYoutubeCmsRevenueConfirmedRoute
  '/_public-routes/_password/password_register/$token': typeof PublicRoutesPasswordPassword_registerTokenRoute
  '/_public-routes/_password/password_reset/$token': typeof PublicRoutesPasswordPassword_resetTokenRoute
  '/_public-routes/tiktok-onboarding/password-register/$token': typeof PublicRoutesTiktokOnboardingPasswordRegisterTokenRoute
  '/_private-routes/advertiser/$id/': typeof PrivateRoutesAdvertiserIdIndexRoute
  '/_private-routes/agency/$id/': typeof PrivateRoutesAgencyIdIndexRoute
  '/_private-routes/analytics/$brandAccountId/': typeof PrivateRoutesAnalyticsBrandAccountIdIndexRoute
  '/_private-routes/auto-managed/$id/': typeof PrivateRoutesAutoManagedIdIndexRoute
  '/_private-routes/engagement/$id/': typeof PrivateRoutesEngagementIdIndexRoute
  '/_private-routes/hashtag-analytics/instagram/': typeof PrivateRoutesHashtagAnalyticsInstagramIndexRoute
  '/_private-routes/hashtag-analytics/tiktok/': typeof PrivateRoutesHashtagAnalyticsTiktokIndexRoute
  '/_private-routes/influencer/$id/': typeof PrivateRoutesInfluencerIdIndexRoute
  '/_private-routes/influencers/search/': typeof PrivateRoutesInfluencersSearchIndexRoute
  '/_private-routes/marketplace/$id/': typeof PrivateRoutesMarketplaceIdIndexRoute
  '/_private-routes/marketplace/add/': typeof PrivateRoutesMarketplaceAddIndexRoute
  '/_private-routes/package/$id/': typeof PrivateRoutesPackageIdIndexRoute
  '/_private-routes/partner/$id/': typeof PrivateRoutesPartnerIdIndexRoute
  '/_private-routes/talent-agency/$id/': typeof PrivateRoutesTalentAgencyIdIndexRoute
  '/_private-routes/tiktok/ad-campaign-report/': typeof PrivateRoutesTiktokAdCampaignReportIndexRoute
  '/_private-routes/tiktok/campaigns/': typeof PrivateRoutesTiktokCampaignsIndexRoute
  '/_private-routes/youtube-cms/revenue/': typeof PrivateRoutesYoutubeCmsRevenueIndexRoute
  '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRouteWithChildren
  '/_private-routes/engagement/$id/influencer/campaigns': typeof PrivateRoutesEngagementIdInfluencerCampaignsRoute
  '/_private-routes/engagement/$id/influencer/douyin': typeof PrivateRoutesEngagementIdInfluencerDouyinRoute
  '/_private-routes/engagement/$id/influencer/facebook': typeof PrivateRoutesEngagementIdInfluencerFacebookRoute
  '/_private-routes/engagement/$id/influencer/facebook_page': typeof PrivateRoutesEngagementIdInfluencerFacebook_pageRoute
  '/_private-routes/engagement/$id/influencer/instagram': typeof PrivateRoutesEngagementIdInfluencerInstagramRoute
  '/_private-routes/engagement/$id/influencer/packages': typeof PrivateRoutesEngagementIdInfluencerPackagesRoute
  '/_private-routes/engagement/$id/influencer/posts': typeof PrivateRoutesEngagementIdInfluencerPostsRoute
  '/_private-routes/engagement/$id/influencer/threads': typeof PrivateRoutesEngagementIdInfluencerThreadsRoute
  '/_private-routes/engagement/$id/influencer/tiktok': typeof PrivateRoutesEngagementIdInfluencerTiktokRoute
  '/_private-routes/engagement/$id/influencer/twitter': typeof PrivateRoutesEngagementIdInfluencerTwitterRoute
  '/_private-routes/engagement/$id/influencer/xhs': typeof PrivateRoutesEngagementIdInfluencerXhsRoute
  '/_private-routes/engagement/$id/influencer/youtube': typeof PrivateRoutesEngagementIdInfluencerYoutubeRoute
  '/_private-routes/engagement/$id/posts/$postId': typeof PrivateRoutesEngagementIdPostsPostIdRoute
  '/_private-routes/engagement/$id/posts/add': typeof PrivateRoutesEngagementIdPostsAddRoute
  '/_private-routes/hashtag-analytics/tiktok/hashtag/$countryId': typeof PrivateRoutesHashtagAnalyticsTiktokHashtagCountryIdRoute
  '/_private-routes/hashtag-analytics/tiktok/keyword/$countryId': typeof PrivateRoutesHashtagAnalyticsTiktokKeywordCountryIdRoute
  '/_private-routes/influencer/$id/$socialMediaAccountId/facebook_feed_post': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdFacebook_feed_postRoute
  '/_private-routes/influencer/$id/$socialMediaAccountId/feed_videos': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdFeed_videosRoute
  '/_private-routes/influencer/$id/$socialMediaAccountId/instagram_feed_post': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdInstagram_feed_postRoute
  '/_private-routes/influencer/$id/$socialMediaAccountId/instagram_reel_post': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdInstagram_reel_postRoute
  '/_private-routes/influencer/$id/$socialMediaAccountId/instagram_story_post': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdInstagram_story_postRoute
  '/_private-routes/influencer/$id/$socialMediaAccountId/scraping_feed_posts': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdScraping_feed_postsRoute
  '/_private-routes/influencer/$id/$socialMediaAccountId/shorts': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdShortsRoute
  '/_private-routes/influencer/$id/$socialMediaAccountId/sponsored_feed_posts': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdSponsored_feed_postsRoute
  '/_private-routes/influencer/$id/$socialMediaAccountId/sponsored_youtube_feed_posts': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdSponsored_youtube_feed_postsRoute
  '/_private-routes/influencer/$id/$socialMediaAccountId/twitter_feed_posts': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdTwitter_feed_postsRoute
  '/_private-routes/influencer/$id/$socialMediaAccountId/xhs_picture_posts': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdXhs_picture_postsRoute
  '/_private-routes/influencer/$id/$socialMediaAccountId/xhs_video_posts': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdXhs_video_postsRoute
  '/_private-routes/influencer/$id/$socialMediaAccountId/youtube_compare_feed_videos': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_compare_feed_videosRouteWithChildren
  '/_private-routes/influencer/$id/$socialMediaAccountId/youtube_tags_ranking': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_tags_rankingRoute
  '/_private-routes/influencer/$id/profile/campaigns': typeof PrivateRoutesInfluencerIdProfileCampaignsRoute
  '/_private-routes/influencer/$id/profile/compare': typeof PrivateRoutesInfluencerIdProfileCompareRoute
  '/_private-routes/marketplace/$id/posts/$postId': typeof PrivateRoutesMarketplaceIdPostsPostIdRoute
  '/_private-routes/marketplace/add/e-commerce/$autoMangedCampaignId': typeof PrivateRoutesMarketplaceAddECommerceAutoMangedCampaignIdRoute
  '/_private-routes/package/$id/content/list': typeof PrivateRoutesPackageIdContentListRoute
  '/_private-routes/package/$id/content/search': typeof PrivateRoutesPackageIdContentSearchRouteWithChildren
  '/_private-routes/tiktok/ad-campaign-report/$id/$groupId': typeof PrivateRoutesTiktokAdCampaignReportIdGroupIdRoute
  '/_private-routes/tiktok/campaigns/$id/influencers': typeof PrivateRoutesTiktokCampaignsIdInfluencersRoute
  '/_private-routes/tiktok/campaigns/$id/posts': typeof PrivateRoutesTiktokCampaignsIdPostsRouteWithChildren
  '/_private-routes/tiktok/campaigns/$id/report': typeof PrivateRoutesTiktokCampaignsIdReportRoute
  '/_private-routes/engagement/$id/influencer/': typeof PrivateRoutesEngagementIdInfluencerIndexRoute
  '/_private-routes/engagement/$id/posts/': typeof PrivateRoutesEngagementIdPostsIndexRoute
  '/_private-routes/hashtag-analytics/tiktok/hashtag/': typeof PrivateRoutesHashtagAnalyticsTiktokHashtagIndexRoute
  '/_private-routes/hashtag-analytics/tiktok/keyword/': typeof PrivateRoutesHashtagAnalyticsTiktokKeywordIndexRoute
  '/_private-routes/influencer/$id/profile/': typeof PrivateRoutesInfluencerIdProfileIndexRoute
  '/_private-routes/marketplace/$id/posts/': typeof PrivateRoutesMarketplaceIdPostsIndexRoute
  '/_private-routes/marketplace/add/e-commerce/': typeof PrivateRoutesMarketplaceAddECommerceIndexRoute
  '/_private-routes/package/$id/content/': typeof PrivateRoutesPackageIdContentIndexRoute
  '/_private-routes/tiktok/ad-campaign-report/$id/': typeof PrivateRoutesTiktokAdCampaignReportIdIndexRoute
  '/_private-routes/tiktok/campaigns/$id/': typeof PrivateRoutesTiktokCampaignsIdIndexRoute
  '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/hashtag': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdHashtagRoute
  '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/trend': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdTrendRoute
  '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/ugc': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdUgcRoute
  '/_private-routes/influencer/$id/$socialMediaAccountId/youtube_compare_feed_videos/$compareId': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_compare_feed_videosCompareIdRoute
  '/_private-routes/package/$id/content/search/douyin': typeof PrivateRoutesPackageIdContentSearchDouyinRoute
  '/_private-routes/package/$id/content/search/facebook': typeof PrivateRoutesPackageIdContentSearchFacebookRoute
  '/_private-routes/package/$id/content/search/facebook_page': typeof PrivateRoutesPackageIdContentSearchFacebook_pageRoute
  '/_private-routes/package/$id/content/search/instagram': typeof PrivateRoutesPackageIdContentSearchInstagramRoute
  '/_private-routes/package/$id/content/search/threads': typeof PrivateRoutesPackageIdContentSearchThreadsRoute
  '/_private-routes/package/$id/content/search/tiktok': typeof PrivateRoutesPackageIdContentSearchTiktokRoute
  '/_private-routes/package/$id/content/search/twitter': typeof PrivateRoutesPackageIdContentSearchTwitterRoute
  '/_private-routes/package/$id/content/search/xhs': typeof PrivateRoutesPackageIdContentSearchXhsRoute
  '/_private-routes/package/$id/content/search/youtube': typeof PrivateRoutesPackageIdContentSearchYoutubeRoute
  '/_private-routes/tiktok/campaigns/$id/posts/$postId': typeof PrivateRoutesTiktokCampaignsIdPostsPostIdRoute
  '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdIndexRoute
  '/_private-routes/influencer/$id/$socialMediaAccountId/youtube_compare_feed_videos/': typeof PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_compare_feed_videosIndexRoute
  '/_private-routes/package/$id/content/search/': typeof PrivateRoutesPackageIdContentSearchIndexRoute
  '/_private-routes/tiktok/campaigns/$id/posts/': typeof PrivateRoutesTiktokCampaignsIdPostsIndexRoute
  '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/compare/instagram_compare_feed_post': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdCompareInstagram_compare_feed_postRoute
  '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/compare/youtube_compare_feed_videos': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdCompareYoutube_compare_feed_videosRoute
  '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/facebook_feed_post': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardFacebook_feed_postRoute
  '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/feed_videos': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardFeed_videosRoute
  '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/instagram_comments': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_commentsRoute
  '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/instagram_feed_post': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_feed_postRoute
  '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/instagram_reel_post': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_reel_postRoute
  '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/instagram_story_post': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_story_postRoute
  '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/shorts': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardShortsRoute
  '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/tag_ranking_list': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardTag_ranking_listRoute
  '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/twitter_feed_posts': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardTwitter_feed_postsRoute
  '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/youtube_comments': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardYoutube_commentsRoute
  '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/interaction/brand-ambassadors': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionBrandAmbassadorsRoute
  '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/interaction/mentioned_posts': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionMentioned_postsRoute
  '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/interaction/tagged_posts': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionTagged_postsRoute
  '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/compare/': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdCompareIndexRoute
  '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardIndexRoute
  '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/interaction/': typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/not-found'
    | '/advertiser'
    | '/agency'
    | '/analytics'
    | '/asset-preview'
    | '/auto-managed'
    | '/campaign-posts-discovery'
    | '/hashtag-analytics'
    | '/influencer'
    | '/influencers'
    | '/package'
    | '/partner'
    | '/payments'
    | '/posts'
    | '/posts-insight'
    | '/report'
    | '/settings'
    | '/talent-agency'
    | '/tiktok'
    | '/tools'
    | '/trending'
    | '/user'
    | '/user-settings'
    | '/youtube-cms'
    | '/privacy'
    | '/redirect_to'
    | '/sign-in'
    | '/terms'
    | '/terms-combined'
    | '/tiktok-onboarding'
    | '/access/authorized'
    | '/access/declined'
    | '/advertiser/$id'
    | '/advertiser/add'
    | '/agency/$id'
    | '/agency/add'
    | '/analytics/add'
    | '/auto-managed/$id'
    | '/engagement/$id'
    | '/engagement/add'
    | '/hashtag-analytics/instagram'
    | '/hashtag-analytics/tiktok'
    | '/influencer/$id'
    | '/influencer/add'
    | '/influencers/proposal'
    | '/influencers/search'
    | '/marketplace/$id'
    | '/marketplace/add'
    | '/marketplace/reorder'
    | '/package/$id'
    | '/package/add'
    | '/partner/$id'
    | '/posts-insight/$id'
    | '/redirect/google-auth'
    | '/talent-agency/$id'
    | '/talent-agency/add'
    | '/tiktok/ad-accounts'
    | '/tiktok/ad-campaign-report'
    | '/tiktok/advertiser-details'
    | '/tiktok/budget-allocation'
    | '/tiktok/campaigns'
    | '/tiktok/failed-payment'
    | '/tiktok/subscription-billing'
    | '/tools/video-comp-ai'
    | '/trending/influencers'
    | '/trending/posts'
    | '/user/$id'
    | '/user/add'
    | '/user/linked'
    | '/youtube-cms/invoices'
    | '/youtube-cms/revenue'
    | '/password_forgot'
    | '/egg/referral'
    | '/mkp/referral'
    | '/sign-up/success'
    | '/tiktok-onboarding/ad-account'
    | '/tiktok-onboarding/password-enter'
    | '/tiktok-onboarding/select-plan'
    | '/tiktok-onboarding/success'
    | '/access'
    | '/advertiser/'
    | '/agency/'
    | '/analytics/'
    | '/auto-managed/'
    | '/engagement'
    | '/hashtag-analytics/'
    | '/influencer/'
    | '/influencers/'
    | '/marketplace'
    | '/package/'
    | '/partner/'
    | '/posts-insight/'
    | '/prompts'
    | '/talent-agency/'
    | '/tools/'
    | '/trending/'
    | '/user/'
    | '/youtube-cms/'
    | '/sign-up'
    | '/tiktok-onboarding/'
    | '/advertiser/$id/budget-allocation'
    | '/advertiser/$id/users'
    | '/agency/$id/business'
    | '/agency/$id/users'
    | '/auto-managed/$id/commissions'
    | '/auto-managed/$id/joined-influencers'
    | '/auto-managed/$id/report'
    | '/engagement/$id/influencer'
    | '/engagement/$id/posts'
    | '/engagement/$id/proposal'
    | '/engagement/$id/report'
    | '/engagement/$id/tracking'
    | '/engagement/$id/tracking-referral-codes'
    | '/hashtag-analytics/instagram/$countryId'
    | '/hashtag-analytics/tiktok/hashtag'
    | '/hashtag-analytics/tiktok/keyword'
    | '/influencer/$id/profile'
    | '/influencers/search/douyin'
    | '/influencers/search/facebook'
    | '/influencers/search/facebook_page'
    | '/influencers/search/instagram'
    | '/influencers/search/threads'
    | '/influencers/search/tiktok'
    | '/influencers/search/twitter'
    | '/influencers/search/xhs'
    | '/influencers/search/youtube'
    | '/marketplace/$id/applicant'
    | '/marketplace/$id/commissions'
    | '/marketplace/$id/influencer'
    | '/marketplace/$id/joined-influencers'
    | '/marketplace/$id/posts'
    | '/marketplace/$id/report'
    | '/marketplace/$id/report-affiliate'
    | '/marketplace/$id/tracking'
    | '/marketplace/$id/tracking-referral-codes'
    | '/marketplace/add/referral-code-tracking'
    | '/marketplace/add/social-media-tracking'
    | '/marketplace/add/url-tracking'
    | '/package/$id/content'
    | '/partner/$id/business'
    | '/partner/$id/users'
    | '/posts-insight/$id/$postId'
    | '/redirect/analytics-connect/$provider'
    | '/redirect/analytics-list-connect/$provider'
    | '/redirect/analytics-signin/$provider'
    | '/redirect/connect/tiktok-business'
    | '/redirect/hidden/youtube-list-connect'
    | '/redirect/talent-analytics-connect/$provider'
    | '/redirect/talent-signin/$provider'
    | '/talent-agency/$id/business'
    | '/talent-agency/$id/users'
    | '/tiktok/campaigns/$id'
    | '/tiktok/campaigns/add'
    | '/tiktok/campaigns/review-influencers'
    | '/youtube-cms/revenue/$cmsChannelId'
    | '/youtube-cms/revenue/confirmed'
    | '/password_register/$token'
    | '/password_reset/$token'
    | '/tiktok-onboarding/password-register/$token'
    | '/advertiser/$id/'
    | '/agency/$id/'
    | '/analytics/$brandAccountId'
    | '/auto-managed/$id/'
    | '/engagement/$id/'
    | '/hashtag-analytics/instagram/'
    | '/hashtag-analytics/tiktok/'
    | '/influencer/$id/'
    | '/influencers/search/'
    | '/marketplace/$id/'
    | '/marketplace/add/'
    | '/package/$id/'
    | '/partner/$id/'
    | '/talent-agency/$id/'
    | '/tiktok/ad-campaign-report/'
    | '/tiktok/campaigns/'
    | '/youtube-cms/revenue/'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId'
    | '/engagement/$id/influencer/campaigns'
    | '/engagement/$id/influencer/douyin'
    | '/engagement/$id/influencer/facebook'
    | '/engagement/$id/influencer/facebook_page'
    | '/engagement/$id/influencer/instagram'
    | '/engagement/$id/influencer/packages'
    | '/engagement/$id/influencer/posts'
    | '/engagement/$id/influencer/threads'
    | '/engagement/$id/influencer/tiktok'
    | '/engagement/$id/influencer/twitter'
    | '/engagement/$id/influencer/xhs'
    | '/engagement/$id/influencer/youtube'
    | '/engagement/$id/posts/$postId'
    | '/engagement/$id/posts/add'
    | '/hashtag-analytics/tiktok/hashtag/$countryId'
    | '/hashtag-analytics/tiktok/keyword/$countryId'
    | '/influencer/$id/$socialMediaAccountId/facebook_feed_post'
    | '/influencer/$id/$socialMediaAccountId/feed_videos'
    | '/influencer/$id/$socialMediaAccountId/instagram_feed_post'
    | '/influencer/$id/$socialMediaAccountId/instagram_reel_post'
    | '/influencer/$id/$socialMediaAccountId/instagram_story_post'
    | '/influencer/$id/$socialMediaAccountId/scraping_feed_posts'
    | '/influencer/$id/$socialMediaAccountId/shorts'
    | '/influencer/$id/$socialMediaAccountId/sponsored_feed_posts'
    | '/influencer/$id/$socialMediaAccountId/sponsored_youtube_feed_posts'
    | '/influencer/$id/$socialMediaAccountId/twitter_feed_posts'
    | '/influencer/$id/$socialMediaAccountId/xhs_picture_posts'
    | '/influencer/$id/$socialMediaAccountId/xhs_video_posts'
    | '/influencer/$id/$socialMediaAccountId/youtube_compare_feed_videos'
    | '/influencer/$id/$socialMediaAccountId/youtube_tags_ranking'
    | '/influencer/$id/profile/campaigns'
    | '/influencer/$id/profile/compare'
    | '/marketplace/$id/posts/$postId'
    | '/marketplace/add/e-commerce/$autoMangedCampaignId'
    | '/package/$id/content/list'
    | '/package/$id/content/search'
    | '/tiktok/ad-campaign-report/$id/$groupId'
    | '/tiktok/campaigns/$id/influencers'
    | '/tiktok/campaigns/$id/posts'
    | '/tiktok/campaigns/$id/report'
    | '/engagement/$id/influencer/'
    | '/engagement/$id/posts/'
    | '/hashtag-analytics/tiktok/hashtag/'
    | '/hashtag-analytics/tiktok/keyword/'
    | '/influencer/$id/profile/'
    | '/marketplace/$id/posts/'
    | '/marketplace/add/e-commerce'
    | '/package/$id/content/'
    | '/tiktok/ad-campaign-report/$id'
    | '/tiktok/campaigns/$id/'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/hashtag'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/trend'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/ugc'
    | '/influencer/$id/$socialMediaAccountId/youtube_compare_feed_videos/$compareId'
    | '/package/$id/content/search/douyin'
    | '/package/$id/content/search/facebook'
    | '/package/$id/content/search/facebook_page'
    | '/package/$id/content/search/instagram'
    | '/package/$id/content/search/threads'
    | '/package/$id/content/search/tiktok'
    | '/package/$id/content/search/twitter'
    | '/package/$id/content/search/xhs'
    | '/package/$id/content/search/youtube'
    | '/tiktok/campaigns/$id/posts/$postId'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/'
    | '/influencer/$id/$socialMediaAccountId/youtube_compare_feed_videos/'
    | '/package/$id/content/search/'
    | '/tiktok/campaigns/$id/posts/'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/compare/instagram_compare_feed_post'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/compare/youtube_compare_feed_videos'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/facebook_feed_post'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/feed_videos'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/instagram_comments'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/instagram_feed_post'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/instagram_reel_post'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/instagram_story_post'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/shorts'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/tag_ranking_list'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/twitter_feed_posts'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/youtube_comments'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/interaction/brand-ambassadors'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/interaction/mentioned_posts'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/interaction/tagged_posts'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/compare'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/interaction'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/not-found'
    | '/asset-preview'
    | '/campaign-posts-discovery'
    | '/payments'
    | '/posts'
    | '/report'
    | '/settings'
    | '/tiktok'
    | '/user-settings'
    | '/privacy'
    | '/redirect_to'
    | '/sign-in'
    | '/terms'
    | '/terms-combined'
    | '/access/authorized'
    | '/access/declined'
    | '/advertiser/add'
    | '/agency/add'
    | '/analytics/add'
    | '/engagement/add'
    | '/influencer/add'
    | '/influencers/proposal'
    | '/marketplace/reorder'
    | '/package/add'
    | '/posts-insight/$id'
    | '/redirect/google-auth'
    | '/talent-agency/add'
    | '/tiktok/ad-accounts'
    | '/tiktok/advertiser-details'
    | '/tiktok/budget-allocation'
    | '/tiktok/failed-payment'
    | '/tiktok/subscription-billing'
    | '/tools/video-comp-ai'
    | '/trending/influencers'
    | '/trending/posts'
    | '/user/$id'
    | '/user/add'
    | '/user/linked'
    | '/youtube-cms/invoices'
    | '/password_forgot'
    | '/egg/referral'
    | '/mkp/referral'
    | '/sign-up/success'
    | '/tiktok-onboarding/ad-account'
    | '/tiktok-onboarding/password-enter'
    | '/tiktok-onboarding/select-plan'
    | '/tiktok-onboarding/success'
    | '/access'
    | '/advertiser'
    | '/agency'
    | '/analytics'
    | '/auto-managed'
    | '/engagement'
    | '/hashtag-analytics'
    | '/influencer'
    | '/influencers'
    | '/marketplace'
    | '/package'
    | '/partner'
    | '/posts-insight'
    | '/prompts'
    | '/talent-agency'
    | '/tools'
    | '/trending'
    | '/user'
    | '/youtube-cms'
    | '/sign-up'
    | '/tiktok-onboarding'
    | '/advertiser/$id/budget-allocation'
    | '/advertiser/$id/users'
    | '/agency/$id/business'
    | '/agency/$id/users'
    | '/auto-managed/$id/commissions'
    | '/auto-managed/$id/joined-influencers'
    | '/auto-managed/$id/report'
    | '/engagement/$id/proposal'
    | '/engagement/$id/report'
    | '/engagement/$id/tracking'
    | '/engagement/$id/tracking-referral-codes'
    | '/hashtag-analytics/instagram/$countryId'
    | '/influencers/search/douyin'
    | '/influencers/search/facebook'
    | '/influencers/search/facebook_page'
    | '/influencers/search/instagram'
    | '/influencers/search/threads'
    | '/influencers/search/tiktok'
    | '/influencers/search/twitter'
    | '/influencers/search/xhs'
    | '/influencers/search/youtube'
    | '/marketplace/$id/applicant'
    | '/marketplace/$id/commissions'
    | '/marketplace/$id/influencer'
    | '/marketplace/$id/joined-influencers'
    | '/marketplace/$id/report'
    | '/marketplace/$id/report-affiliate'
    | '/marketplace/$id/tracking'
    | '/marketplace/$id/tracking-referral-codes'
    | '/marketplace/add/referral-code-tracking'
    | '/marketplace/add/social-media-tracking'
    | '/marketplace/add/url-tracking'
    | '/partner/$id/business'
    | '/partner/$id/users'
    | '/posts-insight/$id/$postId'
    | '/redirect/analytics-connect/$provider'
    | '/redirect/analytics-list-connect/$provider'
    | '/redirect/analytics-signin/$provider'
    | '/redirect/connect/tiktok-business'
    | '/redirect/hidden/youtube-list-connect'
    | '/redirect/talent-analytics-connect/$provider'
    | '/redirect/talent-signin/$provider'
    | '/talent-agency/$id/business'
    | '/talent-agency/$id/users'
    | '/tiktok/campaigns/add'
    | '/tiktok/campaigns/review-influencers'
    | '/youtube-cms/revenue/$cmsChannelId'
    | '/youtube-cms/revenue/confirmed'
    | '/password_register/$token'
    | '/password_reset/$token'
    | '/tiktok-onboarding/password-register/$token'
    | '/advertiser/$id'
    | '/agency/$id'
    | '/analytics/$brandAccountId'
    | '/auto-managed/$id'
    | '/engagement/$id'
    | '/hashtag-analytics/instagram'
    | '/hashtag-analytics/tiktok'
    | '/influencer/$id'
    | '/influencers/search'
    | '/marketplace/$id'
    | '/marketplace/add'
    | '/package/$id'
    | '/partner/$id'
    | '/talent-agency/$id'
    | '/tiktok/ad-campaign-report'
    | '/tiktok/campaigns'
    | '/youtube-cms/revenue'
    | '/engagement/$id/influencer/campaigns'
    | '/engagement/$id/influencer/douyin'
    | '/engagement/$id/influencer/facebook'
    | '/engagement/$id/influencer/facebook_page'
    | '/engagement/$id/influencer/instagram'
    | '/engagement/$id/influencer/packages'
    | '/engagement/$id/influencer/posts'
    | '/engagement/$id/influencer/threads'
    | '/engagement/$id/influencer/tiktok'
    | '/engagement/$id/influencer/twitter'
    | '/engagement/$id/influencer/xhs'
    | '/engagement/$id/influencer/youtube'
    | '/engagement/$id/posts/$postId'
    | '/engagement/$id/posts/add'
    | '/hashtag-analytics/tiktok/hashtag/$countryId'
    | '/hashtag-analytics/tiktok/keyword/$countryId'
    | '/influencer/$id/$socialMediaAccountId/facebook_feed_post'
    | '/influencer/$id/$socialMediaAccountId/feed_videos'
    | '/influencer/$id/$socialMediaAccountId/instagram_feed_post'
    | '/influencer/$id/$socialMediaAccountId/instagram_reel_post'
    | '/influencer/$id/$socialMediaAccountId/instagram_story_post'
    | '/influencer/$id/$socialMediaAccountId/scraping_feed_posts'
    | '/influencer/$id/$socialMediaAccountId/shorts'
    | '/influencer/$id/$socialMediaAccountId/sponsored_feed_posts'
    | '/influencer/$id/$socialMediaAccountId/sponsored_youtube_feed_posts'
    | '/influencer/$id/$socialMediaAccountId/twitter_feed_posts'
    | '/influencer/$id/$socialMediaAccountId/xhs_picture_posts'
    | '/influencer/$id/$socialMediaAccountId/xhs_video_posts'
    | '/influencer/$id/$socialMediaAccountId/youtube_tags_ranking'
    | '/influencer/$id/profile/campaigns'
    | '/influencer/$id/profile/compare'
    | '/marketplace/$id/posts/$postId'
    | '/marketplace/add/e-commerce/$autoMangedCampaignId'
    | '/package/$id/content/list'
    | '/tiktok/ad-campaign-report/$id/$groupId'
    | '/tiktok/campaigns/$id/influencers'
    | '/tiktok/campaigns/$id/report'
    | '/engagement/$id/influencer'
    | '/engagement/$id/posts'
    | '/hashtag-analytics/tiktok/hashtag'
    | '/hashtag-analytics/tiktok/keyword'
    | '/influencer/$id/profile'
    | '/marketplace/$id/posts'
    | '/marketplace/add/e-commerce'
    | '/package/$id/content'
    | '/tiktok/ad-campaign-report/$id'
    | '/tiktok/campaigns/$id'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/hashtag'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/trend'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/ugc'
    | '/influencer/$id/$socialMediaAccountId/youtube_compare_feed_videos/$compareId'
    | '/package/$id/content/search/douyin'
    | '/package/$id/content/search/facebook'
    | '/package/$id/content/search/facebook_page'
    | '/package/$id/content/search/instagram'
    | '/package/$id/content/search/threads'
    | '/package/$id/content/search/tiktok'
    | '/package/$id/content/search/twitter'
    | '/package/$id/content/search/xhs'
    | '/package/$id/content/search/youtube'
    | '/tiktok/campaigns/$id/posts/$postId'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId'
    | '/influencer/$id/$socialMediaAccountId/youtube_compare_feed_videos'
    | '/package/$id/content/search'
    | '/tiktok/campaigns/$id/posts'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/compare/instagram_compare_feed_post'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/compare/youtube_compare_feed_videos'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/facebook_feed_post'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/feed_videos'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/instagram_comments'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/instagram_feed_post'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/instagram_reel_post'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/instagram_story_post'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/shorts'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/tag_ranking_list'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/twitter_feed_posts'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/youtube_comments'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/interaction/brand-ambassadors'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/interaction/mentioned_posts'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/interaction/tagged_posts'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/compare'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard'
    | '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/interaction'
  id:
    | '__root__'
    | '/'
    | '/_private-routes'
    | '/_public-routes'
    | '/not-found'
    | '/_private-routes/advertiser'
    | '/_private-routes/agency'
    | '/_private-routes/analytics'
    | '/_private-routes/asset-preview'
    | '/_private-routes/auto-managed'
    | '/_private-routes/campaign-posts-discovery'
    | '/_private-routes/hashtag-analytics'
    | '/_private-routes/influencer'
    | '/_private-routes/influencers'
    | '/_private-routes/package'
    | '/_private-routes/partner'
    | '/_private-routes/payments'
    | '/_private-routes/posts'
    | '/_private-routes/posts-insight'
    | '/_private-routes/report'
    | '/_private-routes/settings'
    | '/_private-routes/talent-agency'
    | '/_private-routes/tiktok'
    | '/_private-routes/tools'
    | '/_private-routes/trending'
    | '/_private-routes/user'
    | '/_private-routes/user-settings'
    | '/_private-routes/youtube-cms'
    | '/_public-routes/privacy'
    | '/_public-routes/redirect_to'
    | '/_public-routes/sign-in'
    | '/_public-routes/terms'
    | '/_public-routes/terms-combined'
    | '/_public-routes/tiktok-onboarding'
    | '/_private-routes/access/authorized'
    | '/_private-routes/access/declined'
    | '/_private-routes/advertiser/$id'
    | '/_private-routes/advertiser/add'
    | '/_private-routes/agency/$id'
    | '/_private-routes/agency/add'
    | '/_private-routes/analytics/add'
    | '/_private-routes/auto-managed/$id'
    | '/_private-routes/engagement/$id'
    | '/_private-routes/engagement/add'
    | '/_private-routes/hashtag-analytics/instagram'
    | '/_private-routes/hashtag-analytics/tiktok'
    | '/_private-routes/influencer/$id'
    | '/_private-routes/influencer/add'
    | '/_private-routes/influencers/proposal'
    | '/_private-routes/influencers/search'
    | '/_private-routes/marketplace/$id'
    | '/_private-routes/marketplace/add'
    | '/_private-routes/marketplace/reorder'
    | '/_private-routes/package/$id'
    | '/_private-routes/package/add'
    | '/_private-routes/partner/$id'
    | '/_private-routes/posts-insight/$id'
    | '/_private-routes/redirect/google-auth'
    | '/_private-routes/talent-agency/$id'
    | '/_private-routes/talent-agency/add'
    | '/_private-routes/tiktok/ad-accounts'
    | '/_private-routes/tiktok/ad-campaign-report'
    | '/_private-routes/tiktok/advertiser-details'
    | '/_private-routes/tiktok/budget-allocation'
    | '/_private-routes/tiktok/campaigns'
    | '/_private-routes/tiktok/failed-payment'
    | '/_private-routes/tiktok/subscription-billing'
    | '/_private-routes/tools/video-comp-ai'
    | '/_private-routes/trending/influencers'
    | '/_private-routes/trending/posts'
    | '/_private-routes/user/$id'
    | '/_private-routes/user/add'
    | '/_private-routes/user/linked'
    | '/_private-routes/youtube-cms/invoices'
    | '/_private-routes/youtube-cms/revenue'
    | '/_public-routes/_password/password_forgot'
    | '/_public-routes/egg/referral'
    | '/_public-routes/mkp/referral'
    | '/_public-routes/sign-up/success'
    | '/_public-routes/tiktok-onboarding/ad-account'
    | '/_public-routes/tiktok-onboarding/password-enter'
    | '/_public-routes/tiktok-onboarding/select-plan'
    | '/_public-routes/tiktok-onboarding/success'
    | '/_private-routes/access/'
    | '/_private-routes/advertiser/'
    | '/_private-routes/agency/'
    | '/_private-routes/analytics/'
    | '/_private-routes/auto-managed/'
    | '/_private-routes/engagement/'
    | '/_private-routes/hashtag-analytics/'
    | '/_private-routes/influencer/'
    | '/_private-routes/influencers/'
    | '/_private-routes/marketplace/'
    | '/_private-routes/package/'
    | '/_private-routes/partner/'
    | '/_private-routes/posts-insight/'
    | '/_private-routes/prompts/'
    | '/_private-routes/talent-agency/'
    | '/_private-routes/tools/'
    | '/_private-routes/trending/'
    | '/_private-routes/user/'
    | '/_private-routes/youtube-cms/'
    | '/_public-routes/sign-up/'
    | '/_public-routes/tiktok-onboarding/'
    | '/_private-routes/advertiser/$id/budget-allocation'
    | '/_private-routes/advertiser/$id/users'
    | '/_private-routes/agency/$id/business'
    | '/_private-routes/agency/$id/users'
    | '/_private-routes/auto-managed/$id/commissions'
    | '/_private-routes/auto-managed/$id/joined-influencers'
    | '/_private-routes/auto-managed/$id/report'
    | '/_private-routes/engagement/$id/influencer'
    | '/_private-routes/engagement/$id/posts'
    | '/_private-routes/engagement/$id/proposal'
    | '/_private-routes/engagement/$id/report'
    | '/_private-routes/engagement/$id/tracking'
    | '/_private-routes/engagement/$id/tracking-referral-codes'
    | '/_private-routes/hashtag-analytics/instagram/$countryId'
    | '/_private-routes/hashtag-analytics/tiktok/hashtag'
    | '/_private-routes/hashtag-analytics/tiktok/keyword'
    | '/_private-routes/influencer/$id/profile'
    | '/_private-routes/influencers/search/douyin'
    | '/_private-routes/influencers/search/facebook'
    | '/_private-routes/influencers/search/facebook_page'
    | '/_private-routes/influencers/search/instagram'
    | '/_private-routes/influencers/search/threads'
    | '/_private-routes/influencers/search/tiktok'
    | '/_private-routes/influencers/search/twitter'
    | '/_private-routes/influencers/search/xhs'
    | '/_private-routes/influencers/search/youtube'
    | '/_private-routes/marketplace/$id/applicant'
    | '/_private-routes/marketplace/$id/commissions'
    | '/_private-routes/marketplace/$id/influencer'
    | '/_private-routes/marketplace/$id/joined-influencers'
    | '/_private-routes/marketplace/$id/posts'
    | '/_private-routes/marketplace/$id/report'
    | '/_private-routes/marketplace/$id/report-affiliate'
    | '/_private-routes/marketplace/$id/tracking'
    | '/_private-routes/marketplace/$id/tracking-referral-codes'
    | '/_private-routes/marketplace/add/referral-code-tracking'
    | '/_private-routes/marketplace/add/social-media-tracking'
    | '/_private-routes/marketplace/add/url-tracking'
    | '/_private-routes/package/$id/content'
    | '/_private-routes/partner/$id/business'
    | '/_private-routes/partner/$id/users'
    | '/_private-routes/posts-insight/$id/$postId'
    | '/_private-routes/redirect/analytics-connect/$provider'
    | '/_private-routes/redirect/analytics-list-connect/$provider'
    | '/_private-routes/redirect/analytics-signin/$provider'
    | '/_private-routes/redirect/connect/tiktok-business'
    | '/_private-routes/redirect/hidden/youtube-list-connect'
    | '/_private-routes/redirect/talent-analytics-connect/$provider'
    | '/_private-routes/redirect/talent-signin/$provider'
    | '/_private-routes/talent-agency/$id/business'
    | '/_private-routes/talent-agency/$id/users'
    | '/_private-routes/tiktok/campaigns/$id'
    | '/_private-routes/tiktok/campaigns/add'
    | '/_private-routes/tiktok/campaigns/review-influencers'
    | '/_private-routes/youtube-cms/revenue/$cmsChannelId'
    | '/_private-routes/youtube-cms/revenue/confirmed'
    | '/_public-routes/_password/password_register/$token'
    | '/_public-routes/_password/password_reset/$token'
    | '/_public-routes/tiktok-onboarding/password-register/$token'
    | '/_private-routes/advertiser/$id/'
    | '/_private-routes/agency/$id/'
    | '/_private-routes/analytics/$brandAccountId/'
    | '/_private-routes/auto-managed/$id/'
    | '/_private-routes/engagement/$id/'
    | '/_private-routes/hashtag-analytics/instagram/'
    | '/_private-routes/hashtag-analytics/tiktok/'
    | '/_private-routes/influencer/$id/'
    | '/_private-routes/influencers/search/'
    | '/_private-routes/marketplace/$id/'
    | '/_private-routes/marketplace/add/'
    | '/_private-routes/package/$id/'
    | '/_private-routes/partner/$id/'
    | '/_private-routes/talent-agency/$id/'
    | '/_private-routes/tiktok/ad-campaign-report/'
    | '/_private-routes/tiktok/campaigns/'
    | '/_private-routes/youtube-cms/revenue/'
    | '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId'
    | '/_private-routes/engagement/$id/influencer/campaigns'
    | '/_private-routes/engagement/$id/influencer/douyin'
    | '/_private-routes/engagement/$id/influencer/facebook'
    | '/_private-routes/engagement/$id/influencer/facebook_page'
    | '/_private-routes/engagement/$id/influencer/instagram'
    | '/_private-routes/engagement/$id/influencer/packages'
    | '/_private-routes/engagement/$id/influencer/posts'
    | '/_private-routes/engagement/$id/influencer/threads'
    | '/_private-routes/engagement/$id/influencer/tiktok'
    | '/_private-routes/engagement/$id/influencer/twitter'
    | '/_private-routes/engagement/$id/influencer/xhs'
    | '/_private-routes/engagement/$id/influencer/youtube'
    | '/_private-routes/engagement/$id/posts/$postId'
    | '/_private-routes/engagement/$id/posts/add'
    | '/_private-routes/hashtag-analytics/tiktok/hashtag/$countryId'
    | '/_private-routes/hashtag-analytics/tiktok/keyword/$countryId'
    | '/_private-routes/influencer/$id/$socialMediaAccountId/facebook_feed_post'
    | '/_private-routes/influencer/$id/$socialMediaAccountId/feed_videos'
    | '/_private-routes/influencer/$id/$socialMediaAccountId/instagram_feed_post'
    | '/_private-routes/influencer/$id/$socialMediaAccountId/instagram_reel_post'
    | '/_private-routes/influencer/$id/$socialMediaAccountId/instagram_story_post'
    | '/_private-routes/influencer/$id/$socialMediaAccountId/scraping_feed_posts'
    | '/_private-routes/influencer/$id/$socialMediaAccountId/shorts'
    | '/_private-routes/influencer/$id/$socialMediaAccountId/sponsored_feed_posts'
    | '/_private-routes/influencer/$id/$socialMediaAccountId/sponsored_youtube_feed_posts'
    | '/_private-routes/influencer/$id/$socialMediaAccountId/twitter_feed_posts'
    | '/_private-routes/influencer/$id/$socialMediaAccountId/xhs_picture_posts'
    | '/_private-routes/influencer/$id/$socialMediaAccountId/xhs_video_posts'
    | '/_private-routes/influencer/$id/$socialMediaAccountId/youtube_compare_feed_videos'
    | '/_private-routes/influencer/$id/$socialMediaAccountId/youtube_tags_ranking'
    | '/_private-routes/influencer/$id/profile/campaigns'
    | '/_private-routes/influencer/$id/profile/compare'
    | '/_private-routes/marketplace/$id/posts/$postId'
    | '/_private-routes/marketplace/add/e-commerce/$autoMangedCampaignId'
    | '/_private-routes/package/$id/content/list'
    | '/_private-routes/package/$id/content/search'
    | '/_private-routes/tiktok/ad-campaign-report/$id/$groupId'
    | '/_private-routes/tiktok/campaigns/$id/influencers'
    | '/_private-routes/tiktok/campaigns/$id/posts'
    | '/_private-routes/tiktok/campaigns/$id/report'
    | '/_private-routes/engagement/$id/influencer/'
    | '/_private-routes/engagement/$id/posts/'
    | '/_private-routes/hashtag-analytics/tiktok/hashtag/'
    | '/_private-routes/hashtag-analytics/tiktok/keyword/'
    | '/_private-routes/influencer/$id/profile/'
    | '/_private-routes/marketplace/$id/posts/'
    | '/_private-routes/marketplace/add/e-commerce/'
    | '/_private-routes/package/$id/content/'
    | '/_private-routes/tiktok/ad-campaign-report/$id/'
    | '/_private-routes/tiktok/campaigns/$id/'
    | '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/hashtag'
    | '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/trend'
    | '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/ugc'
    | '/_private-routes/influencer/$id/$socialMediaAccountId/youtube_compare_feed_videos/$compareId'
    | '/_private-routes/package/$id/content/search/douyin'
    | '/_private-routes/package/$id/content/search/facebook'
    | '/_private-routes/package/$id/content/search/facebook_page'
    | '/_private-routes/package/$id/content/search/instagram'
    | '/_private-routes/package/$id/content/search/threads'
    | '/_private-routes/package/$id/content/search/tiktok'
    | '/_private-routes/package/$id/content/search/twitter'
    | '/_private-routes/package/$id/content/search/xhs'
    | '/_private-routes/package/$id/content/search/youtube'
    | '/_private-routes/tiktok/campaigns/$id/posts/$postId'
    | '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/'
    | '/_private-routes/influencer/$id/$socialMediaAccountId/youtube_compare_feed_videos/'
    | '/_private-routes/package/$id/content/search/'
    | '/_private-routes/tiktok/campaigns/$id/posts/'
    | '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/compare/instagram_compare_feed_post'
    | '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/compare/youtube_compare_feed_videos'
    | '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/facebook_feed_post'
    | '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/feed_videos'
    | '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/instagram_comments'
    | '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/instagram_feed_post'
    | '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/instagram_reel_post'
    | '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/instagram_story_post'
    | '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/shorts'
    | '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/tag_ranking_list'
    | '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/twitter_feed_posts'
    | '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/youtube_comments'
    | '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/interaction/brand-ambassadors'
    | '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/interaction/mentioned_posts'
    | '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/interaction/tagged_posts'
    | '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/compare/'
    | '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/'
    | '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/interaction/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  PrivateRoutesRoute: typeof PrivateRoutesRouteWithChildren
  PublicRoutesRoute: typeof PublicRoutesRouteWithChildren
  NotFoundRoute: typeof NotFoundRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/not-found': {
      id: '/not-found'
      path: '/not-found'
      fullPath: '/not-found'
      preLoaderRoute: typeof NotFoundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public-routes': {
      id: '/_public-routes'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicRoutesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_private-routes': {
      id: '/_private-routes'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PrivateRoutesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public-routes/tiktok-onboarding': {
      id: '/_public-routes/tiktok-onboarding'
      path: '/tiktok-onboarding'
      fullPath: '/tiktok-onboarding'
      preLoaderRoute: typeof PublicRoutesTiktokOnboardingRouteImport
      parentRoute: typeof PublicRoutesRoute
    }
    '/_public-routes/terms-combined': {
      id: '/_public-routes/terms-combined'
      path: '/terms-combined'
      fullPath: '/terms-combined'
      preLoaderRoute: typeof PublicRoutesTermsCombinedRouteImport
      parentRoute: typeof PublicRoutesRoute
    }
    '/_public-routes/terms': {
      id: '/_public-routes/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof PublicRoutesTermsRouteImport
      parentRoute: typeof PublicRoutesRoute
    }
    '/_public-routes/sign-in': {
      id: '/_public-routes/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof PublicRoutesSignInRouteImport
      parentRoute: typeof PublicRoutesRoute
    }
    '/_public-routes/redirect_to': {
      id: '/_public-routes/redirect_to'
      path: '/redirect_to'
      fullPath: '/redirect_to'
      preLoaderRoute: typeof PublicRoutesRedirect_toRouteImport
      parentRoute: typeof PublicRoutesRoute
    }
    '/_public-routes/privacy': {
      id: '/_public-routes/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PublicRoutesPrivacyRouteImport
      parentRoute: typeof PublicRoutesRoute
    }
    '/_private-routes/youtube-cms': {
      id: '/_private-routes/youtube-cms'
      path: '/youtube-cms'
      fullPath: '/youtube-cms'
      preLoaderRoute: typeof PrivateRoutesYoutubeCmsRouteImport
      parentRoute: typeof PrivateRoutesRoute
    }
    '/_private-routes/user-settings': {
      id: '/_private-routes/user-settings'
      path: '/user-settings'
      fullPath: '/user-settings'
      preLoaderRoute: typeof PrivateRoutesUserSettingsRouteImport
      parentRoute: typeof PrivateRoutesRoute
    }
    '/_private-routes/user': {
      id: '/_private-routes/user'
      path: '/user'
      fullPath: '/user'
      preLoaderRoute: typeof PrivateRoutesUserRouteImport
      parentRoute: typeof PrivateRoutesRoute
    }
    '/_private-routes/trending': {
      id: '/_private-routes/trending'
      path: '/trending'
      fullPath: '/trending'
      preLoaderRoute: typeof PrivateRoutesTrendingRouteImport
      parentRoute: typeof PrivateRoutesRoute
    }
    '/_private-routes/tools': {
      id: '/_private-routes/tools'
      path: '/tools'
      fullPath: '/tools'
      preLoaderRoute: typeof PrivateRoutesToolsRouteImport
      parentRoute: typeof PrivateRoutesRoute
    }
    '/_private-routes/tiktok': {
      id: '/_private-routes/tiktok'
      path: '/tiktok'
      fullPath: '/tiktok'
      preLoaderRoute: typeof PrivateRoutesTiktokRouteImport
      parentRoute: typeof PrivateRoutesRoute
    }
    '/_private-routes/talent-agency': {
      id: '/_private-routes/talent-agency'
      path: '/talent-agency'
      fullPath: '/talent-agency'
      preLoaderRoute: typeof PrivateRoutesTalentAgencyRouteImport
      parentRoute: typeof PrivateRoutesRoute
    }
    '/_private-routes/settings': {
      id: '/_private-routes/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof PrivateRoutesSettingsRouteImport
      parentRoute: typeof PrivateRoutesRoute
    }
    '/_private-routes/report': {
      id: '/_private-routes/report'
      path: '/report'
      fullPath: '/report'
      preLoaderRoute: typeof PrivateRoutesReportRouteImport
      parentRoute: typeof PrivateRoutesRoute
    }
    '/_private-routes/posts-insight': {
      id: '/_private-routes/posts-insight'
      path: '/posts-insight'
      fullPath: '/posts-insight'
      preLoaderRoute: typeof PrivateRoutesPostsInsightRouteImport
      parentRoute: typeof PrivateRoutesRoute
    }
    '/_private-routes/posts': {
      id: '/_private-routes/posts'
      path: '/posts'
      fullPath: '/posts'
      preLoaderRoute: typeof PrivateRoutesPostsRouteImport
      parentRoute: typeof PrivateRoutesRoute
    }
    '/_private-routes/payments': {
      id: '/_private-routes/payments'
      path: '/payments'
      fullPath: '/payments'
      preLoaderRoute: typeof PrivateRoutesPaymentsRouteImport
      parentRoute: typeof PrivateRoutesRoute
    }
    '/_private-routes/partner': {
      id: '/_private-routes/partner'
      path: '/partner'
      fullPath: '/partner'
      preLoaderRoute: typeof PrivateRoutesPartnerRouteImport
      parentRoute: typeof PrivateRoutesRoute
    }
    '/_private-routes/package': {
      id: '/_private-routes/package'
      path: '/package'
      fullPath: '/package'
      preLoaderRoute: typeof PrivateRoutesPackageRouteImport
      parentRoute: typeof PrivateRoutesRoute
    }
    '/_private-routes/influencers': {
      id: '/_private-routes/influencers'
      path: '/influencers'
      fullPath: '/influencers'
      preLoaderRoute: typeof PrivateRoutesInfluencersRouteImport
      parentRoute: typeof PrivateRoutesRoute
    }
    '/_private-routes/influencer': {
      id: '/_private-routes/influencer'
      path: '/influencer'
      fullPath: '/influencer'
      preLoaderRoute: typeof PrivateRoutesInfluencerRouteImport
      parentRoute: typeof PrivateRoutesRoute
    }
    '/_private-routes/hashtag-analytics': {
      id: '/_private-routes/hashtag-analytics'
      path: '/hashtag-analytics'
      fullPath: '/hashtag-analytics'
      preLoaderRoute: typeof PrivateRoutesHashtagAnalyticsRouteImport
      parentRoute: typeof PrivateRoutesRoute
    }
    '/_private-routes/campaign-posts-discovery': {
      id: '/_private-routes/campaign-posts-discovery'
      path: '/campaign-posts-discovery'
      fullPath: '/campaign-posts-discovery'
      preLoaderRoute: typeof PrivateRoutesCampaignPostsDiscoveryRouteImport
      parentRoute: typeof PrivateRoutesRoute
    }
    '/_private-routes/auto-managed': {
      id: '/_private-routes/auto-managed'
      path: '/auto-managed'
      fullPath: '/auto-managed'
      preLoaderRoute: typeof PrivateRoutesAutoManagedRouteImport
      parentRoute: typeof PrivateRoutesRoute
    }
    '/_private-routes/asset-preview': {
      id: '/_private-routes/asset-preview'
      path: '/asset-preview'
      fullPath: '/asset-preview'
      preLoaderRoute: typeof PrivateRoutesAssetPreviewRouteImport
      parentRoute: typeof PrivateRoutesRoute
    }
    '/_private-routes/analytics': {
      id: '/_private-routes/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof PrivateRoutesAnalyticsRouteImport
      parentRoute: typeof PrivateRoutesRoute
    }
    '/_private-routes/agency': {
      id: '/_private-routes/agency'
      path: '/agency'
      fullPath: '/agency'
      preLoaderRoute: typeof PrivateRoutesAgencyRouteImport
      parentRoute: typeof PrivateRoutesRoute
    }
    '/_private-routes/advertiser': {
      id: '/_private-routes/advertiser'
      path: '/advertiser'
      fullPath: '/advertiser'
      preLoaderRoute: typeof PrivateRoutesAdvertiserRouteImport
      parentRoute: typeof PrivateRoutesRoute
    }
    '/_public-routes/tiktok-onboarding/': {
      id: '/_public-routes/tiktok-onboarding/'
      path: '/'
      fullPath: '/tiktok-onboarding/'
      preLoaderRoute: typeof PublicRoutesTiktokOnboardingIndexRouteImport
      parentRoute: typeof PublicRoutesTiktokOnboardingRoute
    }
    '/_public-routes/sign-up/': {
      id: '/_public-routes/sign-up/'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof PublicRoutesSignUpIndexRouteImport
      parentRoute: typeof PublicRoutesRoute
    }
    '/_private-routes/youtube-cms/': {
      id: '/_private-routes/youtube-cms/'
      path: '/'
      fullPath: '/youtube-cms/'
      preLoaderRoute: typeof PrivateRoutesYoutubeCmsIndexRouteImport
      parentRoute: typeof PrivateRoutesYoutubeCmsRoute
    }
    '/_private-routes/user/': {
      id: '/_private-routes/user/'
      path: '/'
      fullPath: '/user/'
      preLoaderRoute: typeof PrivateRoutesUserIndexRouteImport
      parentRoute: typeof PrivateRoutesUserRoute
    }
    '/_private-routes/trending/': {
      id: '/_private-routes/trending/'
      path: '/'
      fullPath: '/trending/'
      preLoaderRoute: typeof PrivateRoutesTrendingIndexRouteImport
      parentRoute: typeof PrivateRoutesTrendingRoute
    }
    '/_private-routes/tools/': {
      id: '/_private-routes/tools/'
      path: '/'
      fullPath: '/tools/'
      preLoaderRoute: typeof PrivateRoutesToolsIndexRouteImport
      parentRoute: typeof PrivateRoutesToolsRoute
    }
    '/_private-routes/talent-agency/': {
      id: '/_private-routes/talent-agency/'
      path: '/'
      fullPath: '/talent-agency/'
      preLoaderRoute: typeof PrivateRoutesTalentAgencyIndexRouteImport
      parentRoute: typeof PrivateRoutesTalentAgencyRoute
    }
    '/_private-routes/prompts/': {
      id: '/_private-routes/prompts/'
      path: '/prompts'
      fullPath: '/prompts'
      preLoaderRoute: typeof PrivateRoutesPromptsIndexRouteImport
      parentRoute: typeof PrivateRoutesRoute
    }
    '/_private-routes/posts-insight/': {
      id: '/_private-routes/posts-insight/'
      path: '/'
      fullPath: '/posts-insight/'
      preLoaderRoute: typeof PrivateRoutesPostsInsightIndexRouteImport
      parentRoute: typeof PrivateRoutesPostsInsightRoute
    }
    '/_private-routes/partner/': {
      id: '/_private-routes/partner/'
      path: '/'
      fullPath: '/partner/'
      preLoaderRoute: typeof PrivateRoutesPartnerIndexRouteImport
      parentRoute: typeof PrivateRoutesPartnerRoute
    }
    '/_private-routes/package/': {
      id: '/_private-routes/package/'
      path: '/'
      fullPath: '/package/'
      preLoaderRoute: typeof PrivateRoutesPackageIndexRouteImport
      parentRoute: typeof PrivateRoutesPackageRoute
    }
    '/_private-routes/marketplace/': {
      id: '/_private-routes/marketplace/'
      path: '/marketplace'
      fullPath: '/marketplace'
      preLoaderRoute: typeof PrivateRoutesMarketplaceIndexRouteImport
      parentRoute: typeof PrivateRoutesRoute
    }
    '/_private-routes/influencers/': {
      id: '/_private-routes/influencers/'
      path: '/'
      fullPath: '/influencers/'
      preLoaderRoute: typeof PrivateRoutesInfluencersIndexRouteImport
      parentRoute: typeof PrivateRoutesInfluencersRoute
    }
    '/_private-routes/influencer/': {
      id: '/_private-routes/influencer/'
      path: '/'
      fullPath: '/influencer/'
      preLoaderRoute: typeof PrivateRoutesInfluencerIndexRouteImport
      parentRoute: typeof PrivateRoutesInfluencerRoute
    }
    '/_private-routes/hashtag-analytics/': {
      id: '/_private-routes/hashtag-analytics/'
      path: '/'
      fullPath: '/hashtag-analytics/'
      preLoaderRoute: typeof PrivateRoutesHashtagAnalyticsIndexRouteImport
      parentRoute: typeof PrivateRoutesHashtagAnalyticsRoute
    }
    '/_private-routes/engagement/': {
      id: '/_private-routes/engagement/'
      path: '/engagement'
      fullPath: '/engagement'
      preLoaderRoute: typeof PrivateRoutesEngagementIndexRouteImport
      parentRoute: typeof PrivateRoutesRoute
    }
    '/_private-routes/auto-managed/': {
      id: '/_private-routes/auto-managed/'
      path: '/'
      fullPath: '/auto-managed/'
      preLoaderRoute: typeof PrivateRoutesAutoManagedIndexRouteImport
      parentRoute: typeof PrivateRoutesAutoManagedRoute
    }
    '/_private-routes/analytics/': {
      id: '/_private-routes/analytics/'
      path: '/'
      fullPath: '/analytics/'
      preLoaderRoute: typeof PrivateRoutesAnalyticsIndexRouteImport
      parentRoute: typeof PrivateRoutesAnalyticsRoute
    }
    '/_private-routes/agency/': {
      id: '/_private-routes/agency/'
      path: '/'
      fullPath: '/agency/'
      preLoaderRoute: typeof PrivateRoutesAgencyIndexRouteImport
      parentRoute: typeof PrivateRoutesAgencyRoute
    }
    '/_private-routes/advertiser/': {
      id: '/_private-routes/advertiser/'
      path: '/'
      fullPath: '/advertiser/'
      preLoaderRoute: typeof PrivateRoutesAdvertiserIndexRouteImport
      parentRoute: typeof PrivateRoutesAdvertiserRoute
    }
    '/_private-routes/access/': {
      id: '/_private-routes/access/'
      path: '/access'
      fullPath: '/access'
      preLoaderRoute: typeof PrivateRoutesAccessIndexRouteImport
      parentRoute: typeof PrivateRoutesRoute
    }
    '/_public-routes/tiktok-onboarding/success': {
      id: '/_public-routes/tiktok-onboarding/success'
      path: '/success'
      fullPath: '/tiktok-onboarding/success'
      preLoaderRoute: typeof PublicRoutesTiktokOnboardingSuccessRouteImport
      parentRoute: typeof PublicRoutesTiktokOnboardingRoute
    }
    '/_public-routes/tiktok-onboarding/select-plan': {
      id: '/_public-routes/tiktok-onboarding/select-plan'
      path: '/select-plan'
      fullPath: '/tiktok-onboarding/select-plan'
      preLoaderRoute: typeof PublicRoutesTiktokOnboardingSelectPlanRouteImport
      parentRoute: typeof PublicRoutesTiktokOnboardingRoute
    }
    '/_public-routes/tiktok-onboarding/password-enter': {
      id: '/_public-routes/tiktok-onboarding/password-enter'
      path: '/password-enter'
      fullPath: '/tiktok-onboarding/password-enter'
      preLoaderRoute: typeof PublicRoutesTiktokOnboardingPasswordEnterRouteImport
      parentRoute: typeof PublicRoutesTiktokOnboardingRoute
    }
    '/_public-routes/tiktok-onboarding/ad-account': {
      id: '/_public-routes/tiktok-onboarding/ad-account'
      path: '/ad-account'
      fullPath: '/tiktok-onboarding/ad-account'
      preLoaderRoute: typeof PublicRoutesTiktokOnboardingAdAccountRouteImport
      parentRoute: typeof PublicRoutesTiktokOnboardingRoute
    }
    '/_public-routes/sign-up/success': {
      id: '/_public-routes/sign-up/success'
      path: '/sign-up/success'
      fullPath: '/sign-up/success'
      preLoaderRoute: typeof PublicRoutesSignUpSuccessRouteImport
      parentRoute: typeof PublicRoutesRoute
    }
    '/_public-routes/mkp/referral': {
      id: '/_public-routes/mkp/referral'
      path: '/mkp/referral'
      fullPath: '/mkp/referral'
      preLoaderRoute: typeof PublicRoutesMkpReferralRouteImport
      parentRoute: typeof PublicRoutesRoute
    }
    '/_public-routes/egg/referral': {
      id: '/_public-routes/egg/referral'
      path: '/egg/referral'
      fullPath: '/egg/referral'
      preLoaderRoute: typeof PublicRoutesEggReferralRouteImport
      parentRoute: typeof PublicRoutesRoute
    }
    '/_public-routes/_password/password_forgot': {
      id: '/_public-routes/_password/password_forgot'
      path: '/password_forgot'
      fullPath: '/password_forgot'
      preLoaderRoute: typeof PublicRoutesPasswordPassword_forgotRouteImport
      parentRoute: typeof PublicRoutesRoute
    }
    '/_private-routes/youtube-cms/revenue': {
      id: '/_private-routes/youtube-cms/revenue'
      path: '/revenue'
      fullPath: '/youtube-cms/revenue'
      preLoaderRoute: typeof PrivateRoutesYoutubeCmsRevenueRouteImport
      parentRoute: typeof PrivateRoutesYoutubeCmsRoute
    }
    '/_private-routes/youtube-cms/invoices': {
      id: '/_private-routes/youtube-cms/invoices'
      path: '/invoices'
      fullPath: '/youtube-cms/invoices'
      preLoaderRoute: typeof PrivateRoutesYoutubeCmsInvoicesRouteImport
      parentRoute: typeof PrivateRoutesYoutubeCmsRoute
    }
    '/_private-routes/user/linked': {
      id: '/_private-routes/user/linked'
      path: '/linked'
      fullPath: '/user/linked'
      preLoaderRoute: typeof PrivateRoutesUserLinkedRouteImport
      parentRoute: typeof PrivateRoutesUserRoute
    }
    '/_private-routes/user/add': {
      id: '/_private-routes/user/add'
      path: '/add'
      fullPath: '/user/add'
      preLoaderRoute: typeof PrivateRoutesUserAddRouteImport
      parentRoute: typeof PrivateRoutesUserRoute
    }
    '/_private-routes/user/$id': {
      id: '/_private-routes/user/$id'
      path: '/$id'
      fullPath: '/user/$id'
      preLoaderRoute: typeof PrivateRoutesUserIdRouteImport
      parentRoute: typeof PrivateRoutesUserRoute
    }
    '/_private-routes/trending/posts': {
      id: '/_private-routes/trending/posts'
      path: '/posts'
      fullPath: '/trending/posts'
      preLoaderRoute: typeof PrivateRoutesTrendingPostsRouteImport
      parentRoute: typeof PrivateRoutesTrendingRoute
    }
    '/_private-routes/trending/influencers': {
      id: '/_private-routes/trending/influencers'
      path: '/influencers'
      fullPath: '/trending/influencers'
      preLoaderRoute: typeof PrivateRoutesTrendingInfluencersRouteImport
      parentRoute: typeof PrivateRoutesTrendingRoute
    }
    '/_private-routes/tools/video-comp-ai': {
      id: '/_private-routes/tools/video-comp-ai'
      path: '/video-comp-ai'
      fullPath: '/tools/video-comp-ai'
      preLoaderRoute: typeof PrivateRoutesToolsVideoCompAiRouteImport
      parentRoute: typeof PrivateRoutesToolsRoute
    }
    '/_private-routes/tiktok/subscription-billing': {
      id: '/_private-routes/tiktok/subscription-billing'
      path: '/subscription-billing'
      fullPath: '/tiktok/subscription-billing'
      preLoaderRoute: typeof PrivateRoutesTiktokSubscriptionBillingRouteImport
      parentRoute: typeof PrivateRoutesTiktokRoute
    }
    '/_private-routes/tiktok/failed-payment': {
      id: '/_private-routes/tiktok/failed-payment'
      path: '/failed-payment'
      fullPath: '/tiktok/failed-payment'
      preLoaderRoute: typeof PrivateRoutesTiktokFailedPaymentRouteImport
      parentRoute: typeof PrivateRoutesTiktokRoute
    }
    '/_private-routes/tiktok/campaigns': {
      id: '/_private-routes/tiktok/campaigns'
      path: '/campaigns'
      fullPath: '/tiktok/campaigns'
      preLoaderRoute: typeof PrivateRoutesTiktokCampaignsRouteImport
      parentRoute: typeof PrivateRoutesTiktokRoute
    }
    '/_private-routes/tiktok/budget-allocation': {
      id: '/_private-routes/tiktok/budget-allocation'
      path: '/budget-allocation'
      fullPath: '/tiktok/budget-allocation'
      preLoaderRoute: typeof PrivateRoutesTiktokBudgetAllocationRouteImport
      parentRoute: typeof PrivateRoutesTiktokRoute
    }
    '/_private-routes/tiktok/advertiser-details': {
      id: '/_private-routes/tiktok/advertiser-details'
      path: '/advertiser-details'
      fullPath: '/tiktok/advertiser-details'
      preLoaderRoute: typeof PrivateRoutesTiktokAdvertiserDetailsRouteImport
      parentRoute: typeof PrivateRoutesTiktokRoute
    }
    '/_private-routes/tiktok/ad-campaign-report': {
      id: '/_private-routes/tiktok/ad-campaign-report'
      path: '/ad-campaign-report'
      fullPath: '/tiktok/ad-campaign-report'
      preLoaderRoute: typeof PrivateRoutesTiktokAdCampaignReportRouteImport
      parentRoute: typeof PrivateRoutesTiktokRoute
    }
    '/_private-routes/tiktok/ad-accounts': {
      id: '/_private-routes/tiktok/ad-accounts'
      path: '/ad-accounts'
      fullPath: '/tiktok/ad-accounts'
      preLoaderRoute: typeof PrivateRoutesTiktokAdAccountsRouteImport
      parentRoute: typeof PrivateRoutesTiktokRoute
    }
    '/_private-routes/talent-agency/add': {
      id: '/_private-routes/talent-agency/add'
      path: '/add'
      fullPath: '/talent-agency/add'
      preLoaderRoute: typeof PrivateRoutesTalentAgencyAddRouteImport
      parentRoute: typeof PrivateRoutesTalentAgencyRoute
    }
    '/_private-routes/talent-agency/$id': {
      id: '/_private-routes/talent-agency/$id'
      path: '/$id'
      fullPath: '/talent-agency/$id'
      preLoaderRoute: typeof PrivateRoutesTalentAgencyIdRouteImport
      parentRoute: typeof PrivateRoutesTalentAgencyRoute
    }
    '/_private-routes/redirect/google-auth': {
      id: '/_private-routes/redirect/google-auth'
      path: '/redirect/google-auth'
      fullPath: '/redirect/google-auth'
      preLoaderRoute: typeof PrivateRoutesRedirectGoogleAuthRouteImport
      parentRoute: typeof PrivateRoutesRoute
    }
    '/_private-routes/posts-insight/$id': {
      id: '/_private-routes/posts-insight/$id'
      path: '/$id'
      fullPath: '/posts-insight/$id'
      preLoaderRoute: typeof PrivateRoutesPostsInsightIdRouteImport
      parentRoute: typeof PrivateRoutesPostsInsightRoute
    }
    '/_private-routes/partner/$id': {
      id: '/_private-routes/partner/$id'
      path: '/$id'
      fullPath: '/partner/$id'
      preLoaderRoute: typeof PrivateRoutesPartnerIdRouteImport
      parentRoute: typeof PrivateRoutesPartnerRoute
    }
    '/_private-routes/package/add': {
      id: '/_private-routes/package/add'
      path: '/add'
      fullPath: '/package/add'
      preLoaderRoute: typeof PrivateRoutesPackageAddRouteImport
      parentRoute: typeof PrivateRoutesPackageRoute
    }
    '/_private-routes/package/$id': {
      id: '/_private-routes/package/$id'
      path: '/$id'
      fullPath: '/package/$id'
      preLoaderRoute: typeof PrivateRoutesPackageIdRouteImport
      parentRoute: typeof PrivateRoutesPackageRoute
    }
    '/_private-routes/marketplace/reorder': {
      id: '/_private-routes/marketplace/reorder'
      path: '/marketplace/reorder'
      fullPath: '/marketplace/reorder'
      preLoaderRoute: typeof PrivateRoutesMarketplaceReorderRouteImport
      parentRoute: typeof PrivateRoutesRoute
    }
    '/_private-routes/marketplace/add': {
      id: '/_private-routes/marketplace/add'
      path: '/marketplace/add'
      fullPath: '/marketplace/add'
      preLoaderRoute: typeof PrivateRoutesMarketplaceAddRouteImport
      parentRoute: typeof PrivateRoutesRoute
    }
    '/_private-routes/marketplace/$id': {
      id: '/_private-routes/marketplace/$id'
      path: '/marketplace/$id'
      fullPath: '/marketplace/$id'
      preLoaderRoute: typeof PrivateRoutesMarketplaceIdRouteImport
      parentRoute: typeof PrivateRoutesRoute
    }
    '/_private-routes/influencers/search': {
      id: '/_private-routes/influencers/search'
      path: '/search'
      fullPath: '/influencers/search'
      preLoaderRoute: typeof PrivateRoutesInfluencersSearchRouteImport
      parentRoute: typeof PrivateRoutesInfluencersRoute
    }
    '/_private-routes/influencers/proposal': {
      id: '/_private-routes/influencers/proposal'
      path: '/proposal'
      fullPath: '/influencers/proposal'
      preLoaderRoute: typeof PrivateRoutesInfluencersProposalRouteImport
      parentRoute: typeof PrivateRoutesInfluencersRoute
    }
    '/_private-routes/influencer/add': {
      id: '/_private-routes/influencer/add'
      path: '/add'
      fullPath: '/influencer/add'
      preLoaderRoute: typeof PrivateRoutesInfluencerAddRouteImport
      parentRoute: typeof PrivateRoutesInfluencerRoute
    }
    '/_private-routes/influencer/$id': {
      id: '/_private-routes/influencer/$id'
      path: '/$id'
      fullPath: '/influencer/$id'
      preLoaderRoute: typeof PrivateRoutesInfluencerIdRouteImport
      parentRoute: typeof PrivateRoutesInfluencerRoute
    }
    '/_private-routes/hashtag-analytics/tiktok': {
      id: '/_private-routes/hashtag-analytics/tiktok'
      path: '/tiktok'
      fullPath: '/hashtag-analytics/tiktok'
      preLoaderRoute: typeof PrivateRoutesHashtagAnalyticsTiktokRouteImport
      parentRoute: typeof PrivateRoutesHashtagAnalyticsRoute
    }
    '/_private-routes/hashtag-analytics/instagram': {
      id: '/_private-routes/hashtag-analytics/instagram'
      path: '/instagram'
      fullPath: '/hashtag-analytics/instagram'
      preLoaderRoute: typeof PrivateRoutesHashtagAnalyticsInstagramRouteImport
      parentRoute: typeof PrivateRoutesHashtagAnalyticsRoute
    }
    '/_private-routes/engagement/add': {
      id: '/_private-routes/engagement/add'
      path: '/engagement/add'
      fullPath: '/engagement/add'
      preLoaderRoute: typeof PrivateRoutesEngagementAddRouteImport
      parentRoute: typeof PrivateRoutesRoute
    }
    '/_private-routes/engagement/$id': {
      id: '/_private-routes/engagement/$id'
      path: '/engagement/$id'
      fullPath: '/engagement/$id'
      preLoaderRoute: typeof PrivateRoutesEngagementIdRouteImport
      parentRoute: typeof PrivateRoutesRoute
    }
    '/_private-routes/auto-managed/$id': {
      id: '/_private-routes/auto-managed/$id'
      path: '/$id'
      fullPath: '/auto-managed/$id'
      preLoaderRoute: typeof PrivateRoutesAutoManagedIdRouteImport
      parentRoute: typeof PrivateRoutesAutoManagedRoute
    }
    '/_private-routes/analytics/add': {
      id: '/_private-routes/analytics/add'
      path: '/add'
      fullPath: '/analytics/add'
      preLoaderRoute: typeof PrivateRoutesAnalyticsAddRouteImport
      parentRoute: typeof PrivateRoutesAnalyticsRoute
    }
    '/_private-routes/agency/add': {
      id: '/_private-routes/agency/add'
      path: '/add'
      fullPath: '/agency/add'
      preLoaderRoute: typeof PrivateRoutesAgencyAddRouteImport
      parentRoute: typeof PrivateRoutesAgencyRoute
    }
    '/_private-routes/agency/$id': {
      id: '/_private-routes/agency/$id'
      path: '/$id'
      fullPath: '/agency/$id'
      preLoaderRoute: typeof PrivateRoutesAgencyIdRouteImport
      parentRoute: typeof PrivateRoutesAgencyRoute
    }
    '/_private-routes/advertiser/add': {
      id: '/_private-routes/advertiser/add'
      path: '/add'
      fullPath: '/advertiser/add'
      preLoaderRoute: typeof PrivateRoutesAdvertiserAddRouteImport
      parentRoute: typeof PrivateRoutesAdvertiserRoute
    }
    '/_private-routes/advertiser/$id': {
      id: '/_private-routes/advertiser/$id'
      path: '/$id'
      fullPath: '/advertiser/$id'
      preLoaderRoute: typeof PrivateRoutesAdvertiserIdRouteImport
      parentRoute: typeof PrivateRoutesAdvertiserRoute
    }
    '/_private-routes/access/declined': {
      id: '/_private-routes/access/declined'
      path: '/access/declined'
      fullPath: '/access/declined'
      preLoaderRoute: typeof PrivateRoutesAccessDeclinedRouteImport
      parentRoute: typeof PrivateRoutesRoute
    }
    '/_private-routes/access/authorized': {
      id: '/_private-routes/access/authorized'
      path: '/access/authorized'
      fullPath: '/access/authorized'
      preLoaderRoute: typeof PrivateRoutesAccessAuthorizedRouteImport
      parentRoute: typeof PrivateRoutesRoute
    }
    '/_private-routes/youtube-cms/revenue/': {
      id: '/_private-routes/youtube-cms/revenue/'
      path: '/'
      fullPath: '/youtube-cms/revenue/'
      preLoaderRoute: typeof PrivateRoutesYoutubeCmsRevenueIndexRouteImport
      parentRoute: typeof PrivateRoutesYoutubeCmsRevenueRoute
    }
    '/_private-routes/tiktok/campaigns/': {
      id: '/_private-routes/tiktok/campaigns/'
      path: '/'
      fullPath: '/tiktok/campaigns/'
      preLoaderRoute: typeof PrivateRoutesTiktokCampaignsIndexRouteImport
      parentRoute: typeof PrivateRoutesTiktokCampaignsRoute
    }
    '/_private-routes/tiktok/ad-campaign-report/': {
      id: '/_private-routes/tiktok/ad-campaign-report/'
      path: '/'
      fullPath: '/tiktok/ad-campaign-report/'
      preLoaderRoute: typeof PrivateRoutesTiktokAdCampaignReportIndexRouteImport
      parentRoute: typeof PrivateRoutesTiktokAdCampaignReportRoute
    }
    '/_private-routes/talent-agency/$id/': {
      id: '/_private-routes/talent-agency/$id/'
      path: '/'
      fullPath: '/talent-agency/$id/'
      preLoaderRoute: typeof PrivateRoutesTalentAgencyIdIndexRouteImport
      parentRoute: typeof PrivateRoutesTalentAgencyIdRoute
    }
    '/_private-routes/partner/$id/': {
      id: '/_private-routes/partner/$id/'
      path: '/'
      fullPath: '/partner/$id/'
      preLoaderRoute: typeof PrivateRoutesPartnerIdIndexRouteImport
      parentRoute: typeof PrivateRoutesPartnerIdRoute
    }
    '/_private-routes/package/$id/': {
      id: '/_private-routes/package/$id/'
      path: '/'
      fullPath: '/package/$id/'
      preLoaderRoute: typeof PrivateRoutesPackageIdIndexRouteImport
      parentRoute: typeof PrivateRoutesPackageIdRoute
    }
    '/_private-routes/marketplace/add/': {
      id: '/_private-routes/marketplace/add/'
      path: '/'
      fullPath: '/marketplace/add/'
      preLoaderRoute: typeof PrivateRoutesMarketplaceAddIndexRouteImport
      parentRoute: typeof PrivateRoutesMarketplaceAddRoute
    }
    '/_private-routes/marketplace/$id/': {
      id: '/_private-routes/marketplace/$id/'
      path: '/'
      fullPath: '/marketplace/$id/'
      preLoaderRoute: typeof PrivateRoutesMarketplaceIdIndexRouteImport
      parentRoute: typeof PrivateRoutesMarketplaceIdRoute
    }
    '/_private-routes/influencers/search/': {
      id: '/_private-routes/influencers/search/'
      path: '/'
      fullPath: '/influencers/search/'
      preLoaderRoute: typeof PrivateRoutesInfluencersSearchIndexRouteImport
      parentRoute: typeof PrivateRoutesInfluencersSearchRoute
    }
    '/_private-routes/influencer/$id/': {
      id: '/_private-routes/influencer/$id/'
      path: '/'
      fullPath: '/influencer/$id/'
      preLoaderRoute: typeof PrivateRoutesInfluencerIdIndexRouteImport
      parentRoute: typeof PrivateRoutesInfluencerIdRoute
    }
    '/_private-routes/hashtag-analytics/tiktok/': {
      id: '/_private-routes/hashtag-analytics/tiktok/'
      path: '/'
      fullPath: '/hashtag-analytics/tiktok/'
      preLoaderRoute: typeof PrivateRoutesHashtagAnalyticsTiktokIndexRouteImport
      parentRoute: typeof PrivateRoutesHashtagAnalyticsTiktokRoute
    }
    '/_private-routes/hashtag-analytics/instagram/': {
      id: '/_private-routes/hashtag-analytics/instagram/'
      path: '/'
      fullPath: '/hashtag-analytics/instagram/'
      preLoaderRoute: typeof PrivateRoutesHashtagAnalyticsInstagramIndexRouteImport
      parentRoute: typeof PrivateRoutesHashtagAnalyticsInstagramRoute
    }
    '/_private-routes/engagement/$id/': {
      id: '/_private-routes/engagement/$id/'
      path: '/'
      fullPath: '/engagement/$id/'
      preLoaderRoute: typeof PrivateRoutesEngagementIdIndexRouteImport
      parentRoute: typeof PrivateRoutesEngagementIdRoute
    }
    '/_private-routes/auto-managed/$id/': {
      id: '/_private-routes/auto-managed/$id/'
      path: '/'
      fullPath: '/auto-managed/$id/'
      preLoaderRoute: typeof PrivateRoutesAutoManagedIdIndexRouteImport
      parentRoute: typeof PrivateRoutesAutoManagedIdRoute
    }
    '/_private-routes/analytics/$brandAccountId/': {
      id: '/_private-routes/analytics/$brandAccountId/'
      path: '/$brandAccountId'
      fullPath: '/analytics/$brandAccountId'
      preLoaderRoute: typeof PrivateRoutesAnalyticsBrandAccountIdIndexRouteImport
      parentRoute: typeof PrivateRoutesAnalyticsRoute
    }
    '/_private-routes/agency/$id/': {
      id: '/_private-routes/agency/$id/'
      path: '/'
      fullPath: '/agency/$id/'
      preLoaderRoute: typeof PrivateRoutesAgencyIdIndexRouteImport
      parentRoute: typeof PrivateRoutesAgencyIdRoute
    }
    '/_private-routes/advertiser/$id/': {
      id: '/_private-routes/advertiser/$id/'
      path: '/'
      fullPath: '/advertiser/$id/'
      preLoaderRoute: typeof PrivateRoutesAdvertiserIdIndexRouteImport
      parentRoute: typeof PrivateRoutesAdvertiserIdRoute
    }
    '/_public-routes/tiktok-onboarding/password-register/$token': {
      id: '/_public-routes/tiktok-onboarding/password-register/$token'
      path: '/password-register/$token'
      fullPath: '/tiktok-onboarding/password-register/$token'
      preLoaderRoute: typeof PublicRoutesTiktokOnboardingPasswordRegisterTokenRouteImport
      parentRoute: typeof PublicRoutesTiktokOnboardingRoute
    }
    '/_public-routes/_password/password_reset/$token': {
      id: '/_public-routes/_password/password_reset/$token'
      path: '/password_reset/$token'
      fullPath: '/password_reset/$token'
      preLoaderRoute: typeof PublicRoutesPasswordPassword_resetTokenRouteImport
      parentRoute: typeof PublicRoutesRoute
    }
    '/_public-routes/_password/password_register/$token': {
      id: '/_public-routes/_password/password_register/$token'
      path: '/password_register/$token'
      fullPath: '/password_register/$token'
      preLoaderRoute: typeof PublicRoutesPasswordPassword_registerTokenRouteImport
      parentRoute: typeof PublicRoutesRoute
    }
    '/_private-routes/youtube-cms/revenue/confirmed': {
      id: '/_private-routes/youtube-cms/revenue/confirmed'
      path: '/confirmed'
      fullPath: '/youtube-cms/revenue/confirmed'
      preLoaderRoute: typeof PrivateRoutesYoutubeCmsRevenueConfirmedRouteImport
      parentRoute: typeof PrivateRoutesYoutubeCmsRevenueRoute
    }
    '/_private-routes/youtube-cms/revenue/$cmsChannelId': {
      id: '/_private-routes/youtube-cms/revenue/$cmsChannelId'
      path: '/$cmsChannelId'
      fullPath: '/youtube-cms/revenue/$cmsChannelId'
      preLoaderRoute: typeof PrivateRoutesYoutubeCmsRevenueCmsChannelIdRouteImport
      parentRoute: typeof PrivateRoutesYoutubeCmsRevenueRoute
    }
    '/_private-routes/tiktok/campaigns/review-influencers': {
      id: '/_private-routes/tiktok/campaigns/review-influencers'
      path: '/review-influencers'
      fullPath: '/tiktok/campaigns/review-influencers'
      preLoaderRoute: typeof PrivateRoutesTiktokCampaignsReviewInfluencersRouteImport
      parentRoute: typeof PrivateRoutesTiktokCampaignsRoute
    }
    '/_private-routes/tiktok/campaigns/add': {
      id: '/_private-routes/tiktok/campaigns/add'
      path: '/add'
      fullPath: '/tiktok/campaigns/add'
      preLoaderRoute: typeof PrivateRoutesTiktokCampaignsAddRouteImport
      parentRoute: typeof PrivateRoutesTiktokCampaignsRoute
    }
    '/_private-routes/tiktok/campaigns/$id': {
      id: '/_private-routes/tiktok/campaigns/$id'
      path: '/$id'
      fullPath: '/tiktok/campaigns/$id'
      preLoaderRoute: typeof PrivateRoutesTiktokCampaignsIdRouteImport
      parentRoute: typeof PrivateRoutesTiktokCampaignsRoute
    }
    '/_private-routes/talent-agency/$id/users': {
      id: '/_private-routes/talent-agency/$id/users'
      path: '/users'
      fullPath: '/talent-agency/$id/users'
      preLoaderRoute: typeof PrivateRoutesTalentAgencyIdUsersRouteImport
      parentRoute: typeof PrivateRoutesTalentAgencyIdRoute
    }
    '/_private-routes/talent-agency/$id/business': {
      id: '/_private-routes/talent-agency/$id/business'
      path: '/business'
      fullPath: '/talent-agency/$id/business'
      preLoaderRoute: typeof PrivateRoutesTalentAgencyIdBusinessRouteImport
      parentRoute: typeof PrivateRoutesTalentAgencyIdRoute
    }
    '/_private-routes/redirect/talent-signin/$provider': {
      id: '/_private-routes/redirect/talent-signin/$provider'
      path: '/redirect/talent-signin/$provider'
      fullPath: '/redirect/talent-signin/$provider'
      preLoaderRoute: typeof PrivateRoutesRedirectTalentSigninProviderRouteImport
      parentRoute: typeof PrivateRoutesRoute
    }
    '/_private-routes/redirect/talent-analytics-connect/$provider': {
      id: '/_private-routes/redirect/talent-analytics-connect/$provider'
      path: '/redirect/talent-analytics-connect/$provider'
      fullPath: '/redirect/talent-analytics-connect/$provider'
      preLoaderRoute: typeof PrivateRoutesRedirectTalentAnalyticsConnectProviderRouteImport
      parentRoute: typeof PrivateRoutesRoute
    }
    '/_private-routes/redirect/hidden/youtube-list-connect': {
      id: '/_private-routes/redirect/hidden/youtube-list-connect'
      path: '/redirect/hidden/youtube-list-connect'
      fullPath: '/redirect/hidden/youtube-list-connect'
      preLoaderRoute: typeof PrivateRoutesRedirectHiddenYoutubeListConnectRouteImport
      parentRoute: typeof PrivateRoutesRoute
    }
    '/_private-routes/redirect/connect/tiktok-business': {
      id: '/_private-routes/redirect/connect/tiktok-business'
      path: '/redirect/connect/tiktok-business'
      fullPath: '/redirect/connect/tiktok-business'
      preLoaderRoute: typeof PrivateRoutesRedirectConnectTiktokBusinessRouteImport
      parentRoute: typeof PrivateRoutesRoute
    }
    '/_private-routes/redirect/analytics-signin/$provider': {
      id: '/_private-routes/redirect/analytics-signin/$provider'
      path: '/redirect/analytics-signin/$provider'
      fullPath: '/redirect/analytics-signin/$provider'
      preLoaderRoute: typeof PrivateRoutesRedirectAnalyticsSigninProviderRouteImport
      parentRoute: typeof PrivateRoutesRoute
    }
    '/_private-routes/redirect/analytics-list-connect/$provider': {
      id: '/_private-routes/redirect/analytics-list-connect/$provider'
      path: '/redirect/analytics-list-connect/$provider'
      fullPath: '/redirect/analytics-list-connect/$provider'
      preLoaderRoute: typeof PrivateRoutesRedirectAnalyticsListConnectProviderRouteImport
      parentRoute: typeof PrivateRoutesRoute
    }
    '/_private-routes/redirect/analytics-connect/$provider': {
      id: '/_private-routes/redirect/analytics-connect/$provider'
      path: '/redirect/analytics-connect/$provider'
      fullPath: '/redirect/analytics-connect/$provider'
      preLoaderRoute: typeof PrivateRoutesRedirectAnalyticsConnectProviderRouteImport
      parentRoute: typeof PrivateRoutesRoute
    }
    '/_private-routes/posts-insight/$id/$postId': {
      id: '/_private-routes/posts-insight/$id/$postId'
      path: '/$postId'
      fullPath: '/posts-insight/$id/$postId'
      preLoaderRoute: typeof PrivateRoutesPostsInsightIdPostIdRouteImport
      parentRoute: typeof PrivateRoutesPostsInsightIdRoute
    }
    '/_private-routes/partner/$id/users': {
      id: '/_private-routes/partner/$id/users'
      path: '/users'
      fullPath: '/partner/$id/users'
      preLoaderRoute: typeof PrivateRoutesPartnerIdUsersRouteImport
      parentRoute: typeof PrivateRoutesPartnerIdRoute
    }
    '/_private-routes/partner/$id/business': {
      id: '/_private-routes/partner/$id/business'
      path: '/business'
      fullPath: '/partner/$id/business'
      preLoaderRoute: typeof PrivateRoutesPartnerIdBusinessRouteImport
      parentRoute: typeof PrivateRoutesPartnerIdRoute
    }
    '/_private-routes/package/$id/content': {
      id: '/_private-routes/package/$id/content'
      path: '/content'
      fullPath: '/package/$id/content'
      preLoaderRoute: typeof PrivateRoutesPackageIdContentRouteImport
      parentRoute: typeof PrivateRoutesPackageIdRoute
    }
    '/_private-routes/marketplace/add/url-tracking': {
      id: '/_private-routes/marketplace/add/url-tracking'
      path: '/url-tracking'
      fullPath: '/marketplace/add/url-tracking'
      preLoaderRoute: typeof PrivateRoutesMarketplaceAddUrlTrackingRouteImport
      parentRoute: typeof PrivateRoutesMarketplaceAddRoute
    }
    '/_private-routes/marketplace/add/social-media-tracking': {
      id: '/_private-routes/marketplace/add/social-media-tracking'
      path: '/social-media-tracking'
      fullPath: '/marketplace/add/social-media-tracking'
      preLoaderRoute: typeof PrivateRoutesMarketplaceAddSocialMediaTrackingRouteImport
      parentRoute: typeof PrivateRoutesMarketplaceAddRoute
    }
    '/_private-routes/marketplace/add/referral-code-tracking': {
      id: '/_private-routes/marketplace/add/referral-code-tracking'
      path: '/referral-code-tracking'
      fullPath: '/marketplace/add/referral-code-tracking'
      preLoaderRoute: typeof PrivateRoutesMarketplaceAddReferralCodeTrackingRouteImport
      parentRoute: typeof PrivateRoutesMarketplaceAddRoute
    }
    '/_private-routes/marketplace/$id/tracking-referral-codes': {
      id: '/_private-routes/marketplace/$id/tracking-referral-codes'
      path: '/tracking-referral-codes'
      fullPath: '/marketplace/$id/tracking-referral-codes'
      preLoaderRoute: typeof PrivateRoutesMarketplaceIdTrackingReferralCodesRouteImport
      parentRoute: typeof PrivateRoutesMarketplaceIdRoute
    }
    '/_private-routes/marketplace/$id/tracking': {
      id: '/_private-routes/marketplace/$id/tracking'
      path: '/tracking'
      fullPath: '/marketplace/$id/tracking'
      preLoaderRoute: typeof PrivateRoutesMarketplaceIdTrackingRouteImport
      parentRoute: typeof PrivateRoutesMarketplaceIdRoute
    }
    '/_private-routes/marketplace/$id/report-affiliate': {
      id: '/_private-routes/marketplace/$id/report-affiliate'
      path: '/report-affiliate'
      fullPath: '/marketplace/$id/report-affiliate'
      preLoaderRoute: typeof PrivateRoutesMarketplaceIdReportAffiliateRouteImport
      parentRoute: typeof PrivateRoutesMarketplaceIdRoute
    }
    '/_private-routes/marketplace/$id/report': {
      id: '/_private-routes/marketplace/$id/report'
      path: '/report'
      fullPath: '/marketplace/$id/report'
      preLoaderRoute: typeof PrivateRoutesMarketplaceIdReportRouteImport
      parentRoute: typeof PrivateRoutesMarketplaceIdRoute
    }
    '/_private-routes/marketplace/$id/posts': {
      id: '/_private-routes/marketplace/$id/posts'
      path: '/posts'
      fullPath: '/marketplace/$id/posts'
      preLoaderRoute: typeof PrivateRoutesMarketplaceIdPostsRouteImport
      parentRoute: typeof PrivateRoutesMarketplaceIdRoute
    }
    '/_private-routes/marketplace/$id/joined-influencers': {
      id: '/_private-routes/marketplace/$id/joined-influencers'
      path: '/joined-influencers'
      fullPath: '/marketplace/$id/joined-influencers'
      preLoaderRoute: typeof PrivateRoutesMarketplaceIdJoinedInfluencersRouteImport
      parentRoute: typeof PrivateRoutesMarketplaceIdRoute
    }
    '/_private-routes/marketplace/$id/influencer': {
      id: '/_private-routes/marketplace/$id/influencer'
      path: '/influencer'
      fullPath: '/marketplace/$id/influencer'
      preLoaderRoute: typeof PrivateRoutesMarketplaceIdInfluencerRouteImport
      parentRoute: typeof PrivateRoutesMarketplaceIdRoute
    }
    '/_private-routes/marketplace/$id/commissions': {
      id: '/_private-routes/marketplace/$id/commissions'
      path: '/commissions'
      fullPath: '/marketplace/$id/commissions'
      preLoaderRoute: typeof PrivateRoutesMarketplaceIdCommissionsRouteImport
      parentRoute: typeof PrivateRoutesMarketplaceIdRoute
    }
    '/_private-routes/marketplace/$id/applicant': {
      id: '/_private-routes/marketplace/$id/applicant'
      path: '/applicant'
      fullPath: '/marketplace/$id/applicant'
      preLoaderRoute: typeof PrivateRoutesMarketplaceIdApplicantRouteImport
      parentRoute: typeof PrivateRoutesMarketplaceIdRoute
    }
    '/_private-routes/influencers/search/youtube': {
      id: '/_private-routes/influencers/search/youtube'
      path: '/youtube'
      fullPath: '/influencers/search/youtube'
      preLoaderRoute: typeof PrivateRoutesInfluencersSearchYoutubeRouteImport
      parentRoute: typeof PrivateRoutesInfluencersSearchRoute
    }
    '/_private-routes/influencers/search/xhs': {
      id: '/_private-routes/influencers/search/xhs'
      path: '/xhs'
      fullPath: '/influencers/search/xhs'
      preLoaderRoute: typeof PrivateRoutesInfluencersSearchXhsRouteImport
      parentRoute: typeof PrivateRoutesInfluencersSearchRoute
    }
    '/_private-routes/influencers/search/twitter': {
      id: '/_private-routes/influencers/search/twitter'
      path: '/twitter'
      fullPath: '/influencers/search/twitter'
      preLoaderRoute: typeof PrivateRoutesInfluencersSearchTwitterRouteImport
      parentRoute: typeof PrivateRoutesInfluencersSearchRoute
    }
    '/_private-routes/influencers/search/tiktok': {
      id: '/_private-routes/influencers/search/tiktok'
      path: '/tiktok'
      fullPath: '/influencers/search/tiktok'
      preLoaderRoute: typeof PrivateRoutesInfluencersSearchTiktokRouteImport
      parentRoute: typeof PrivateRoutesInfluencersSearchRoute
    }
    '/_private-routes/influencers/search/threads': {
      id: '/_private-routes/influencers/search/threads'
      path: '/threads'
      fullPath: '/influencers/search/threads'
      preLoaderRoute: typeof PrivateRoutesInfluencersSearchThreadsRouteImport
      parentRoute: typeof PrivateRoutesInfluencersSearchRoute
    }
    '/_private-routes/influencers/search/instagram': {
      id: '/_private-routes/influencers/search/instagram'
      path: '/instagram'
      fullPath: '/influencers/search/instagram'
      preLoaderRoute: typeof PrivateRoutesInfluencersSearchInstagramRouteImport
      parentRoute: typeof PrivateRoutesInfluencersSearchRoute
    }
    '/_private-routes/influencers/search/facebook_page': {
      id: '/_private-routes/influencers/search/facebook_page'
      path: '/facebook_page'
      fullPath: '/influencers/search/facebook_page'
      preLoaderRoute: typeof PrivateRoutesInfluencersSearchFacebook_pageRouteImport
      parentRoute: typeof PrivateRoutesInfluencersSearchRoute
    }
    '/_private-routes/influencers/search/facebook': {
      id: '/_private-routes/influencers/search/facebook'
      path: '/facebook'
      fullPath: '/influencers/search/facebook'
      preLoaderRoute: typeof PrivateRoutesInfluencersSearchFacebookRouteImport
      parentRoute: typeof PrivateRoutesInfluencersSearchRoute
    }
    '/_private-routes/influencers/search/douyin': {
      id: '/_private-routes/influencers/search/douyin'
      path: '/douyin'
      fullPath: '/influencers/search/douyin'
      preLoaderRoute: typeof PrivateRoutesInfluencersSearchDouyinRouteImport
      parentRoute: typeof PrivateRoutesInfluencersSearchRoute
    }
    '/_private-routes/influencer/$id/profile': {
      id: '/_private-routes/influencer/$id/profile'
      path: '/profile'
      fullPath: '/influencer/$id/profile'
      preLoaderRoute: typeof PrivateRoutesInfluencerIdProfileRouteImport
      parentRoute: typeof PrivateRoutesInfluencerIdRoute
    }
    '/_private-routes/hashtag-analytics/tiktok/keyword': {
      id: '/_private-routes/hashtag-analytics/tiktok/keyword'
      path: '/keyword'
      fullPath: '/hashtag-analytics/tiktok/keyword'
      preLoaderRoute: typeof PrivateRoutesHashtagAnalyticsTiktokKeywordRouteImport
      parentRoute: typeof PrivateRoutesHashtagAnalyticsTiktokRoute
    }
    '/_private-routes/hashtag-analytics/tiktok/hashtag': {
      id: '/_private-routes/hashtag-analytics/tiktok/hashtag'
      path: '/hashtag'
      fullPath: '/hashtag-analytics/tiktok/hashtag'
      preLoaderRoute: typeof PrivateRoutesHashtagAnalyticsTiktokHashtagRouteImport
      parentRoute: typeof PrivateRoutesHashtagAnalyticsTiktokRoute
    }
    '/_private-routes/hashtag-analytics/instagram/$countryId': {
      id: '/_private-routes/hashtag-analytics/instagram/$countryId'
      path: '/$countryId'
      fullPath: '/hashtag-analytics/instagram/$countryId'
      preLoaderRoute: typeof PrivateRoutesHashtagAnalyticsInstagramCountryIdRouteImport
      parentRoute: typeof PrivateRoutesHashtagAnalyticsInstagramRoute
    }
    '/_private-routes/engagement/$id/tracking-referral-codes': {
      id: '/_private-routes/engagement/$id/tracking-referral-codes'
      path: '/tracking-referral-codes'
      fullPath: '/engagement/$id/tracking-referral-codes'
      preLoaderRoute: typeof PrivateRoutesEngagementIdTrackingReferralCodesRouteImport
      parentRoute: typeof PrivateRoutesEngagementIdRoute
    }
    '/_private-routes/engagement/$id/tracking': {
      id: '/_private-routes/engagement/$id/tracking'
      path: '/tracking'
      fullPath: '/engagement/$id/tracking'
      preLoaderRoute: typeof PrivateRoutesEngagementIdTrackingRouteImport
      parentRoute: typeof PrivateRoutesEngagementIdRoute
    }
    '/_private-routes/engagement/$id/report': {
      id: '/_private-routes/engagement/$id/report'
      path: '/report'
      fullPath: '/engagement/$id/report'
      preLoaderRoute: typeof PrivateRoutesEngagementIdReportRouteImport
      parentRoute: typeof PrivateRoutesEngagementIdRoute
    }
    '/_private-routes/engagement/$id/proposal': {
      id: '/_private-routes/engagement/$id/proposal'
      path: '/proposal'
      fullPath: '/engagement/$id/proposal'
      preLoaderRoute: typeof PrivateRoutesEngagementIdProposalRouteImport
      parentRoute: typeof PrivateRoutesEngagementIdRoute
    }
    '/_private-routes/engagement/$id/posts': {
      id: '/_private-routes/engagement/$id/posts'
      path: '/posts'
      fullPath: '/engagement/$id/posts'
      preLoaderRoute: typeof PrivateRoutesEngagementIdPostsRouteImport
      parentRoute: typeof PrivateRoutesEngagementIdRoute
    }
    '/_private-routes/engagement/$id/influencer': {
      id: '/_private-routes/engagement/$id/influencer'
      path: '/influencer'
      fullPath: '/engagement/$id/influencer'
      preLoaderRoute: typeof PrivateRoutesEngagementIdInfluencerRouteImport
      parentRoute: typeof PrivateRoutesEngagementIdRoute
    }
    '/_private-routes/auto-managed/$id/report': {
      id: '/_private-routes/auto-managed/$id/report'
      path: '/report'
      fullPath: '/auto-managed/$id/report'
      preLoaderRoute: typeof PrivateRoutesAutoManagedIdReportRouteImport
      parentRoute: typeof PrivateRoutesAutoManagedIdRoute
    }
    '/_private-routes/auto-managed/$id/joined-influencers': {
      id: '/_private-routes/auto-managed/$id/joined-influencers'
      path: '/joined-influencers'
      fullPath: '/auto-managed/$id/joined-influencers'
      preLoaderRoute: typeof PrivateRoutesAutoManagedIdJoinedInfluencersRouteImport
      parentRoute: typeof PrivateRoutesAutoManagedIdRoute
    }
    '/_private-routes/auto-managed/$id/commissions': {
      id: '/_private-routes/auto-managed/$id/commissions'
      path: '/commissions'
      fullPath: '/auto-managed/$id/commissions'
      preLoaderRoute: typeof PrivateRoutesAutoManagedIdCommissionsRouteImport
      parentRoute: typeof PrivateRoutesAutoManagedIdRoute
    }
    '/_private-routes/agency/$id/users': {
      id: '/_private-routes/agency/$id/users'
      path: '/users'
      fullPath: '/agency/$id/users'
      preLoaderRoute: typeof PrivateRoutesAgencyIdUsersRouteImport
      parentRoute: typeof PrivateRoutesAgencyIdRoute
    }
    '/_private-routes/agency/$id/business': {
      id: '/_private-routes/agency/$id/business'
      path: '/business'
      fullPath: '/agency/$id/business'
      preLoaderRoute: typeof PrivateRoutesAgencyIdBusinessRouteImport
      parentRoute: typeof PrivateRoutesAgencyIdRoute
    }
    '/_private-routes/advertiser/$id/users': {
      id: '/_private-routes/advertiser/$id/users'
      path: '/users'
      fullPath: '/advertiser/$id/users'
      preLoaderRoute: typeof PrivateRoutesAdvertiserIdUsersRouteImport
      parentRoute: typeof PrivateRoutesAdvertiserIdRoute
    }
    '/_private-routes/advertiser/$id/budget-allocation': {
      id: '/_private-routes/advertiser/$id/budget-allocation'
      path: '/budget-allocation'
      fullPath: '/advertiser/$id/budget-allocation'
      preLoaderRoute: typeof PrivateRoutesAdvertiserIdBudgetAllocationRouteImport
      parentRoute: typeof PrivateRoutesAdvertiserIdRoute
    }
    '/_private-routes/tiktok/campaigns/$id/': {
      id: '/_private-routes/tiktok/campaigns/$id/'
      path: '/'
      fullPath: '/tiktok/campaigns/$id/'
      preLoaderRoute: typeof PrivateRoutesTiktokCampaignsIdIndexRouteImport
      parentRoute: typeof PrivateRoutesTiktokCampaignsIdRoute
    }
    '/_private-routes/tiktok/ad-campaign-report/$id/': {
      id: '/_private-routes/tiktok/ad-campaign-report/$id/'
      path: '/$id'
      fullPath: '/tiktok/ad-campaign-report/$id'
      preLoaderRoute: typeof PrivateRoutesTiktokAdCampaignReportIdIndexRouteImport
      parentRoute: typeof PrivateRoutesTiktokAdCampaignReportRoute
    }
    '/_private-routes/package/$id/content/': {
      id: '/_private-routes/package/$id/content/'
      path: '/'
      fullPath: '/package/$id/content/'
      preLoaderRoute: typeof PrivateRoutesPackageIdContentIndexRouteImport
      parentRoute: typeof PrivateRoutesPackageIdContentRoute
    }
    '/_private-routes/marketplace/add/e-commerce/': {
      id: '/_private-routes/marketplace/add/e-commerce/'
      path: '/e-commerce'
      fullPath: '/marketplace/add/e-commerce'
      preLoaderRoute: typeof PrivateRoutesMarketplaceAddECommerceIndexRouteImport
      parentRoute: typeof PrivateRoutesMarketplaceAddRoute
    }
    '/_private-routes/marketplace/$id/posts/': {
      id: '/_private-routes/marketplace/$id/posts/'
      path: '/'
      fullPath: '/marketplace/$id/posts/'
      preLoaderRoute: typeof PrivateRoutesMarketplaceIdPostsIndexRouteImport
      parentRoute: typeof PrivateRoutesMarketplaceIdPostsRoute
    }
    '/_private-routes/influencer/$id/profile/': {
      id: '/_private-routes/influencer/$id/profile/'
      path: '/'
      fullPath: '/influencer/$id/profile/'
      preLoaderRoute: typeof PrivateRoutesInfluencerIdProfileIndexRouteImport
      parentRoute: typeof PrivateRoutesInfluencerIdProfileRoute
    }
    '/_private-routes/hashtag-analytics/tiktok/keyword/': {
      id: '/_private-routes/hashtag-analytics/tiktok/keyword/'
      path: '/'
      fullPath: '/hashtag-analytics/tiktok/keyword/'
      preLoaderRoute: typeof PrivateRoutesHashtagAnalyticsTiktokKeywordIndexRouteImport
      parentRoute: typeof PrivateRoutesHashtagAnalyticsTiktokKeywordRoute
    }
    '/_private-routes/hashtag-analytics/tiktok/hashtag/': {
      id: '/_private-routes/hashtag-analytics/tiktok/hashtag/'
      path: '/'
      fullPath: '/hashtag-analytics/tiktok/hashtag/'
      preLoaderRoute: typeof PrivateRoutesHashtagAnalyticsTiktokHashtagIndexRouteImport
      parentRoute: typeof PrivateRoutesHashtagAnalyticsTiktokHashtagRoute
    }
    '/_private-routes/engagement/$id/posts/': {
      id: '/_private-routes/engagement/$id/posts/'
      path: '/'
      fullPath: '/engagement/$id/posts/'
      preLoaderRoute: typeof PrivateRoutesEngagementIdPostsIndexRouteImport
      parentRoute: typeof PrivateRoutesEngagementIdPostsRoute
    }
    '/_private-routes/engagement/$id/influencer/': {
      id: '/_private-routes/engagement/$id/influencer/'
      path: '/'
      fullPath: '/engagement/$id/influencer/'
      preLoaderRoute: typeof PrivateRoutesEngagementIdInfluencerIndexRouteImport
      parentRoute: typeof PrivateRoutesEngagementIdInfluencerRoute
    }
    '/_private-routes/tiktok/campaigns/$id/report': {
      id: '/_private-routes/tiktok/campaigns/$id/report'
      path: '/report'
      fullPath: '/tiktok/campaigns/$id/report'
      preLoaderRoute: typeof PrivateRoutesTiktokCampaignsIdReportRouteImport
      parentRoute: typeof PrivateRoutesTiktokCampaignsIdRoute
    }
    '/_private-routes/tiktok/campaigns/$id/posts': {
      id: '/_private-routes/tiktok/campaigns/$id/posts'
      path: '/posts'
      fullPath: '/tiktok/campaigns/$id/posts'
      preLoaderRoute: typeof PrivateRoutesTiktokCampaignsIdPostsRouteImport
      parentRoute: typeof PrivateRoutesTiktokCampaignsIdRoute
    }
    '/_private-routes/tiktok/campaigns/$id/influencers': {
      id: '/_private-routes/tiktok/campaigns/$id/influencers'
      path: '/influencers'
      fullPath: '/tiktok/campaigns/$id/influencers'
      preLoaderRoute: typeof PrivateRoutesTiktokCampaignsIdInfluencersRouteImport
      parentRoute: typeof PrivateRoutesTiktokCampaignsIdRoute
    }
    '/_private-routes/tiktok/ad-campaign-report/$id/$groupId': {
      id: '/_private-routes/tiktok/ad-campaign-report/$id/$groupId'
      path: '/$id/$groupId'
      fullPath: '/tiktok/ad-campaign-report/$id/$groupId'
      preLoaderRoute: typeof PrivateRoutesTiktokAdCampaignReportIdGroupIdRouteImport
      parentRoute: typeof PrivateRoutesTiktokAdCampaignReportRoute
    }
    '/_private-routes/package/$id/content/search': {
      id: '/_private-routes/package/$id/content/search'
      path: '/search'
      fullPath: '/package/$id/content/search'
      preLoaderRoute: typeof PrivateRoutesPackageIdContentSearchRouteImport
      parentRoute: typeof PrivateRoutesPackageIdContentRoute
    }
    '/_private-routes/package/$id/content/list': {
      id: '/_private-routes/package/$id/content/list'
      path: '/list'
      fullPath: '/package/$id/content/list'
      preLoaderRoute: typeof PrivateRoutesPackageIdContentListRouteImport
      parentRoute: typeof PrivateRoutesPackageIdContentRoute
    }
    '/_private-routes/marketplace/add/e-commerce/$autoMangedCampaignId': {
      id: '/_private-routes/marketplace/add/e-commerce/$autoMangedCampaignId'
      path: '/e-commerce/$autoMangedCampaignId'
      fullPath: '/marketplace/add/e-commerce/$autoMangedCampaignId'
      preLoaderRoute: typeof PrivateRoutesMarketplaceAddECommerceAutoMangedCampaignIdRouteImport
      parentRoute: typeof PrivateRoutesMarketplaceAddRoute
    }
    '/_private-routes/marketplace/$id/posts/$postId': {
      id: '/_private-routes/marketplace/$id/posts/$postId'
      path: '/$postId'
      fullPath: '/marketplace/$id/posts/$postId'
      preLoaderRoute: typeof PrivateRoutesMarketplaceIdPostsPostIdRouteImport
      parentRoute: typeof PrivateRoutesMarketplaceIdPostsRoute
    }
    '/_private-routes/influencer/$id/profile/compare': {
      id: '/_private-routes/influencer/$id/profile/compare'
      path: '/compare'
      fullPath: '/influencer/$id/profile/compare'
      preLoaderRoute: typeof PrivateRoutesInfluencerIdProfileCompareRouteImport
      parentRoute: typeof PrivateRoutesInfluencerIdProfileRoute
    }
    '/_private-routes/influencer/$id/profile/campaigns': {
      id: '/_private-routes/influencer/$id/profile/campaigns'
      path: '/campaigns'
      fullPath: '/influencer/$id/profile/campaigns'
      preLoaderRoute: typeof PrivateRoutesInfluencerIdProfileCampaignsRouteImport
      parentRoute: typeof PrivateRoutesInfluencerIdProfileRoute
    }
    '/_private-routes/influencer/$id/$socialMediaAccountId/youtube_tags_ranking': {
      id: '/_private-routes/influencer/$id/$socialMediaAccountId/youtube_tags_ranking'
      path: '/$socialMediaAccountId/youtube_tags_ranking'
      fullPath: '/influencer/$id/$socialMediaAccountId/youtube_tags_ranking'
      preLoaderRoute: typeof PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_tags_rankingRouteImport
      parentRoute: typeof PrivateRoutesInfluencerIdRoute
    }
    '/_private-routes/influencer/$id/$socialMediaAccountId/youtube_compare_feed_videos': {
      id: '/_private-routes/influencer/$id/$socialMediaAccountId/youtube_compare_feed_videos'
      path: '/$socialMediaAccountId/youtube_compare_feed_videos'
      fullPath: '/influencer/$id/$socialMediaAccountId/youtube_compare_feed_videos'
      preLoaderRoute: typeof PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_compare_feed_videosRouteImport
      parentRoute: typeof PrivateRoutesInfluencerIdRoute
    }
    '/_private-routes/influencer/$id/$socialMediaAccountId/xhs_video_posts': {
      id: '/_private-routes/influencer/$id/$socialMediaAccountId/xhs_video_posts'
      path: '/$socialMediaAccountId/xhs_video_posts'
      fullPath: '/influencer/$id/$socialMediaAccountId/xhs_video_posts'
      preLoaderRoute: typeof PrivateRoutesInfluencerIdSocialMediaAccountIdXhs_video_postsRouteImport
      parentRoute: typeof PrivateRoutesInfluencerIdRoute
    }
    '/_private-routes/influencer/$id/$socialMediaAccountId/xhs_picture_posts': {
      id: '/_private-routes/influencer/$id/$socialMediaAccountId/xhs_picture_posts'
      path: '/$socialMediaAccountId/xhs_picture_posts'
      fullPath: '/influencer/$id/$socialMediaAccountId/xhs_picture_posts'
      preLoaderRoute: typeof PrivateRoutesInfluencerIdSocialMediaAccountIdXhs_picture_postsRouteImport
      parentRoute: typeof PrivateRoutesInfluencerIdRoute
    }
    '/_private-routes/influencer/$id/$socialMediaAccountId/twitter_feed_posts': {
      id: '/_private-routes/influencer/$id/$socialMediaAccountId/twitter_feed_posts'
      path: '/$socialMediaAccountId/twitter_feed_posts'
      fullPath: '/influencer/$id/$socialMediaAccountId/twitter_feed_posts'
      preLoaderRoute: typeof PrivateRoutesInfluencerIdSocialMediaAccountIdTwitter_feed_postsRouteImport
      parentRoute: typeof PrivateRoutesInfluencerIdRoute
    }
    '/_private-routes/influencer/$id/$socialMediaAccountId/sponsored_youtube_feed_posts': {
      id: '/_private-routes/influencer/$id/$socialMediaAccountId/sponsored_youtube_feed_posts'
      path: '/$socialMediaAccountId/sponsored_youtube_feed_posts'
      fullPath: '/influencer/$id/$socialMediaAccountId/sponsored_youtube_feed_posts'
      preLoaderRoute: typeof PrivateRoutesInfluencerIdSocialMediaAccountIdSponsored_youtube_feed_postsRouteImport
      parentRoute: typeof PrivateRoutesInfluencerIdRoute
    }
    '/_private-routes/influencer/$id/$socialMediaAccountId/sponsored_feed_posts': {
      id: '/_private-routes/influencer/$id/$socialMediaAccountId/sponsored_feed_posts'
      path: '/$socialMediaAccountId/sponsored_feed_posts'
      fullPath: '/influencer/$id/$socialMediaAccountId/sponsored_feed_posts'
      preLoaderRoute: typeof PrivateRoutesInfluencerIdSocialMediaAccountIdSponsored_feed_postsRouteImport
      parentRoute: typeof PrivateRoutesInfluencerIdRoute
    }
    '/_private-routes/influencer/$id/$socialMediaAccountId/shorts': {
      id: '/_private-routes/influencer/$id/$socialMediaAccountId/shorts'
      path: '/$socialMediaAccountId/shorts'
      fullPath: '/influencer/$id/$socialMediaAccountId/shorts'
      preLoaderRoute: typeof PrivateRoutesInfluencerIdSocialMediaAccountIdShortsRouteImport
      parentRoute: typeof PrivateRoutesInfluencerIdRoute
    }
    '/_private-routes/influencer/$id/$socialMediaAccountId/scraping_feed_posts': {
      id: '/_private-routes/influencer/$id/$socialMediaAccountId/scraping_feed_posts'
      path: '/$socialMediaAccountId/scraping_feed_posts'
      fullPath: '/influencer/$id/$socialMediaAccountId/scraping_feed_posts'
      preLoaderRoute: typeof PrivateRoutesInfluencerIdSocialMediaAccountIdScraping_feed_postsRouteImport
      parentRoute: typeof PrivateRoutesInfluencerIdRoute
    }
    '/_private-routes/influencer/$id/$socialMediaAccountId/instagram_story_post': {
      id: '/_private-routes/influencer/$id/$socialMediaAccountId/instagram_story_post'
      path: '/$socialMediaAccountId/instagram_story_post'
      fullPath: '/influencer/$id/$socialMediaAccountId/instagram_story_post'
      preLoaderRoute: typeof PrivateRoutesInfluencerIdSocialMediaAccountIdInstagram_story_postRouteImport
      parentRoute: typeof PrivateRoutesInfluencerIdRoute
    }
    '/_private-routes/influencer/$id/$socialMediaAccountId/instagram_reel_post': {
      id: '/_private-routes/influencer/$id/$socialMediaAccountId/instagram_reel_post'
      path: '/$socialMediaAccountId/instagram_reel_post'
      fullPath: '/influencer/$id/$socialMediaAccountId/instagram_reel_post'
      preLoaderRoute: typeof PrivateRoutesInfluencerIdSocialMediaAccountIdInstagram_reel_postRouteImport
      parentRoute: typeof PrivateRoutesInfluencerIdRoute
    }
    '/_private-routes/influencer/$id/$socialMediaAccountId/instagram_feed_post': {
      id: '/_private-routes/influencer/$id/$socialMediaAccountId/instagram_feed_post'
      path: '/$socialMediaAccountId/instagram_feed_post'
      fullPath: '/influencer/$id/$socialMediaAccountId/instagram_feed_post'
      preLoaderRoute: typeof PrivateRoutesInfluencerIdSocialMediaAccountIdInstagram_feed_postRouteImport
      parentRoute: typeof PrivateRoutesInfluencerIdRoute
    }
    '/_private-routes/influencer/$id/$socialMediaAccountId/feed_videos': {
      id: '/_private-routes/influencer/$id/$socialMediaAccountId/feed_videos'
      path: '/$socialMediaAccountId/feed_videos'
      fullPath: '/influencer/$id/$socialMediaAccountId/feed_videos'
      preLoaderRoute: typeof PrivateRoutesInfluencerIdSocialMediaAccountIdFeed_videosRouteImport
      parentRoute: typeof PrivateRoutesInfluencerIdRoute
    }
    '/_private-routes/influencer/$id/$socialMediaAccountId/facebook_feed_post': {
      id: '/_private-routes/influencer/$id/$socialMediaAccountId/facebook_feed_post'
      path: '/$socialMediaAccountId/facebook_feed_post'
      fullPath: '/influencer/$id/$socialMediaAccountId/facebook_feed_post'
      preLoaderRoute: typeof PrivateRoutesInfluencerIdSocialMediaAccountIdFacebook_feed_postRouteImport
      parentRoute: typeof PrivateRoutesInfluencerIdRoute
    }
    '/_private-routes/hashtag-analytics/tiktok/keyword/$countryId': {
      id: '/_private-routes/hashtag-analytics/tiktok/keyword/$countryId'
      path: '/$countryId'
      fullPath: '/hashtag-analytics/tiktok/keyword/$countryId'
      preLoaderRoute: typeof PrivateRoutesHashtagAnalyticsTiktokKeywordCountryIdRouteImport
      parentRoute: typeof PrivateRoutesHashtagAnalyticsTiktokKeywordRoute
    }
    '/_private-routes/hashtag-analytics/tiktok/hashtag/$countryId': {
      id: '/_private-routes/hashtag-analytics/tiktok/hashtag/$countryId'
      path: '/$countryId'
      fullPath: '/hashtag-analytics/tiktok/hashtag/$countryId'
      preLoaderRoute: typeof PrivateRoutesHashtagAnalyticsTiktokHashtagCountryIdRouteImport
      parentRoute: typeof PrivateRoutesHashtagAnalyticsTiktokHashtagRoute
    }
    '/_private-routes/engagement/$id/posts/add': {
      id: '/_private-routes/engagement/$id/posts/add'
      path: '/add'
      fullPath: '/engagement/$id/posts/add'
      preLoaderRoute: typeof PrivateRoutesEngagementIdPostsAddRouteImport
      parentRoute: typeof PrivateRoutesEngagementIdPostsRoute
    }
    '/_private-routes/engagement/$id/posts/$postId': {
      id: '/_private-routes/engagement/$id/posts/$postId'
      path: '/$postId'
      fullPath: '/engagement/$id/posts/$postId'
      preLoaderRoute: typeof PrivateRoutesEngagementIdPostsPostIdRouteImport
      parentRoute: typeof PrivateRoutesEngagementIdPostsRoute
    }
    '/_private-routes/engagement/$id/influencer/youtube': {
      id: '/_private-routes/engagement/$id/influencer/youtube'
      path: '/youtube'
      fullPath: '/engagement/$id/influencer/youtube'
      preLoaderRoute: typeof PrivateRoutesEngagementIdInfluencerYoutubeRouteImport
      parentRoute: typeof PrivateRoutesEngagementIdInfluencerRoute
    }
    '/_private-routes/engagement/$id/influencer/xhs': {
      id: '/_private-routes/engagement/$id/influencer/xhs'
      path: '/xhs'
      fullPath: '/engagement/$id/influencer/xhs'
      preLoaderRoute: typeof PrivateRoutesEngagementIdInfluencerXhsRouteImport
      parentRoute: typeof PrivateRoutesEngagementIdInfluencerRoute
    }
    '/_private-routes/engagement/$id/influencer/twitter': {
      id: '/_private-routes/engagement/$id/influencer/twitter'
      path: '/twitter'
      fullPath: '/engagement/$id/influencer/twitter'
      preLoaderRoute: typeof PrivateRoutesEngagementIdInfluencerTwitterRouteImport
      parentRoute: typeof PrivateRoutesEngagementIdInfluencerRoute
    }
    '/_private-routes/engagement/$id/influencer/tiktok': {
      id: '/_private-routes/engagement/$id/influencer/tiktok'
      path: '/tiktok'
      fullPath: '/engagement/$id/influencer/tiktok'
      preLoaderRoute: typeof PrivateRoutesEngagementIdInfluencerTiktokRouteImport
      parentRoute: typeof PrivateRoutesEngagementIdInfluencerRoute
    }
    '/_private-routes/engagement/$id/influencer/threads': {
      id: '/_private-routes/engagement/$id/influencer/threads'
      path: '/threads'
      fullPath: '/engagement/$id/influencer/threads'
      preLoaderRoute: typeof PrivateRoutesEngagementIdInfluencerThreadsRouteImport
      parentRoute: typeof PrivateRoutesEngagementIdInfluencerRoute
    }
    '/_private-routes/engagement/$id/influencer/posts': {
      id: '/_private-routes/engagement/$id/influencer/posts'
      path: '/posts'
      fullPath: '/engagement/$id/influencer/posts'
      preLoaderRoute: typeof PrivateRoutesEngagementIdInfluencerPostsRouteImport
      parentRoute: typeof PrivateRoutesEngagementIdInfluencerRoute
    }
    '/_private-routes/engagement/$id/influencer/packages': {
      id: '/_private-routes/engagement/$id/influencer/packages'
      path: '/packages'
      fullPath: '/engagement/$id/influencer/packages'
      preLoaderRoute: typeof PrivateRoutesEngagementIdInfluencerPackagesRouteImport
      parentRoute: typeof PrivateRoutesEngagementIdInfluencerRoute
    }
    '/_private-routes/engagement/$id/influencer/instagram': {
      id: '/_private-routes/engagement/$id/influencer/instagram'
      path: '/instagram'
      fullPath: '/engagement/$id/influencer/instagram'
      preLoaderRoute: typeof PrivateRoutesEngagementIdInfluencerInstagramRouteImport
      parentRoute: typeof PrivateRoutesEngagementIdInfluencerRoute
    }
    '/_private-routes/engagement/$id/influencer/facebook_page': {
      id: '/_private-routes/engagement/$id/influencer/facebook_page'
      path: '/facebook_page'
      fullPath: '/engagement/$id/influencer/facebook_page'
      preLoaderRoute: typeof PrivateRoutesEngagementIdInfluencerFacebook_pageRouteImport
      parentRoute: typeof PrivateRoutesEngagementIdInfluencerRoute
    }
    '/_private-routes/engagement/$id/influencer/facebook': {
      id: '/_private-routes/engagement/$id/influencer/facebook'
      path: '/facebook'
      fullPath: '/engagement/$id/influencer/facebook'
      preLoaderRoute: typeof PrivateRoutesEngagementIdInfluencerFacebookRouteImport
      parentRoute: typeof PrivateRoutesEngagementIdInfluencerRoute
    }
    '/_private-routes/engagement/$id/influencer/douyin': {
      id: '/_private-routes/engagement/$id/influencer/douyin'
      path: '/douyin'
      fullPath: '/engagement/$id/influencer/douyin'
      preLoaderRoute: typeof PrivateRoutesEngagementIdInfluencerDouyinRouteImport
      parentRoute: typeof PrivateRoutesEngagementIdInfluencerRoute
    }
    '/_private-routes/engagement/$id/influencer/campaigns': {
      id: '/_private-routes/engagement/$id/influencer/campaigns'
      path: '/campaigns'
      fullPath: '/engagement/$id/influencer/campaigns'
      preLoaderRoute: typeof PrivateRoutesEngagementIdInfluencerCampaignsRouteImport
      parentRoute: typeof PrivateRoutesEngagementIdInfluencerRoute
    }
    '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId': {
      id: '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId'
      path: '/$brandAccountId/$socialMedia/$socialMediaAccountId'
      fullPath: '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId'
      preLoaderRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRouteImport
      parentRoute: typeof PrivateRoutesAnalyticsRoute
    }
    '/_private-routes/tiktok/campaigns/$id/posts/': {
      id: '/_private-routes/tiktok/campaigns/$id/posts/'
      path: '/'
      fullPath: '/tiktok/campaigns/$id/posts/'
      preLoaderRoute: typeof PrivateRoutesTiktokCampaignsIdPostsIndexRouteImport
      parentRoute: typeof PrivateRoutesTiktokCampaignsIdPostsRoute
    }
    '/_private-routes/package/$id/content/search/': {
      id: '/_private-routes/package/$id/content/search/'
      path: '/'
      fullPath: '/package/$id/content/search/'
      preLoaderRoute: typeof PrivateRoutesPackageIdContentSearchIndexRouteImport
      parentRoute: typeof PrivateRoutesPackageIdContentSearchRoute
    }
    '/_private-routes/influencer/$id/$socialMediaAccountId/youtube_compare_feed_videos/': {
      id: '/_private-routes/influencer/$id/$socialMediaAccountId/youtube_compare_feed_videos/'
      path: '/'
      fullPath: '/influencer/$id/$socialMediaAccountId/youtube_compare_feed_videos/'
      preLoaderRoute: typeof PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_compare_feed_videosIndexRouteImport
      parentRoute: typeof PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_compare_feed_videosRoute
    }
    '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/': {
      id: '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/'
      path: '/'
      fullPath: '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/'
      preLoaderRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdIndexRouteImport
      parentRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute
    }
    '/_private-routes/tiktok/campaigns/$id/posts/$postId': {
      id: '/_private-routes/tiktok/campaigns/$id/posts/$postId'
      path: '/$postId'
      fullPath: '/tiktok/campaigns/$id/posts/$postId'
      preLoaderRoute: typeof PrivateRoutesTiktokCampaignsIdPostsPostIdRouteImport
      parentRoute: typeof PrivateRoutesTiktokCampaignsIdPostsRoute
    }
    '/_private-routes/package/$id/content/search/youtube': {
      id: '/_private-routes/package/$id/content/search/youtube'
      path: '/youtube'
      fullPath: '/package/$id/content/search/youtube'
      preLoaderRoute: typeof PrivateRoutesPackageIdContentSearchYoutubeRouteImport
      parentRoute: typeof PrivateRoutesPackageIdContentSearchRoute
    }
    '/_private-routes/package/$id/content/search/xhs': {
      id: '/_private-routes/package/$id/content/search/xhs'
      path: '/xhs'
      fullPath: '/package/$id/content/search/xhs'
      preLoaderRoute: typeof PrivateRoutesPackageIdContentSearchXhsRouteImport
      parentRoute: typeof PrivateRoutesPackageIdContentSearchRoute
    }
    '/_private-routes/package/$id/content/search/twitter': {
      id: '/_private-routes/package/$id/content/search/twitter'
      path: '/twitter'
      fullPath: '/package/$id/content/search/twitter'
      preLoaderRoute: typeof PrivateRoutesPackageIdContentSearchTwitterRouteImport
      parentRoute: typeof PrivateRoutesPackageIdContentSearchRoute
    }
    '/_private-routes/package/$id/content/search/tiktok': {
      id: '/_private-routes/package/$id/content/search/tiktok'
      path: '/tiktok'
      fullPath: '/package/$id/content/search/tiktok'
      preLoaderRoute: typeof PrivateRoutesPackageIdContentSearchTiktokRouteImport
      parentRoute: typeof PrivateRoutesPackageIdContentSearchRoute
    }
    '/_private-routes/package/$id/content/search/threads': {
      id: '/_private-routes/package/$id/content/search/threads'
      path: '/threads'
      fullPath: '/package/$id/content/search/threads'
      preLoaderRoute: typeof PrivateRoutesPackageIdContentSearchThreadsRouteImport
      parentRoute: typeof PrivateRoutesPackageIdContentSearchRoute
    }
    '/_private-routes/package/$id/content/search/instagram': {
      id: '/_private-routes/package/$id/content/search/instagram'
      path: '/instagram'
      fullPath: '/package/$id/content/search/instagram'
      preLoaderRoute: typeof PrivateRoutesPackageIdContentSearchInstagramRouteImport
      parentRoute: typeof PrivateRoutesPackageIdContentSearchRoute
    }
    '/_private-routes/package/$id/content/search/facebook_page': {
      id: '/_private-routes/package/$id/content/search/facebook_page'
      path: '/facebook_page'
      fullPath: '/package/$id/content/search/facebook_page'
      preLoaderRoute: typeof PrivateRoutesPackageIdContentSearchFacebook_pageRouteImport
      parentRoute: typeof PrivateRoutesPackageIdContentSearchRoute
    }
    '/_private-routes/package/$id/content/search/facebook': {
      id: '/_private-routes/package/$id/content/search/facebook'
      path: '/facebook'
      fullPath: '/package/$id/content/search/facebook'
      preLoaderRoute: typeof PrivateRoutesPackageIdContentSearchFacebookRouteImport
      parentRoute: typeof PrivateRoutesPackageIdContentSearchRoute
    }
    '/_private-routes/package/$id/content/search/douyin': {
      id: '/_private-routes/package/$id/content/search/douyin'
      path: '/douyin'
      fullPath: '/package/$id/content/search/douyin'
      preLoaderRoute: typeof PrivateRoutesPackageIdContentSearchDouyinRouteImport
      parentRoute: typeof PrivateRoutesPackageIdContentSearchRoute
    }
    '/_private-routes/influencer/$id/$socialMediaAccountId/youtube_compare_feed_videos/$compareId': {
      id: '/_private-routes/influencer/$id/$socialMediaAccountId/youtube_compare_feed_videos/$compareId'
      path: '/$compareId'
      fullPath: '/influencer/$id/$socialMediaAccountId/youtube_compare_feed_videos/$compareId'
      preLoaderRoute: typeof PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_compare_feed_videosCompareIdRouteImport
      parentRoute: typeof PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_compare_feed_videosRoute
    }
    '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/ugc': {
      id: '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/ugc'
      path: '/ugc'
      fullPath: '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/ugc'
      preLoaderRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdUgcRouteImport
      parentRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute
    }
    '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/trend': {
      id: '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/trend'
      path: '/trend'
      fullPath: '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/trend'
      preLoaderRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdTrendRouteImport
      parentRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute
    }
    '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/hashtag': {
      id: '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/hashtag'
      path: '/hashtag'
      fullPath: '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/hashtag'
      preLoaderRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdHashtagRouteImport
      parentRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute
    }
    '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/interaction/': {
      id: '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/interaction/'
      path: '/interaction'
      fullPath: '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/interaction'
      preLoaderRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionIndexRouteImport
      parentRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute
    }
    '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/': {
      id: '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/'
      path: '/dashboard'
      fullPath: '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard'
      preLoaderRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardIndexRouteImport
      parentRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute
    }
    '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/compare/': {
      id: '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/compare/'
      path: '/compare'
      fullPath: '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/compare'
      preLoaderRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdCompareIndexRouteImport
      parentRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute
    }
    '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/interaction/tagged_posts': {
      id: '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/interaction/tagged_posts'
      path: '/interaction/tagged_posts'
      fullPath: '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/interaction/tagged_posts'
      preLoaderRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionTagged_postsRouteImport
      parentRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute
    }
    '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/interaction/mentioned_posts': {
      id: '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/interaction/mentioned_posts'
      path: '/interaction/mentioned_posts'
      fullPath: '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/interaction/mentioned_posts'
      preLoaderRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionMentioned_postsRouteImport
      parentRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute
    }
    '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/interaction/brand-ambassadors': {
      id: '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/interaction/brand-ambassadors'
      path: '/interaction/brand-ambassadors'
      fullPath: '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/interaction/brand-ambassadors'
      preLoaderRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionBrandAmbassadorsRouteImport
      parentRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute
    }
    '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/youtube_comments': {
      id: '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/youtube_comments'
      path: '/dashboard/youtube_comments'
      fullPath: '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/youtube_comments'
      preLoaderRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardYoutube_commentsRouteImport
      parentRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute
    }
    '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/twitter_feed_posts': {
      id: '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/twitter_feed_posts'
      path: '/dashboard/twitter_feed_posts'
      fullPath: '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/twitter_feed_posts'
      preLoaderRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardTwitter_feed_postsRouteImport
      parentRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute
    }
    '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/tag_ranking_list': {
      id: '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/tag_ranking_list'
      path: '/dashboard/tag_ranking_list'
      fullPath: '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/tag_ranking_list'
      preLoaderRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardTag_ranking_listRouteImport
      parentRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute
    }
    '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/shorts': {
      id: '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/shorts'
      path: '/dashboard/shorts'
      fullPath: '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/shorts'
      preLoaderRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardShortsRouteImport
      parentRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute
    }
    '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/instagram_story_post': {
      id: '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/instagram_story_post'
      path: '/dashboard/instagram_story_post'
      fullPath: '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/instagram_story_post'
      preLoaderRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_story_postRouteImport
      parentRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute
    }
    '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/instagram_reel_post': {
      id: '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/instagram_reel_post'
      path: '/dashboard/instagram_reel_post'
      fullPath: '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/instagram_reel_post'
      preLoaderRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_reel_postRouteImport
      parentRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute
    }
    '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/instagram_feed_post': {
      id: '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/instagram_feed_post'
      path: '/dashboard/instagram_feed_post'
      fullPath: '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/instagram_feed_post'
      preLoaderRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_feed_postRouteImport
      parentRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute
    }
    '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/instagram_comments': {
      id: '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/instagram_comments'
      path: '/dashboard/instagram_comments'
      fullPath: '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/instagram_comments'
      preLoaderRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_commentsRouteImport
      parentRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute
    }
    '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/feed_videos': {
      id: '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/feed_videos'
      path: '/dashboard/feed_videos'
      fullPath: '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/feed_videos'
      preLoaderRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardFeed_videosRouteImport
      parentRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute
    }
    '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/facebook_feed_post': {
      id: '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/facebook_feed_post'
      path: '/dashboard/facebook_feed_post'
      fullPath: '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/dashboard/facebook_feed_post'
      preLoaderRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardFacebook_feed_postRouteImport
      parentRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute
    }
    '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/compare/youtube_compare_feed_videos': {
      id: '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/compare/youtube_compare_feed_videos'
      path: '/compare/youtube_compare_feed_videos'
      fullPath: '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/compare/youtube_compare_feed_videos'
      preLoaderRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdCompareYoutube_compare_feed_videosRouteImport
      parentRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute
    }
    '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/compare/instagram_compare_feed_post': {
      id: '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/compare/instagram_compare_feed_post'
      path: '/compare/instagram_compare_feed_post'
      fullPath: '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/compare/instagram_compare_feed_post'
      preLoaderRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdCompareInstagram_compare_feed_postRouteImport
      parentRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute
    }
  }
}

interface PrivateRoutesAdvertiserIdRouteChildren {
  PrivateRoutesAdvertiserIdBudgetAllocationRoute: typeof PrivateRoutesAdvertiserIdBudgetAllocationRoute
  PrivateRoutesAdvertiserIdUsersRoute: typeof PrivateRoutesAdvertiserIdUsersRoute
  PrivateRoutesAdvertiserIdIndexRoute: typeof PrivateRoutesAdvertiserIdIndexRoute
}

const PrivateRoutesAdvertiserIdRouteChildren: PrivateRoutesAdvertiserIdRouteChildren =
  {
    PrivateRoutesAdvertiserIdBudgetAllocationRoute:
      PrivateRoutesAdvertiserIdBudgetAllocationRoute,
    PrivateRoutesAdvertiserIdUsersRoute: PrivateRoutesAdvertiserIdUsersRoute,
    PrivateRoutesAdvertiserIdIndexRoute: PrivateRoutesAdvertiserIdIndexRoute,
  }

const PrivateRoutesAdvertiserIdRouteWithChildren =
  PrivateRoutesAdvertiserIdRoute._addFileChildren(
    PrivateRoutesAdvertiserIdRouteChildren,
  )

interface PrivateRoutesAdvertiserRouteChildren {
  PrivateRoutesAdvertiserIdRoute: typeof PrivateRoutesAdvertiserIdRouteWithChildren
  PrivateRoutesAdvertiserAddRoute: typeof PrivateRoutesAdvertiserAddRoute
  PrivateRoutesAdvertiserIndexRoute: typeof PrivateRoutesAdvertiserIndexRoute
}

const PrivateRoutesAdvertiserRouteChildren: PrivateRoutesAdvertiserRouteChildren =
  {
    PrivateRoutesAdvertiserIdRoute: PrivateRoutesAdvertiserIdRouteWithChildren,
    PrivateRoutesAdvertiserAddRoute: PrivateRoutesAdvertiserAddRoute,
    PrivateRoutesAdvertiserIndexRoute: PrivateRoutesAdvertiserIndexRoute,
  }

const PrivateRoutesAdvertiserRouteWithChildren =
  PrivateRoutesAdvertiserRoute._addFileChildren(
    PrivateRoutesAdvertiserRouteChildren,
  )

interface PrivateRoutesAgencyIdRouteChildren {
  PrivateRoutesAgencyIdBusinessRoute: typeof PrivateRoutesAgencyIdBusinessRoute
  PrivateRoutesAgencyIdUsersRoute: typeof PrivateRoutesAgencyIdUsersRoute
  PrivateRoutesAgencyIdIndexRoute: typeof PrivateRoutesAgencyIdIndexRoute
}

const PrivateRoutesAgencyIdRouteChildren: PrivateRoutesAgencyIdRouteChildren = {
  PrivateRoutesAgencyIdBusinessRoute: PrivateRoutesAgencyIdBusinessRoute,
  PrivateRoutesAgencyIdUsersRoute: PrivateRoutesAgencyIdUsersRoute,
  PrivateRoutesAgencyIdIndexRoute: PrivateRoutesAgencyIdIndexRoute,
}

const PrivateRoutesAgencyIdRouteWithChildren =
  PrivateRoutesAgencyIdRoute._addFileChildren(
    PrivateRoutesAgencyIdRouteChildren,
  )

interface PrivateRoutesAgencyRouteChildren {
  PrivateRoutesAgencyIdRoute: typeof PrivateRoutesAgencyIdRouteWithChildren
  PrivateRoutesAgencyAddRoute: typeof PrivateRoutesAgencyAddRoute
  PrivateRoutesAgencyIndexRoute: typeof PrivateRoutesAgencyIndexRoute
}

const PrivateRoutesAgencyRouteChildren: PrivateRoutesAgencyRouteChildren = {
  PrivateRoutesAgencyIdRoute: PrivateRoutesAgencyIdRouteWithChildren,
  PrivateRoutesAgencyAddRoute: PrivateRoutesAgencyAddRoute,
  PrivateRoutesAgencyIndexRoute: PrivateRoutesAgencyIndexRoute,
}

const PrivateRoutesAgencyRouteWithChildren =
  PrivateRoutesAgencyRoute._addFileChildren(PrivateRoutesAgencyRouteChildren)

interface PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRouteChildren {
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdHashtagRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdHashtagRoute
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdTrendRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdTrendRoute
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdUgcRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdUgcRoute
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdIndexRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdIndexRoute
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdCompareInstagram_compare_feed_postRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdCompareInstagram_compare_feed_postRoute
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdCompareYoutube_compare_feed_videosRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdCompareYoutube_compare_feed_videosRoute
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardFacebook_feed_postRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardFacebook_feed_postRoute
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardFeed_videosRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardFeed_videosRoute
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_commentsRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_commentsRoute
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_feed_postRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_feed_postRoute
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_reel_postRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_reel_postRoute
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_story_postRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_story_postRoute
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardShortsRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardShortsRoute
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardTag_ranking_listRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardTag_ranking_listRoute
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardTwitter_feed_postsRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardTwitter_feed_postsRoute
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardYoutube_commentsRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardYoutube_commentsRoute
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionBrandAmbassadorsRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionBrandAmbassadorsRoute
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionMentioned_postsRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionMentioned_postsRoute
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionTagged_postsRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionTagged_postsRoute
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdCompareIndexRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdCompareIndexRoute
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardIndexRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardIndexRoute
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionIndexRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionIndexRoute
}

const PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRouteChildren: PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRouteChildren =
  {
    PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdHashtagRoute:
      PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdHashtagRoute,
    PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdTrendRoute:
      PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdTrendRoute,
    PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdUgcRoute:
      PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdUgcRoute,
    PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdIndexRoute:
      PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdIndexRoute,
    PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdCompareInstagram_compare_feed_postRoute:
      PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdCompareInstagram_compare_feed_postRoute,
    PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdCompareYoutube_compare_feed_videosRoute:
      PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdCompareYoutube_compare_feed_videosRoute,
    PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardFacebook_feed_postRoute:
      PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardFacebook_feed_postRoute,
    PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardFeed_videosRoute:
      PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardFeed_videosRoute,
    PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_commentsRoute:
      PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_commentsRoute,
    PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_feed_postRoute:
      PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_feed_postRoute,
    PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_reel_postRoute:
      PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_reel_postRoute,
    PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_story_postRoute:
      PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardInstagram_story_postRoute,
    PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardShortsRoute:
      PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardShortsRoute,
    PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardTag_ranking_listRoute:
      PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardTag_ranking_listRoute,
    PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardTwitter_feed_postsRoute:
      PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardTwitter_feed_postsRoute,
    PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardYoutube_commentsRoute:
      PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardYoutube_commentsRoute,
    PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionBrandAmbassadorsRoute:
      PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionBrandAmbassadorsRoute,
    PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionMentioned_postsRoute:
      PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionMentioned_postsRoute,
    PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionTagged_postsRoute:
      PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionTagged_postsRoute,
    PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdCompareIndexRoute:
      PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdCompareIndexRoute,
    PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardIndexRoute:
      PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdDashboardIndexRoute,
    PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionIndexRoute:
      PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdInteractionIndexRoute,
  }

const PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRouteWithChildren =
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute._addFileChildren(
    PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRouteChildren,
  )

interface PrivateRoutesAnalyticsRouteChildren {
  PrivateRoutesAnalyticsAddRoute: typeof PrivateRoutesAnalyticsAddRoute
  PrivateRoutesAnalyticsIndexRoute: typeof PrivateRoutesAnalyticsIndexRoute
  PrivateRoutesAnalyticsBrandAccountIdIndexRoute: typeof PrivateRoutesAnalyticsBrandAccountIdIndexRoute
  PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute: typeof PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRouteWithChildren
}

const PrivateRoutesAnalyticsRouteChildren: PrivateRoutesAnalyticsRouteChildren =
  {
    PrivateRoutesAnalyticsAddRoute: PrivateRoutesAnalyticsAddRoute,
    PrivateRoutesAnalyticsIndexRoute: PrivateRoutesAnalyticsIndexRoute,
    PrivateRoutesAnalyticsBrandAccountIdIndexRoute:
      PrivateRoutesAnalyticsBrandAccountIdIndexRoute,
    PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRoute:
      PrivateRoutesAnalyticsBrandAccountIdSocialMediaSocialMediaAccountIdRouteWithChildren,
  }

const PrivateRoutesAnalyticsRouteWithChildren =
  PrivateRoutesAnalyticsRoute._addFileChildren(
    PrivateRoutesAnalyticsRouteChildren,
  )

interface PrivateRoutesAutoManagedIdRouteChildren {
  PrivateRoutesAutoManagedIdCommissionsRoute: typeof PrivateRoutesAutoManagedIdCommissionsRoute
  PrivateRoutesAutoManagedIdJoinedInfluencersRoute: typeof PrivateRoutesAutoManagedIdJoinedInfluencersRoute
  PrivateRoutesAutoManagedIdReportRoute: typeof PrivateRoutesAutoManagedIdReportRoute
  PrivateRoutesAutoManagedIdIndexRoute: typeof PrivateRoutesAutoManagedIdIndexRoute
}

const PrivateRoutesAutoManagedIdRouteChildren: PrivateRoutesAutoManagedIdRouteChildren =
  {
    PrivateRoutesAutoManagedIdCommissionsRoute:
      PrivateRoutesAutoManagedIdCommissionsRoute,
    PrivateRoutesAutoManagedIdJoinedInfluencersRoute:
      PrivateRoutesAutoManagedIdJoinedInfluencersRoute,
    PrivateRoutesAutoManagedIdReportRoute:
      PrivateRoutesAutoManagedIdReportRoute,
    PrivateRoutesAutoManagedIdIndexRoute: PrivateRoutesAutoManagedIdIndexRoute,
  }

const PrivateRoutesAutoManagedIdRouteWithChildren =
  PrivateRoutesAutoManagedIdRoute._addFileChildren(
    PrivateRoutesAutoManagedIdRouteChildren,
  )

interface PrivateRoutesAutoManagedRouteChildren {
  PrivateRoutesAutoManagedIdRoute: typeof PrivateRoutesAutoManagedIdRouteWithChildren
  PrivateRoutesAutoManagedIndexRoute: typeof PrivateRoutesAutoManagedIndexRoute
}

const PrivateRoutesAutoManagedRouteChildren: PrivateRoutesAutoManagedRouteChildren =
  {
    PrivateRoutesAutoManagedIdRoute:
      PrivateRoutesAutoManagedIdRouteWithChildren,
    PrivateRoutesAutoManagedIndexRoute: PrivateRoutesAutoManagedIndexRoute,
  }

const PrivateRoutesAutoManagedRouteWithChildren =
  PrivateRoutesAutoManagedRoute._addFileChildren(
    PrivateRoutesAutoManagedRouteChildren,
  )

interface PrivateRoutesHashtagAnalyticsInstagramRouteChildren {
  PrivateRoutesHashtagAnalyticsInstagramCountryIdRoute: typeof PrivateRoutesHashtagAnalyticsInstagramCountryIdRoute
  PrivateRoutesHashtagAnalyticsInstagramIndexRoute: typeof PrivateRoutesHashtagAnalyticsInstagramIndexRoute
}

const PrivateRoutesHashtagAnalyticsInstagramRouteChildren: PrivateRoutesHashtagAnalyticsInstagramRouteChildren =
  {
    PrivateRoutesHashtagAnalyticsInstagramCountryIdRoute:
      PrivateRoutesHashtagAnalyticsInstagramCountryIdRoute,
    PrivateRoutesHashtagAnalyticsInstagramIndexRoute:
      PrivateRoutesHashtagAnalyticsInstagramIndexRoute,
  }

const PrivateRoutesHashtagAnalyticsInstagramRouteWithChildren =
  PrivateRoutesHashtagAnalyticsInstagramRoute._addFileChildren(
    PrivateRoutesHashtagAnalyticsInstagramRouteChildren,
  )

interface PrivateRoutesHashtagAnalyticsTiktokHashtagRouteChildren {
  PrivateRoutesHashtagAnalyticsTiktokHashtagCountryIdRoute: typeof PrivateRoutesHashtagAnalyticsTiktokHashtagCountryIdRoute
  PrivateRoutesHashtagAnalyticsTiktokHashtagIndexRoute: typeof PrivateRoutesHashtagAnalyticsTiktokHashtagIndexRoute
}

const PrivateRoutesHashtagAnalyticsTiktokHashtagRouteChildren: PrivateRoutesHashtagAnalyticsTiktokHashtagRouteChildren =
  {
    PrivateRoutesHashtagAnalyticsTiktokHashtagCountryIdRoute:
      PrivateRoutesHashtagAnalyticsTiktokHashtagCountryIdRoute,
    PrivateRoutesHashtagAnalyticsTiktokHashtagIndexRoute:
      PrivateRoutesHashtagAnalyticsTiktokHashtagIndexRoute,
  }

const PrivateRoutesHashtagAnalyticsTiktokHashtagRouteWithChildren =
  PrivateRoutesHashtagAnalyticsTiktokHashtagRoute._addFileChildren(
    PrivateRoutesHashtagAnalyticsTiktokHashtagRouteChildren,
  )

interface PrivateRoutesHashtagAnalyticsTiktokKeywordRouteChildren {
  PrivateRoutesHashtagAnalyticsTiktokKeywordCountryIdRoute: typeof PrivateRoutesHashtagAnalyticsTiktokKeywordCountryIdRoute
  PrivateRoutesHashtagAnalyticsTiktokKeywordIndexRoute: typeof PrivateRoutesHashtagAnalyticsTiktokKeywordIndexRoute
}

const PrivateRoutesHashtagAnalyticsTiktokKeywordRouteChildren: PrivateRoutesHashtagAnalyticsTiktokKeywordRouteChildren =
  {
    PrivateRoutesHashtagAnalyticsTiktokKeywordCountryIdRoute:
      PrivateRoutesHashtagAnalyticsTiktokKeywordCountryIdRoute,
    PrivateRoutesHashtagAnalyticsTiktokKeywordIndexRoute:
      PrivateRoutesHashtagAnalyticsTiktokKeywordIndexRoute,
  }

const PrivateRoutesHashtagAnalyticsTiktokKeywordRouteWithChildren =
  PrivateRoutesHashtagAnalyticsTiktokKeywordRoute._addFileChildren(
    PrivateRoutesHashtagAnalyticsTiktokKeywordRouteChildren,
  )

interface PrivateRoutesHashtagAnalyticsTiktokRouteChildren {
  PrivateRoutesHashtagAnalyticsTiktokHashtagRoute: typeof PrivateRoutesHashtagAnalyticsTiktokHashtagRouteWithChildren
  PrivateRoutesHashtagAnalyticsTiktokKeywordRoute: typeof PrivateRoutesHashtagAnalyticsTiktokKeywordRouteWithChildren
  PrivateRoutesHashtagAnalyticsTiktokIndexRoute: typeof PrivateRoutesHashtagAnalyticsTiktokIndexRoute
}

const PrivateRoutesHashtagAnalyticsTiktokRouteChildren: PrivateRoutesHashtagAnalyticsTiktokRouteChildren =
  {
    PrivateRoutesHashtagAnalyticsTiktokHashtagRoute:
      PrivateRoutesHashtagAnalyticsTiktokHashtagRouteWithChildren,
    PrivateRoutesHashtagAnalyticsTiktokKeywordRoute:
      PrivateRoutesHashtagAnalyticsTiktokKeywordRouteWithChildren,
    PrivateRoutesHashtagAnalyticsTiktokIndexRoute:
      PrivateRoutesHashtagAnalyticsTiktokIndexRoute,
  }

const PrivateRoutesHashtagAnalyticsTiktokRouteWithChildren =
  PrivateRoutesHashtagAnalyticsTiktokRoute._addFileChildren(
    PrivateRoutesHashtagAnalyticsTiktokRouteChildren,
  )

interface PrivateRoutesHashtagAnalyticsRouteChildren {
  PrivateRoutesHashtagAnalyticsInstagramRoute: typeof PrivateRoutesHashtagAnalyticsInstagramRouteWithChildren
  PrivateRoutesHashtagAnalyticsTiktokRoute: typeof PrivateRoutesHashtagAnalyticsTiktokRouteWithChildren
  PrivateRoutesHashtagAnalyticsIndexRoute: typeof PrivateRoutesHashtagAnalyticsIndexRoute
}

const PrivateRoutesHashtagAnalyticsRouteChildren: PrivateRoutesHashtagAnalyticsRouteChildren =
  {
    PrivateRoutesHashtagAnalyticsInstagramRoute:
      PrivateRoutesHashtagAnalyticsInstagramRouteWithChildren,
    PrivateRoutesHashtagAnalyticsTiktokRoute:
      PrivateRoutesHashtagAnalyticsTiktokRouteWithChildren,
    PrivateRoutesHashtagAnalyticsIndexRoute:
      PrivateRoutesHashtagAnalyticsIndexRoute,
  }

const PrivateRoutesHashtagAnalyticsRouteWithChildren =
  PrivateRoutesHashtagAnalyticsRoute._addFileChildren(
    PrivateRoutesHashtagAnalyticsRouteChildren,
  )

interface PrivateRoutesInfluencerIdProfileRouteChildren {
  PrivateRoutesInfluencerIdProfileCampaignsRoute: typeof PrivateRoutesInfluencerIdProfileCampaignsRoute
  PrivateRoutesInfluencerIdProfileCompareRoute: typeof PrivateRoutesInfluencerIdProfileCompareRoute
  PrivateRoutesInfluencerIdProfileIndexRoute: typeof PrivateRoutesInfluencerIdProfileIndexRoute
}

const PrivateRoutesInfluencerIdProfileRouteChildren: PrivateRoutesInfluencerIdProfileRouteChildren =
  {
    PrivateRoutesInfluencerIdProfileCampaignsRoute:
      PrivateRoutesInfluencerIdProfileCampaignsRoute,
    PrivateRoutesInfluencerIdProfileCompareRoute:
      PrivateRoutesInfluencerIdProfileCompareRoute,
    PrivateRoutesInfluencerIdProfileIndexRoute:
      PrivateRoutesInfluencerIdProfileIndexRoute,
  }

const PrivateRoutesInfluencerIdProfileRouteWithChildren =
  PrivateRoutesInfluencerIdProfileRoute._addFileChildren(
    PrivateRoutesInfluencerIdProfileRouteChildren,
  )

interface PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_compare_feed_videosRouteChildren {
  PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_compare_feed_videosCompareIdRoute: typeof PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_compare_feed_videosCompareIdRoute
  PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_compare_feed_videosIndexRoute: typeof PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_compare_feed_videosIndexRoute
}

const PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_compare_feed_videosRouteChildren: PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_compare_feed_videosRouteChildren =
  {
    PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_compare_feed_videosCompareIdRoute:
      PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_compare_feed_videosCompareIdRoute,
    PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_compare_feed_videosIndexRoute:
      PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_compare_feed_videosIndexRoute,
  }

const PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_compare_feed_videosRouteWithChildren =
  PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_compare_feed_videosRoute._addFileChildren(
    PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_compare_feed_videosRouteChildren,
  )

interface PrivateRoutesInfluencerIdRouteChildren {
  PrivateRoutesInfluencerIdProfileRoute: typeof PrivateRoutesInfluencerIdProfileRouteWithChildren
  PrivateRoutesInfluencerIdIndexRoute: typeof PrivateRoutesInfluencerIdIndexRoute
  PrivateRoutesInfluencerIdSocialMediaAccountIdFacebook_feed_postRoute: typeof PrivateRoutesInfluencerIdSocialMediaAccountIdFacebook_feed_postRoute
  PrivateRoutesInfluencerIdSocialMediaAccountIdFeed_videosRoute: typeof PrivateRoutesInfluencerIdSocialMediaAccountIdFeed_videosRoute
  PrivateRoutesInfluencerIdSocialMediaAccountIdInstagram_feed_postRoute: typeof PrivateRoutesInfluencerIdSocialMediaAccountIdInstagram_feed_postRoute
  PrivateRoutesInfluencerIdSocialMediaAccountIdInstagram_reel_postRoute: typeof PrivateRoutesInfluencerIdSocialMediaAccountIdInstagram_reel_postRoute
  PrivateRoutesInfluencerIdSocialMediaAccountIdInstagram_story_postRoute: typeof PrivateRoutesInfluencerIdSocialMediaAccountIdInstagram_story_postRoute
  PrivateRoutesInfluencerIdSocialMediaAccountIdScraping_feed_postsRoute: typeof PrivateRoutesInfluencerIdSocialMediaAccountIdScraping_feed_postsRoute
  PrivateRoutesInfluencerIdSocialMediaAccountIdShortsRoute: typeof PrivateRoutesInfluencerIdSocialMediaAccountIdShortsRoute
  PrivateRoutesInfluencerIdSocialMediaAccountIdSponsored_feed_postsRoute: typeof PrivateRoutesInfluencerIdSocialMediaAccountIdSponsored_feed_postsRoute
  PrivateRoutesInfluencerIdSocialMediaAccountIdSponsored_youtube_feed_postsRoute: typeof PrivateRoutesInfluencerIdSocialMediaAccountIdSponsored_youtube_feed_postsRoute
  PrivateRoutesInfluencerIdSocialMediaAccountIdTwitter_feed_postsRoute: typeof PrivateRoutesInfluencerIdSocialMediaAccountIdTwitter_feed_postsRoute
  PrivateRoutesInfluencerIdSocialMediaAccountIdXhs_picture_postsRoute: typeof PrivateRoutesInfluencerIdSocialMediaAccountIdXhs_picture_postsRoute
  PrivateRoutesInfluencerIdSocialMediaAccountIdXhs_video_postsRoute: typeof PrivateRoutesInfluencerIdSocialMediaAccountIdXhs_video_postsRoute
  PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_compare_feed_videosRoute: typeof PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_compare_feed_videosRouteWithChildren
  PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_tags_rankingRoute: typeof PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_tags_rankingRoute
}

const PrivateRoutesInfluencerIdRouteChildren: PrivateRoutesInfluencerIdRouteChildren =
  {
    PrivateRoutesInfluencerIdProfileRoute:
      PrivateRoutesInfluencerIdProfileRouteWithChildren,
    PrivateRoutesInfluencerIdIndexRoute: PrivateRoutesInfluencerIdIndexRoute,
    PrivateRoutesInfluencerIdSocialMediaAccountIdFacebook_feed_postRoute:
      PrivateRoutesInfluencerIdSocialMediaAccountIdFacebook_feed_postRoute,
    PrivateRoutesInfluencerIdSocialMediaAccountIdFeed_videosRoute:
      PrivateRoutesInfluencerIdSocialMediaAccountIdFeed_videosRoute,
    PrivateRoutesInfluencerIdSocialMediaAccountIdInstagram_feed_postRoute:
      PrivateRoutesInfluencerIdSocialMediaAccountIdInstagram_feed_postRoute,
    PrivateRoutesInfluencerIdSocialMediaAccountIdInstagram_reel_postRoute:
      PrivateRoutesInfluencerIdSocialMediaAccountIdInstagram_reel_postRoute,
    PrivateRoutesInfluencerIdSocialMediaAccountIdInstagram_story_postRoute:
      PrivateRoutesInfluencerIdSocialMediaAccountIdInstagram_story_postRoute,
    PrivateRoutesInfluencerIdSocialMediaAccountIdScraping_feed_postsRoute:
      PrivateRoutesInfluencerIdSocialMediaAccountIdScraping_feed_postsRoute,
    PrivateRoutesInfluencerIdSocialMediaAccountIdShortsRoute:
      PrivateRoutesInfluencerIdSocialMediaAccountIdShortsRoute,
    PrivateRoutesInfluencerIdSocialMediaAccountIdSponsored_feed_postsRoute:
      PrivateRoutesInfluencerIdSocialMediaAccountIdSponsored_feed_postsRoute,
    PrivateRoutesInfluencerIdSocialMediaAccountIdSponsored_youtube_feed_postsRoute:
      PrivateRoutesInfluencerIdSocialMediaAccountIdSponsored_youtube_feed_postsRoute,
    PrivateRoutesInfluencerIdSocialMediaAccountIdTwitter_feed_postsRoute:
      PrivateRoutesInfluencerIdSocialMediaAccountIdTwitter_feed_postsRoute,
    PrivateRoutesInfluencerIdSocialMediaAccountIdXhs_picture_postsRoute:
      PrivateRoutesInfluencerIdSocialMediaAccountIdXhs_picture_postsRoute,
    PrivateRoutesInfluencerIdSocialMediaAccountIdXhs_video_postsRoute:
      PrivateRoutesInfluencerIdSocialMediaAccountIdXhs_video_postsRoute,
    PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_compare_feed_videosRoute:
      PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_compare_feed_videosRouteWithChildren,
    PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_tags_rankingRoute:
      PrivateRoutesInfluencerIdSocialMediaAccountIdYoutube_tags_rankingRoute,
  }

const PrivateRoutesInfluencerIdRouteWithChildren =
  PrivateRoutesInfluencerIdRoute._addFileChildren(
    PrivateRoutesInfluencerIdRouteChildren,
  )

interface PrivateRoutesInfluencerRouteChildren {
  PrivateRoutesInfluencerIdRoute: typeof PrivateRoutesInfluencerIdRouteWithChildren
  PrivateRoutesInfluencerAddRoute: typeof PrivateRoutesInfluencerAddRoute
  PrivateRoutesInfluencerIndexRoute: typeof PrivateRoutesInfluencerIndexRoute
}

const PrivateRoutesInfluencerRouteChildren: PrivateRoutesInfluencerRouteChildren =
  {
    PrivateRoutesInfluencerIdRoute: PrivateRoutesInfluencerIdRouteWithChildren,
    PrivateRoutesInfluencerAddRoute: PrivateRoutesInfluencerAddRoute,
    PrivateRoutesInfluencerIndexRoute: PrivateRoutesInfluencerIndexRoute,
  }

const PrivateRoutesInfluencerRouteWithChildren =
  PrivateRoutesInfluencerRoute._addFileChildren(
    PrivateRoutesInfluencerRouteChildren,
  )

interface PrivateRoutesInfluencersSearchRouteChildren {
  PrivateRoutesInfluencersSearchDouyinRoute: typeof PrivateRoutesInfluencersSearchDouyinRoute
  PrivateRoutesInfluencersSearchFacebookRoute: typeof PrivateRoutesInfluencersSearchFacebookRoute
  PrivateRoutesInfluencersSearchFacebook_pageRoute: typeof PrivateRoutesInfluencersSearchFacebook_pageRoute
  PrivateRoutesInfluencersSearchInstagramRoute: typeof PrivateRoutesInfluencersSearchInstagramRoute
  PrivateRoutesInfluencersSearchThreadsRoute: typeof PrivateRoutesInfluencersSearchThreadsRoute
  PrivateRoutesInfluencersSearchTiktokRoute: typeof PrivateRoutesInfluencersSearchTiktokRoute
  PrivateRoutesInfluencersSearchTwitterRoute: typeof PrivateRoutesInfluencersSearchTwitterRoute
  PrivateRoutesInfluencersSearchXhsRoute: typeof PrivateRoutesInfluencersSearchXhsRoute
  PrivateRoutesInfluencersSearchYoutubeRoute: typeof PrivateRoutesInfluencersSearchYoutubeRoute
  PrivateRoutesInfluencersSearchIndexRoute: typeof PrivateRoutesInfluencersSearchIndexRoute
}

const PrivateRoutesInfluencersSearchRouteChildren: PrivateRoutesInfluencersSearchRouteChildren =
  {
    PrivateRoutesInfluencersSearchDouyinRoute:
      PrivateRoutesInfluencersSearchDouyinRoute,
    PrivateRoutesInfluencersSearchFacebookRoute:
      PrivateRoutesInfluencersSearchFacebookRoute,
    PrivateRoutesInfluencersSearchFacebook_pageRoute:
      PrivateRoutesInfluencersSearchFacebook_pageRoute,
    PrivateRoutesInfluencersSearchInstagramRoute:
      PrivateRoutesInfluencersSearchInstagramRoute,
    PrivateRoutesInfluencersSearchThreadsRoute:
      PrivateRoutesInfluencersSearchThreadsRoute,
    PrivateRoutesInfluencersSearchTiktokRoute:
      PrivateRoutesInfluencersSearchTiktokRoute,
    PrivateRoutesInfluencersSearchTwitterRoute:
      PrivateRoutesInfluencersSearchTwitterRoute,
    PrivateRoutesInfluencersSearchXhsRoute:
      PrivateRoutesInfluencersSearchXhsRoute,
    PrivateRoutesInfluencersSearchYoutubeRoute:
      PrivateRoutesInfluencersSearchYoutubeRoute,
    PrivateRoutesInfluencersSearchIndexRoute:
      PrivateRoutesInfluencersSearchIndexRoute,
  }

const PrivateRoutesInfluencersSearchRouteWithChildren =
  PrivateRoutesInfluencersSearchRoute._addFileChildren(
    PrivateRoutesInfluencersSearchRouteChildren,
  )

interface PrivateRoutesInfluencersRouteChildren {
  PrivateRoutesInfluencersProposalRoute: typeof PrivateRoutesInfluencersProposalRoute
  PrivateRoutesInfluencersSearchRoute: typeof PrivateRoutesInfluencersSearchRouteWithChildren
  PrivateRoutesInfluencersIndexRoute: typeof PrivateRoutesInfluencersIndexRoute
}

const PrivateRoutesInfluencersRouteChildren: PrivateRoutesInfluencersRouteChildren =
  {
    PrivateRoutesInfluencersProposalRoute:
      PrivateRoutesInfluencersProposalRoute,
    PrivateRoutesInfluencersSearchRoute:
      PrivateRoutesInfluencersSearchRouteWithChildren,
    PrivateRoutesInfluencersIndexRoute: PrivateRoutesInfluencersIndexRoute,
  }

const PrivateRoutesInfluencersRouteWithChildren =
  PrivateRoutesInfluencersRoute._addFileChildren(
    PrivateRoutesInfluencersRouteChildren,
  )

interface PrivateRoutesPackageIdContentSearchRouteChildren {
  PrivateRoutesPackageIdContentSearchDouyinRoute: typeof PrivateRoutesPackageIdContentSearchDouyinRoute
  PrivateRoutesPackageIdContentSearchFacebookRoute: typeof PrivateRoutesPackageIdContentSearchFacebookRoute
  PrivateRoutesPackageIdContentSearchFacebook_pageRoute: typeof PrivateRoutesPackageIdContentSearchFacebook_pageRoute
  PrivateRoutesPackageIdContentSearchInstagramRoute: typeof PrivateRoutesPackageIdContentSearchInstagramRoute
  PrivateRoutesPackageIdContentSearchThreadsRoute: typeof PrivateRoutesPackageIdContentSearchThreadsRoute
  PrivateRoutesPackageIdContentSearchTiktokRoute: typeof PrivateRoutesPackageIdContentSearchTiktokRoute
  PrivateRoutesPackageIdContentSearchTwitterRoute: typeof PrivateRoutesPackageIdContentSearchTwitterRoute
  PrivateRoutesPackageIdContentSearchXhsRoute: typeof PrivateRoutesPackageIdContentSearchXhsRoute
  PrivateRoutesPackageIdContentSearchYoutubeRoute: typeof PrivateRoutesPackageIdContentSearchYoutubeRoute
  PrivateRoutesPackageIdContentSearchIndexRoute: typeof PrivateRoutesPackageIdContentSearchIndexRoute
}

const PrivateRoutesPackageIdContentSearchRouteChildren: PrivateRoutesPackageIdContentSearchRouteChildren =
  {
    PrivateRoutesPackageIdContentSearchDouyinRoute:
      PrivateRoutesPackageIdContentSearchDouyinRoute,
    PrivateRoutesPackageIdContentSearchFacebookRoute:
      PrivateRoutesPackageIdContentSearchFacebookRoute,
    PrivateRoutesPackageIdContentSearchFacebook_pageRoute:
      PrivateRoutesPackageIdContentSearchFacebook_pageRoute,
    PrivateRoutesPackageIdContentSearchInstagramRoute:
      PrivateRoutesPackageIdContentSearchInstagramRoute,
    PrivateRoutesPackageIdContentSearchThreadsRoute:
      PrivateRoutesPackageIdContentSearchThreadsRoute,
    PrivateRoutesPackageIdContentSearchTiktokRoute:
      PrivateRoutesPackageIdContentSearchTiktokRoute,
    PrivateRoutesPackageIdContentSearchTwitterRoute:
      PrivateRoutesPackageIdContentSearchTwitterRoute,
    PrivateRoutesPackageIdContentSearchXhsRoute:
      PrivateRoutesPackageIdContentSearchXhsRoute,
    PrivateRoutesPackageIdContentSearchYoutubeRoute:
      PrivateRoutesPackageIdContentSearchYoutubeRoute,
    PrivateRoutesPackageIdContentSearchIndexRoute:
      PrivateRoutesPackageIdContentSearchIndexRoute,
  }

const PrivateRoutesPackageIdContentSearchRouteWithChildren =
  PrivateRoutesPackageIdContentSearchRoute._addFileChildren(
    PrivateRoutesPackageIdContentSearchRouteChildren,
  )

interface PrivateRoutesPackageIdContentRouteChildren {
  PrivateRoutesPackageIdContentListRoute: typeof PrivateRoutesPackageIdContentListRoute
  PrivateRoutesPackageIdContentSearchRoute: typeof PrivateRoutesPackageIdContentSearchRouteWithChildren
  PrivateRoutesPackageIdContentIndexRoute: typeof PrivateRoutesPackageIdContentIndexRoute
}

const PrivateRoutesPackageIdContentRouteChildren: PrivateRoutesPackageIdContentRouteChildren =
  {
    PrivateRoutesPackageIdContentListRoute:
      PrivateRoutesPackageIdContentListRoute,
    PrivateRoutesPackageIdContentSearchRoute:
      PrivateRoutesPackageIdContentSearchRouteWithChildren,
    PrivateRoutesPackageIdContentIndexRoute:
      PrivateRoutesPackageIdContentIndexRoute,
  }

const PrivateRoutesPackageIdContentRouteWithChildren =
  PrivateRoutesPackageIdContentRoute._addFileChildren(
    PrivateRoutesPackageIdContentRouteChildren,
  )

interface PrivateRoutesPackageIdRouteChildren {
  PrivateRoutesPackageIdContentRoute: typeof PrivateRoutesPackageIdContentRouteWithChildren
  PrivateRoutesPackageIdIndexRoute: typeof PrivateRoutesPackageIdIndexRoute
}

const PrivateRoutesPackageIdRouteChildren: PrivateRoutesPackageIdRouteChildren =
  {
    PrivateRoutesPackageIdContentRoute:
      PrivateRoutesPackageIdContentRouteWithChildren,
    PrivateRoutesPackageIdIndexRoute: PrivateRoutesPackageIdIndexRoute,
  }

const PrivateRoutesPackageIdRouteWithChildren =
  PrivateRoutesPackageIdRoute._addFileChildren(
    PrivateRoutesPackageIdRouteChildren,
  )

interface PrivateRoutesPackageRouteChildren {
  PrivateRoutesPackageIdRoute: typeof PrivateRoutesPackageIdRouteWithChildren
  PrivateRoutesPackageAddRoute: typeof PrivateRoutesPackageAddRoute
  PrivateRoutesPackageIndexRoute: typeof PrivateRoutesPackageIndexRoute
}

const PrivateRoutesPackageRouteChildren: PrivateRoutesPackageRouteChildren = {
  PrivateRoutesPackageIdRoute: PrivateRoutesPackageIdRouteWithChildren,
  PrivateRoutesPackageAddRoute: PrivateRoutesPackageAddRoute,
  PrivateRoutesPackageIndexRoute: PrivateRoutesPackageIndexRoute,
}

const PrivateRoutesPackageRouteWithChildren =
  PrivateRoutesPackageRoute._addFileChildren(PrivateRoutesPackageRouteChildren)

interface PrivateRoutesPartnerIdRouteChildren {
  PrivateRoutesPartnerIdBusinessRoute: typeof PrivateRoutesPartnerIdBusinessRoute
  PrivateRoutesPartnerIdUsersRoute: typeof PrivateRoutesPartnerIdUsersRoute
  PrivateRoutesPartnerIdIndexRoute: typeof PrivateRoutesPartnerIdIndexRoute
}

const PrivateRoutesPartnerIdRouteChildren: PrivateRoutesPartnerIdRouteChildren =
  {
    PrivateRoutesPartnerIdBusinessRoute: PrivateRoutesPartnerIdBusinessRoute,
    PrivateRoutesPartnerIdUsersRoute: PrivateRoutesPartnerIdUsersRoute,
    PrivateRoutesPartnerIdIndexRoute: PrivateRoutesPartnerIdIndexRoute,
  }

const PrivateRoutesPartnerIdRouteWithChildren =
  PrivateRoutesPartnerIdRoute._addFileChildren(
    PrivateRoutesPartnerIdRouteChildren,
  )

interface PrivateRoutesPartnerRouteChildren {
  PrivateRoutesPartnerIdRoute: typeof PrivateRoutesPartnerIdRouteWithChildren
  PrivateRoutesPartnerIndexRoute: typeof PrivateRoutesPartnerIndexRoute
}

const PrivateRoutesPartnerRouteChildren: PrivateRoutesPartnerRouteChildren = {
  PrivateRoutesPartnerIdRoute: PrivateRoutesPartnerIdRouteWithChildren,
  PrivateRoutesPartnerIndexRoute: PrivateRoutesPartnerIndexRoute,
}

const PrivateRoutesPartnerRouteWithChildren =
  PrivateRoutesPartnerRoute._addFileChildren(PrivateRoutesPartnerRouteChildren)

interface PrivateRoutesPostsInsightIdRouteChildren {
  PrivateRoutesPostsInsightIdPostIdRoute: typeof PrivateRoutesPostsInsightIdPostIdRoute
}

const PrivateRoutesPostsInsightIdRouteChildren: PrivateRoutesPostsInsightIdRouteChildren =
  {
    PrivateRoutesPostsInsightIdPostIdRoute:
      PrivateRoutesPostsInsightIdPostIdRoute,
  }

const PrivateRoutesPostsInsightIdRouteWithChildren =
  PrivateRoutesPostsInsightIdRoute._addFileChildren(
    PrivateRoutesPostsInsightIdRouteChildren,
  )

interface PrivateRoutesPostsInsightRouteChildren {
  PrivateRoutesPostsInsightIdRoute: typeof PrivateRoutesPostsInsightIdRouteWithChildren
  PrivateRoutesPostsInsightIndexRoute: typeof PrivateRoutesPostsInsightIndexRoute
}

const PrivateRoutesPostsInsightRouteChildren: PrivateRoutesPostsInsightRouteChildren =
  {
    PrivateRoutesPostsInsightIdRoute:
      PrivateRoutesPostsInsightIdRouteWithChildren,
    PrivateRoutesPostsInsightIndexRoute: PrivateRoutesPostsInsightIndexRoute,
  }

const PrivateRoutesPostsInsightRouteWithChildren =
  PrivateRoutesPostsInsightRoute._addFileChildren(
    PrivateRoutesPostsInsightRouteChildren,
  )

interface PrivateRoutesTalentAgencyIdRouteChildren {
  PrivateRoutesTalentAgencyIdBusinessRoute: typeof PrivateRoutesTalentAgencyIdBusinessRoute
  PrivateRoutesTalentAgencyIdUsersRoute: typeof PrivateRoutesTalentAgencyIdUsersRoute
  PrivateRoutesTalentAgencyIdIndexRoute: typeof PrivateRoutesTalentAgencyIdIndexRoute
}

const PrivateRoutesTalentAgencyIdRouteChildren: PrivateRoutesTalentAgencyIdRouteChildren =
  {
    PrivateRoutesTalentAgencyIdBusinessRoute:
      PrivateRoutesTalentAgencyIdBusinessRoute,
    PrivateRoutesTalentAgencyIdUsersRoute:
      PrivateRoutesTalentAgencyIdUsersRoute,
    PrivateRoutesTalentAgencyIdIndexRoute:
      PrivateRoutesTalentAgencyIdIndexRoute,
  }

const PrivateRoutesTalentAgencyIdRouteWithChildren =
  PrivateRoutesTalentAgencyIdRoute._addFileChildren(
    PrivateRoutesTalentAgencyIdRouteChildren,
  )

interface PrivateRoutesTalentAgencyRouteChildren {
  PrivateRoutesTalentAgencyIdRoute: typeof PrivateRoutesTalentAgencyIdRouteWithChildren
  PrivateRoutesTalentAgencyAddRoute: typeof PrivateRoutesTalentAgencyAddRoute
  PrivateRoutesTalentAgencyIndexRoute: typeof PrivateRoutesTalentAgencyIndexRoute
}

const PrivateRoutesTalentAgencyRouteChildren: PrivateRoutesTalentAgencyRouteChildren =
  {
    PrivateRoutesTalentAgencyIdRoute:
      PrivateRoutesTalentAgencyIdRouteWithChildren,
    PrivateRoutesTalentAgencyAddRoute: PrivateRoutesTalentAgencyAddRoute,
    PrivateRoutesTalentAgencyIndexRoute: PrivateRoutesTalentAgencyIndexRoute,
  }

const PrivateRoutesTalentAgencyRouteWithChildren =
  PrivateRoutesTalentAgencyRoute._addFileChildren(
    PrivateRoutesTalentAgencyRouteChildren,
  )

interface PrivateRoutesTiktokAdCampaignReportRouteChildren {
  PrivateRoutesTiktokAdCampaignReportIndexRoute: typeof PrivateRoutesTiktokAdCampaignReportIndexRoute
  PrivateRoutesTiktokAdCampaignReportIdGroupIdRoute: typeof PrivateRoutesTiktokAdCampaignReportIdGroupIdRoute
  PrivateRoutesTiktokAdCampaignReportIdIndexRoute: typeof PrivateRoutesTiktokAdCampaignReportIdIndexRoute
}

const PrivateRoutesTiktokAdCampaignReportRouteChildren: PrivateRoutesTiktokAdCampaignReportRouteChildren =
  {
    PrivateRoutesTiktokAdCampaignReportIndexRoute:
      PrivateRoutesTiktokAdCampaignReportIndexRoute,
    PrivateRoutesTiktokAdCampaignReportIdGroupIdRoute:
      PrivateRoutesTiktokAdCampaignReportIdGroupIdRoute,
    PrivateRoutesTiktokAdCampaignReportIdIndexRoute:
      PrivateRoutesTiktokAdCampaignReportIdIndexRoute,
  }

const PrivateRoutesTiktokAdCampaignReportRouteWithChildren =
  PrivateRoutesTiktokAdCampaignReportRoute._addFileChildren(
    PrivateRoutesTiktokAdCampaignReportRouteChildren,
  )

interface PrivateRoutesTiktokCampaignsIdPostsRouteChildren {
  PrivateRoutesTiktokCampaignsIdPostsPostIdRoute: typeof PrivateRoutesTiktokCampaignsIdPostsPostIdRoute
  PrivateRoutesTiktokCampaignsIdPostsIndexRoute: typeof PrivateRoutesTiktokCampaignsIdPostsIndexRoute
}

const PrivateRoutesTiktokCampaignsIdPostsRouteChildren: PrivateRoutesTiktokCampaignsIdPostsRouteChildren =
  {
    PrivateRoutesTiktokCampaignsIdPostsPostIdRoute:
      PrivateRoutesTiktokCampaignsIdPostsPostIdRoute,
    PrivateRoutesTiktokCampaignsIdPostsIndexRoute:
      PrivateRoutesTiktokCampaignsIdPostsIndexRoute,
  }

const PrivateRoutesTiktokCampaignsIdPostsRouteWithChildren =
  PrivateRoutesTiktokCampaignsIdPostsRoute._addFileChildren(
    PrivateRoutesTiktokCampaignsIdPostsRouteChildren,
  )

interface PrivateRoutesTiktokCampaignsIdRouteChildren {
  PrivateRoutesTiktokCampaignsIdInfluencersRoute: typeof PrivateRoutesTiktokCampaignsIdInfluencersRoute
  PrivateRoutesTiktokCampaignsIdPostsRoute: typeof PrivateRoutesTiktokCampaignsIdPostsRouteWithChildren
  PrivateRoutesTiktokCampaignsIdReportRoute: typeof PrivateRoutesTiktokCampaignsIdReportRoute
  PrivateRoutesTiktokCampaignsIdIndexRoute: typeof PrivateRoutesTiktokCampaignsIdIndexRoute
}

const PrivateRoutesTiktokCampaignsIdRouteChildren: PrivateRoutesTiktokCampaignsIdRouteChildren =
  {
    PrivateRoutesTiktokCampaignsIdInfluencersRoute:
      PrivateRoutesTiktokCampaignsIdInfluencersRoute,
    PrivateRoutesTiktokCampaignsIdPostsRoute:
      PrivateRoutesTiktokCampaignsIdPostsRouteWithChildren,
    PrivateRoutesTiktokCampaignsIdReportRoute:
      PrivateRoutesTiktokCampaignsIdReportRoute,
    PrivateRoutesTiktokCampaignsIdIndexRoute:
      PrivateRoutesTiktokCampaignsIdIndexRoute,
  }

const PrivateRoutesTiktokCampaignsIdRouteWithChildren =
  PrivateRoutesTiktokCampaignsIdRoute._addFileChildren(
    PrivateRoutesTiktokCampaignsIdRouteChildren,
  )

interface PrivateRoutesTiktokCampaignsRouteChildren {
  PrivateRoutesTiktokCampaignsIdRoute: typeof PrivateRoutesTiktokCampaignsIdRouteWithChildren
  PrivateRoutesTiktokCampaignsAddRoute: typeof PrivateRoutesTiktokCampaignsAddRoute
  PrivateRoutesTiktokCampaignsReviewInfluencersRoute: typeof PrivateRoutesTiktokCampaignsReviewInfluencersRoute
  PrivateRoutesTiktokCampaignsIndexRoute: typeof PrivateRoutesTiktokCampaignsIndexRoute
}

const PrivateRoutesTiktokCampaignsRouteChildren: PrivateRoutesTiktokCampaignsRouteChildren =
  {
    PrivateRoutesTiktokCampaignsIdRoute:
      PrivateRoutesTiktokCampaignsIdRouteWithChildren,
    PrivateRoutesTiktokCampaignsAddRoute: PrivateRoutesTiktokCampaignsAddRoute,
    PrivateRoutesTiktokCampaignsReviewInfluencersRoute:
      PrivateRoutesTiktokCampaignsReviewInfluencersRoute,
    PrivateRoutesTiktokCampaignsIndexRoute:
      PrivateRoutesTiktokCampaignsIndexRoute,
  }

const PrivateRoutesTiktokCampaignsRouteWithChildren =
  PrivateRoutesTiktokCampaignsRoute._addFileChildren(
    PrivateRoutesTiktokCampaignsRouteChildren,
  )

interface PrivateRoutesTiktokRouteChildren {
  PrivateRoutesTiktokAdAccountsRoute: typeof PrivateRoutesTiktokAdAccountsRoute
  PrivateRoutesTiktokAdCampaignReportRoute: typeof PrivateRoutesTiktokAdCampaignReportRouteWithChildren
  PrivateRoutesTiktokAdvertiserDetailsRoute: typeof PrivateRoutesTiktokAdvertiserDetailsRoute
  PrivateRoutesTiktokBudgetAllocationRoute: typeof PrivateRoutesTiktokBudgetAllocationRoute
  PrivateRoutesTiktokCampaignsRoute: typeof PrivateRoutesTiktokCampaignsRouteWithChildren
  PrivateRoutesTiktokFailedPaymentRoute: typeof PrivateRoutesTiktokFailedPaymentRoute
  PrivateRoutesTiktokSubscriptionBillingRoute: typeof PrivateRoutesTiktokSubscriptionBillingRoute
}

const PrivateRoutesTiktokRouteChildren: PrivateRoutesTiktokRouteChildren = {
  PrivateRoutesTiktokAdAccountsRoute: PrivateRoutesTiktokAdAccountsRoute,
  PrivateRoutesTiktokAdCampaignReportRoute:
    PrivateRoutesTiktokAdCampaignReportRouteWithChildren,
  PrivateRoutesTiktokAdvertiserDetailsRoute:
    PrivateRoutesTiktokAdvertiserDetailsRoute,
  PrivateRoutesTiktokBudgetAllocationRoute:
    PrivateRoutesTiktokBudgetAllocationRoute,
  PrivateRoutesTiktokCampaignsRoute:
    PrivateRoutesTiktokCampaignsRouteWithChildren,
  PrivateRoutesTiktokFailedPaymentRoute: PrivateRoutesTiktokFailedPaymentRoute,
  PrivateRoutesTiktokSubscriptionBillingRoute:
    PrivateRoutesTiktokSubscriptionBillingRoute,
}

const PrivateRoutesTiktokRouteWithChildren =
  PrivateRoutesTiktokRoute._addFileChildren(PrivateRoutesTiktokRouteChildren)

interface PrivateRoutesToolsRouteChildren {
  PrivateRoutesToolsVideoCompAiRoute: typeof PrivateRoutesToolsVideoCompAiRoute
  PrivateRoutesToolsIndexRoute: typeof PrivateRoutesToolsIndexRoute
}

const PrivateRoutesToolsRouteChildren: PrivateRoutesToolsRouteChildren = {
  PrivateRoutesToolsVideoCompAiRoute: PrivateRoutesToolsVideoCompAiRoute,
  PrivateRoutesToolsIndexRoute: PrivateRoutesToolsIndexRoute,
}

const PrivateRoutesToolsRouteWithChildren =
  PrivateRoutesToolsRoute._addFileChildren(PrivateRoutesToolsRouteChildren)

interface PrivateRoutesTrendingRouteChildren {
  PrivateRoutesTrendingInfluencersRoute: typeof PrivateRoutesTrendingInfluencersRoute
  PrivateRoutesTrendingPostsRoute: typeof PrivateRoutesTrendingPostsRoute
  PrivateRoutesTrendingIndexRoute: typeof PrivateRoutesTrendingIndexRoute
}

const PrivateRoutesTrendingRouteChildren: PrivateRoutesTrendingRouteChildren = {
  PrivateRoutesTrendingInfluencersRoute: PrivateRoutesTrendingInfluencersRoute,
  PrivateRoutesTrendingPostsRoute: PrivateRoutesTrendingPostsRoute,
  PrivateRoutesTrendingIndexRoute: PrivateRoutesTrendingIndexRoute,
}

const PrivateRoutesTrendingRouteWithChildren =
  PrivateRoutesTrendingRoute._addFileChildren(
    PrivateRoutesTrendingRouteChildren,
  )

interface PrivateRoutesUserRouteChildren {
  PrivateRoutesUserIdRoute: typeof PrivateRoutesUserIdRoute
  PrivateRoutesUserAddRoute: typeof PrivateRoutesUserAddRoute
  PrivateRoutesUserLinkedRoute: typeof PrivateRoutesUserLinkedRoute
  PrivateRoutesUserIndexRoute: typeof PrivateRoutesUserIndexRoute
}

const PrivateRoutesUserRouteChildren: PrivateRoutesUserRouteChildren = {
  PrivateRoutesUserIdRoute: PrivateRoutesUserIdRoute,
  PrivateRoutesUserAddRoute: PrivateRoutesUserAddRoute,
  PrivateRoutesUserLinkedRoute: PrivateRoutesUserLinkedRoute,
  PrivateRoutesUserIndexRoute: PrivateRoutesUserIndexRoute,
}

const PrivateRoutesUserRouteWithChildren =
  PrivateRoutesUserRoute._addFileChildren(PrivateRoutesUserRouteChildren)

interface PrivateRoutesYoutubeCmsRevenueRouteChildren {
  PrivateRoutesYoutubeCmsRevenueCmsChannelIdRoute: typeof PrivateRoutesYoutubeCmsRevenueCmsChannelIdRoute
  PrivateRoutesYoutubeCmsRevenueConfirmedRoute: typeof PrivateRoutesYoutubeCmsRevenueConfirmedRoute
  PrivateRoutesYoutubeCmsRevenueIndexRoute: typeof PrivateRoutesYoutubeCmsRevenueIndexRoute
}

const PrivateRoutesYoutubeCmsRevenueRouteChildren: PrivateRoutesYoutubeCmsRevenueRouteChildren =
  {
    PrivateRoutesYoutubeCmsRevenueCmsChannelIdRoute:
      PrivateRoutesYoutubeCmsRevenueCmsChannelIdRoute,
    PrivateRoutesYoutubeCmsRevenueConfirmedRoute:
      PrivateRoutesYoutubeCmsRevenueConfirmedRoute,
    PrivateRoutesYoutubeCmsRevenueIndexRoute:
      PrivateRoutesYoutubeCmsRevenueIndexRoute,
  }

const PrivateRoutesYoutubeCmsRevenueRouteWithChildren =
  PrivateRoutesYoutubeCmsRevenueRoute._addFileChildren(
    PrivateRoutesYoutubeCmsRevenueRouteChildren,
  )

interface PrivateRoutesYoutubeCmsRouteChildren {
  PrivateRoutesYoutubeCmsInvoicesRoute: typeof PrivateRoutesYoutubeCmsInvoicesRoute
  PrivateRoutesYoutubeCmsRevenueRoute: typeof PrivateRoutesYoutubeCmsRevenueRouteWithChildren
  PrivateRoutesYoutubeCmsIndexRoute: typeof PrivateRoutesYoutubeCmsIndexRoute
}

const PrivateRoutesYoutubeCmsRouteChildren: PrivateRoutesYoutubeCmsRouteChildren =
  {
    PrivateRoutesYoutubeCmsInvoicesRoute: PrivateRoutesYoutubeCmsInvoicesRoute,
    PrivateRoutesYoutubeCmsRevenueRoute:
      PrivateRoutesYoutubeCmsRevenueRouteWithChildren,
    PrivateRoutesYoutubeCmsIndexRoute: PrivateRoutesYoutubeCmsIndexRoute,
  }

const PrivateRoutesYoutubeCmsRouteWithChildren =
  PrivateRoutesYoutubeCmsRoute._addFileChildren(
    PrivateRoutesYoutubeCmsRouteChildren,
  )

interface PrivateRoutesEngagementIdInfluencerRouteChildren {
  PrivateRoutesEngagementIdInfluencerCampaignsRoute: typeof PrivateRoutesEngagementIdInfluencerCampaignsRoute
  PrivateRoutesEngagementIdInfluencerDouyinRoute: typeof PrivateRoutesEngagementIdInfluencerDouyinRoute
  PrivateRoutesEngagementIdInfluencerFacebookRoute: typeof PrivateRoutesEngagementIdInfluencerFacebookRoute
  PrivateRoutesEngagementIdInfluencerFacebook_pageRoute: typeof PrivateRoutesEngagementIdInfluencerFacebook_pageRoute
  PrivateRoutesEngagementIdInfluencerInstagramRoute: typeof PrivateRoutesEngagementIdInfluencerInstagramRoute
  PrivateRoutesEngagementIdInfluencerPackagesRoute: typeof PrivateRoutesEngagementIdInfluencerPackagesRoute
  PrivateRoutesEngagementIdInfluencerPostsRoute: typeof PrivateRoutesEngagementIdInfluencerPostsRoute
  PrivateRoutesEngagementIdInfluencerThreadsRoute: typeof PrivateRoutesEngagementIdInfluencerThreadsRoute
  PrivateRoutesEngagementIdInfluencerTiktokRoute: typeof PrivateRoutesEngagementIdInfluencerTiktokRoute
  PrivateRoutesEngagementIdInfluencerTwitterRoute: typeof PrivateRoutesEngagementIdInfluencerTwitterRoute
  PrivateRoutesEngagementIdInfluencerXhsRoute: typeof PrivateRoutesEngagementIdInfluencerXhsRoute
  PrivateRoutesEngagementIdInfluencerYoutubeRoute: typeof PrivateRoutesEngagementIdInfluencerYoutubeRoute
  PrivateRoutesEngagementIdInfluencerIndexRoute: typeof PrivateRoutesEngagementIdInfluencerIndexRoute
}

const PrivateRoutesEngagementIdInfluencerRouteChildren: PrivateRoutesEngagementIdInfluencerRouteChildren =
  {
    PrivateRoutesEngagementIdInfluencerCampaignsRoute:
      PrivateRoutesEngagementIdInfluencerCampaignsRoute,
    PrivateRoutesEngagementIdInfluencerDouyinRoute:
      PrivateRoutesEngagementIdInfluencerDouyinRoute,
    PrivateRoutesEngagementIdInfluencerFacebookRoute:
      PrivateRoutesEngagementIdInfluencerFacebookRoute,
    PrivateRoutesEngagementIdInfluencerFacebook_pageRoute:
      PrivateRoutesEngagementIdInfluencerFacebook_pageRoute,
    PrivateRoutesEngagementIdInfluencerInstagramRoute:
      PrivateRoutesEngagementIdInfluencerInstagramRoute,
    PrivateRoutesEngagementIdInfluencerPackagesRoute:
      PrivateRoutesEngagementIdInfluencerPackagesRoute,
    PrivateRoutesEngagementIdInfluencerPostsRoute:
      PrivateRoutesEngagementIdInfluencerPostsRoute,
    PrivateRoutesEngagementIdInfluencerThreadsRoute:
      PrivateRoutesEngagementIdInfluencerThreadsRoute,
    PrivateRoutesEngagementIdInfluencerTiktokRoute:
      PrivateRoutesEngagementIdInfluencerTiktokRoute,
    PrivateRoutesEngagementIdInfluencerTwitterRoute:
      PrivateRoutesEngagementIdInfluencerTwitterRoute,
    PrivateRoutesEngagementIdInfluencerXhsRoute:
      PrivateRoutesEngagementIdInfluencerXhsRoute,
    PrivateRoutesEngagementIdInfluencerYoutubeRoute:
      PrivateRoutesEngagementIdInfluencerYoutubeRoute,
    PrivateRoutesEngagementIdInfluencerIndexRoute:
      PrivateRoutesEngagementIdInfluencerIndexRoute,
  }

const PrivateRoutesEngagementIdInfluencerRouteWithChildren =
  PrivateRoutesEngagementIdInfluencerRoute._addFileChildren(
    PrivateRoutesEngagementIdInfluencerRouteChildren,
  )

interface PrivateRoutesEngagementIdPostsRouteChildren {
  PrivateRoutesEngagementIdPostsPostIdRoute: typeof PrivateRoutesEngagementIdPostsPostIdRoute
  PrivateRoutesEngagementIdPostsAddRoute: typeof PrivateRoutesEngagementIdPostsAddRoute
  PrivateRoutesEngagementIdPostsIndexRoute: typeof PrivateRoutesEngagementIdPostsIndexRoute
}

const PrivateRoutesEngagementIdPostsRouteChildren: PrivateRoutesEngagementIdPostsRouteChildren =
  {
    PrivateRoutesEngagementIdPostsPostIdRoute:
      PrivateRoutesEngagementIdPostsPostIdRoute,
    PrivateRoutesEngagementIdPostsAddRoute:
      PrivateRoutesEngagementIdPostsAddRoute,
    PrivateRoutesEngagementIdPostsIndexRoute:
      PrivateRoutesEngagementIdPostsIndexRoute,
  }

const PrivateRoutesEngagementIdPostsRouteWithChildren =
  PrivateRoutesEngagementIdPostsRoute._addFileChildren(
    PrivateRoutesEngagementIdPostsRouteChildren,
  )

interface PrivateRoutesEngagementIdRouteChildren {
  PrivateRoutesEngagementIdInfluencerRoute: typeof PrivateRoutesEngagementIdInfluencerRouteWithChildren
  PrivateRoutesEngagementIdPostsRoute: typeof PrivateRoutesEngagementIdPostsRouteWithChildren
  PrivateRoutesEngagementIdProposalRoute: typeof PrivateRoutesEngagementIdProposalRoute
  PrivateRoutesEngagementIdReportRoute: typeof PrivateRoutesEngagementIdReportRoute
  PrivateRoutesEngagementIdTrackingRoute: typeof PrivateRoutesEngagementIdTrackingRoute
  PrivateRoutesEngagementIdTrackingReferralCodesRoute: typeof PrivateRoutesEngagementIdTrackingReferralCodesRoute
  PrivateRoutesEngagementIdIndexRoute: typeof PrivateRoutesEngagementIdIndexRoute
}

const PrivateRoutesEngagementIdRouteChildren: PrivateRoutesEngagementIdRouteChildren =
  {
    PrivateRoutesEngagementIdInfluencerRoute:
      PrivateRoutesEngagementIdInfluencerRouteWithChildren,
    PrivateRoutesEngagementIdPostsRoute:
      PrivateRoutesEngagementIdPostsRouteWithChildren,
    PrivateRoutesEngagementIdProposalRoute:
      PrivateRoutesEngagementIdProposalRoute,
    PrivateRoutesEngagementIdReportRoute: PrivateRoutesEngagementIdReportRoute,
    PrivateRoutesEngagementIdTrackingRoute:
      PrivateRoutesEngagementIdTrackingRoute,
    PrivateRoutesEngagementIdTrackingReferralCodesRoute:
      PrivateRoutesEngagementIdTrackingReferralCodesRoute,
    PrivateRoutesEngagementIdIndexRoute: PrivateRoutesEngagementIdIndexRoute,
  }

const PrivateRoutesEngagementIdRouteWithChildren =
  PrivateRoutesEngagementIdRoute._addFileChildren(
    PrivateRoutesEngagementIdRouteChildren,
  )

interface PrivateRoutesMarketplaceIdPostsRouteChildren {
  PrivateRoutesMarketplaceIdPostsPostIdRoute: typeof PrivateRoutesMarketplaceIdPostsPostIdRoute
  PrivateRoutesMarketplaceIdPostsIndexRoute: typeof PrivateRoutesMarketplaceIdPostsIndexRoute
}

const PrivateRoutesMarketplaceIdPostsRouteChildren: PrivateRoutesMarketplaceIdPostsRouteChildren =
  {
    PrivateRoutesMarketplaceIdPostsPostIdRoute:
      PrivateRoutesMarketplaceIdPostsPostIdRoute,
    PrivateRoutesMarketplaceIdPostsIndexRoute:
      PrivateRoutesMarketplaceIdPostsIndexRoute,
  }

const PrivateRoutesMarketplaceIdPostsRouteWithChildren =
  PrivateRoutesMarketplaceIdPostsRoute._addFileChildren(
    PrivateRoutesMarketplaceIdPostsRouteChildren,
  )

interface PrivateRoutesMarketplaceIdRouteChildren {
  PrivateRoutesMarketplaceIdApplicantRoute: typeof PrivateRoutesMarketplaceIdApplicantRoute
  PrivateRoutesMarketplaceIdCommissionsRoute: typeof PrivateRoutesMarketplaceIdCommissionsRoute
  PrivateRoutesMarketplaceIdInfluencerRoute: typeof PrivateRoutesMarketplaceIdInfluencerRoute
  PrivateRoutesMarketplaceIdJoinedInfluencersRoute: typeof PrivateRoutesMarketplaceIdJoinedInfluencersRoute
  PrivateRoutesMarketplaceIdPostsRoute: typeof PrivateRoutesMarketplaceIdPostsRouteWithChildren
  PrivateRoutesMarketplaceIdReportRoute: typeof PrivateRoutesMarketplaceIdReportRoute
  PrivateRoutesMarketplaceIdReportAffiliateRoute: typeof PrivateRoutesMarketplaceIdReportAffiliateRoute
  PrivateRoutesMarketplaceIdTrackingRoute: typeof PrivateRoutesMarketplaceIdTrackingRoute
  PrivateRoutesMarketplaceIdTrackingReferralCodesRoute: typeof PrivateRoutesMarketplaceIdTrackingReferralCodesRoute
  PrivateRoutesMarketplaceIdIndexRoute: typeof PrivateRoutesMarketplaceIdIndexRoute
}

const PrivateRoutesMarketplaceIdRouteChildren: PrivateRoutesMarketplaceIdRouteChildren =
  {
    PrivateRoutesMarketplaceIdApplicantRoute:
      PrivateRoutesMarketplaceIdApplicantRoute,
    PrivateRoutesMarketplaceIdCommissionsRoute:
      PrivateRoutesMarketplaceIdCommissionsRoute,
    PrivateRoutesMarketplaceIdInfluencerRoute:
      PrivateRoutesMarketplaceIdInfluencerRoute,
    PrivateRoutesMarketplaceIdJoinedInfluencersRoute:
      PrivateRoutesMarketplaceIdJoinedInfluencersRoute,
    PrivateRoutesMarketplaceIdPostsRoute:
      PrivateRoutesMarketplaceIdPostsRouteWithChildren,
    PrivateRoutesMarketplaceIdReportRoute:
      PrivateRoutesMarketplaceIdReportRoute,
    PrivateRoutesMarketplaceIdReportAffiliateRoute:
      PrivateRoutesMarketplaceIdReportAffiliateRoute,
    PrivateRoutesMarketplaceIdTrackingRoute:
      PrivateRoutesMarketplaceIdTrackingRoute,
    PrivateRoutesMarketplaceIdTrackingReferralCodesRoute:
      PrivateRoutesMarketplaceIdTrackingReferralCodesRoute,
    PrivateRoutesMarketplaceIdIndexRoute: PrivateRoutesMarketplaceIdIndexRoute,
  }

const PrivateRoutesMarketplaceIdRouteWithChildren =
  PrivateRoutesMarketplaceIdRoute._addFileChildren(
    PrivateRoutesMarketplaceIdRouteChildren,
  )

interface PrivateRoutesMarketplaceAddRouteChildren {
  PrivateRoutesMarketplaceAddReferralCodeTrackingRoute: typeof PrivateRoutesMarketplaceAddReferralCodeTrackingRoute
  PrivateRoutesMarketplaceAddSocialMediaTrackingRoute: typeof PrivateRoutesMarketplaceAddSocialMediaTrackingRoute
  PrivateRoutesMarketplaceAddUrlTrackingRoute: typeof PrivateRoutesMarketplaceAddUrlTrackingRoute
  PrivateRoutesMarketplaceAddIndexRoute: typeof PrivateRoutesMarketplaceAddIndexRoute
  PrivateRoutesMarketplaceAddECommerceAutoMangedCampaignIdRoute: typeof PrivateRoutesMarketplaceAddECommerceAutoMangedCampaignIdRoute
  PrivateRoutesMarketplaceAddECommerceIndexRoute: typeof PrivateRoutesMarketplaceAddECommerceIndexRoute
}

const PrivateRoutesMarketplaceAddRouteChildren: PrivateRoutesMarketplaceAddRouteChildren =
  {
    PrivateRoutesMarketplaceAddReferralCodeTrackingRoute:
      PrivateRoutesMarketplaceAddReferralCodeTrackingRoute,
    PrivateRoutesMarketplaceAddSocialMediaTrackingRoute:
      PrivateRoutesMarketplaceAddSocialMediaTrackingRoute,
    PrivateRoutesMarketplaceAddUrlTrackingRoute:
      PrivateRoutesMarketplaceAddUrlTrackingRoute,
    PrivateRoutesMarketplaceAddIndexRoute:
      PrivateRoutesMarketplaceAddIndexRoute,
    PrivateRoutesMarketplaceAddECommerceAutoMangedCampaignIdRoute:
      PrivateRoutesMarketplaceAddECommerceAutoMangedCampaignIdRoute,
    PrivateRoutesMarketplaceAddECommerceIndexRoute:
      PrivateRoutesMarketplaceAddECommerceIndexRoute,
  }

const PrivateRoutesMarketplaceAddRouteWithChildren =
  PrivateRoutesMarketplaceAddRoute._addFileChildren(
    PrivateRoutesMarketplaceAddRouteChildren,
  )

interface PrivateRoutesRouteChildren {
  PrivateRoutesAdvertiserRoute: typeof PrivateRoutesAdvertiserRouteWithChildren
  PrivateRoutesAgencyRoute: typeof PrivateRoutesAgencyRouteWithChildren
  PrivateRoutesAnalyticsRoute: typeof PrivateRoutesAnalyticsRouteWithChildren
  PrivateRoutesAssetPreviewRoute: typeof PrivateRoutesAssetPreviewRoute
  PrivateRoutesAutoManagedRoute: typeof PrivateRoutesAutoManagedRouteWithChildren
  PrivateRoutesCampaignPostsDiscoveryRoute: typeof PrivateRoutesCampaignPostsDiscoveryRoute
  PrivateRoutesHashtagAnalyticsRoute: typeof PrivateRoutesHashtagAnalyticsRouteWithChildren
  PrivateRoutesInfluencerRoute: typeof PrivateRoutesInfluencerRouteWithChildren
  PrivateRoutesInfluencersRoute: typeof PrivateRoutesInfluencersRouteWithChildren
  PrivateRoutesPackageRoute: typeof PrivateRoutesPackageRouteWithChildren
  PrivateRoutesPartnerRoute: typeof PrivateRoutesPartnerRouteWithChildren
  PrivateRoutesPaymentsRoute: typeof PrivateRoutesPaymentsRoute
  PrivateRoutesPostsRoute: typeof PrivateRoutesPostsRoute
  PrivateRoutesPostsInsightRoute: typeof PrivateRoutesPostsInsightRouteWithChildren
  PrivateRoutesReportRoute: typeof PrivateRoutesReportRoute
  PrivateRoutesSettingsRoute: typeof PrivateRoutesSettingsRoute
  PrivateRoutesTalentAgencyRoute: typeof PrivateRoutesTalentAgencyRouteWithChildren
  PrivateRoutesTiktokRoute: typeof PrivateRoutesTiktokRouteWithChildren
  PrivateRoutesToolsRoute: typeof PrivateRoutesToolsRouteWithChildren
  PrivateRoutesTrendingRoute: typeof PrivateRoutesTrendingRouteWithChildren
  PrivateRoutesUserRoute: typeof PrivateRoutesUserRouteWithChildren
  PrivateRoutesUserSettingsRoute: typeof PrivateRoutesUserSettingsRoute
  PrivateRoutesYoutubeCmsRoute: typeof PrivateRoutesYoutubeCmsRouteWithChildren
  PrivateRoutesAccessAuthorizedRoute: typeof PrivateRoutesAccessAuthorizedRoute
  PrivateRoutesAccessDeclinedRoute: typeof PrivateRoutesAccessDeclinedRoute
  PrivateRoutesEngagementIdRoute: typeof PrivateRoutesEngagementIdRouteWithChildren
  PrivateRoutesEngagementAddRoute: typeof PrivateRoutesEngagementAddRoute
  PrivateRoutesMarketplaceIdRoute: typeof PrivateRoutesMarketplaceIdRouteWithChildren
  PrivateRoutesMarketplaceAddRoute: typeof PrivateRoutesMarketplaceAddRouteWithChildren
  PrivateRoutesMarketplaceReorderRoute: typeof PrivateRoutesMarketplaceReorderRoute
  PrivateRoutesRedirectGoogleAuthRoute: typeof PrivateRoutesRedirectGoogleAuthRoute
  PrivateRoutesAccessIndexRoute: typeof PrivateRoutesAccessIndexRoute
  PrivateRoutesEngagementIndexRoute: typeof PrivateRoutesEngagementIndexRoute
  PrivateRoutesMarketplaceIndexRoute: typeof PrivateRoutesMarketplaceIndexRoute
  PrivateRoutesPromptsIndexRoute: typeof PrivateRoutesPromptsIndexRoute
  PrivateRoutesRedirectAnalyticsConnectProviderRoute: typeof PrivateRoutesRedirectAnalyticsConnectProviderRoute
  PrivateRoutesRedirectAnalyticsListConnectProviderRoute: typeof PrivateRoutesRedirectAnalyticsListConnectProviderRoute
  PrivateRoutesRedirectAnalyticsSigninProviderRoute: typeof PrivateRoutesRedirectAnalyticsSigninProviderRoute
  PrivateRoutesRedirectConnectTiktokBusinessRoute: typeof PrivateRoutesRedirectConnectTiktokBusinessRoute
  PrivateRoutesRedirectHiddenYoutubeListConnectRoute: typeof PrivateRoutesRedirectHiddenYoutubeListConnectRoute
  PrivateRoutesRedirectTalentAnalyticsConnectProviderRoute: typeof PrivateRoutesRedirectTalentAnalyticsConnectProviderRoute
  PrivateRoutesRedirectTalentSigninProviderRoute: typeof PrivateRoutesRedirectTalentSigninProviderRoute
}

const PrivateRoutesRouteChildren: PrivateRoutesRouteChildren = {
  PrivateRoutesAdvertiserRoute: PrivateRoutesAdvertiserRouteWithChildren,
  PrivateRoutesAgencyRoute: PrivateRoutesAgencyRouteWithChildren,
  PrivateRoutesAnalyticsRoute: PrivateRoutesAnalyticsRouteWithChildren,
  PrivateRoutesAssetPreviewRoute: PrivateRoutesAssetPreviewRoute,
  PrivateRoutesAutoManagedRoute: PrivateRoutesAutoManagedRouteWithChildren,
  PrivateRoutesCampaignPostsDiscoveryRoute:
    PrivateRoutesCampaignPostsDiscoveryRoute,
  PrivateRoutesHashtagAnalyticsRoute:
    PrivateRoutesHashtagAnalyticsRouteWithChildren,
  PrivateRoutesInfluencerRoute: PrivateRoutesInfluencerRouteWithChildren,
  PrivateRoutesInfluencersRoute: PrivateRoutesInfluencersRouteWithChildren,
  PrivateRoutesPackageRoute: PrivateRoutesPackageRouteWithChildren,
  PrivateRoutesPartnerRoute: PrivateRoutesPartnerRouteWithChildren,
  PrivateRoutesPaymentsRoute: PrivateRoutesPaymentsRoute,
  PrivateRoutesPostsRoute: PrivateRoutesPostsRoute,
  PrivateRoutesPostsInsightRoute: PrivateRoutesPostsInsightRouteWithChildren,
  PrivateRoutesReportRoute: PrivateRoutesReportRoute,
  PrivateRoutesSettingsRoute: PrivateRoutesSettingsRoute,
  PrivateRoutesTalentAgencyRoute: PrivateRoutesTalentAgencyRouteWithChildren,
  PrivateRoutesTiktokRoute: PrivateRoutesTiktokRouteWithChildren,
  PrivateRoutesToolsRoute: PrivateRoutesToolsRouteWithChildren,
  PrivateRoutesTrendingRoute: PrivateRoutesTrendingRouteWithChildren,
  PrivateRoutesUserRoute: PrivateRoutesUserRouteWithChildren,
  PrivateRoutesUserSettingsRoute: PrivateRoutesUserSettingsRoute,
  PrivateRoutesYoutubeCmsRoute: PrivateRoutesYoutubeCmsRouteWithChildren,
  PrivateRoutesAccessAuthorizedRoute: PrivateRoutesAccessAuthorizedRoute,
  PrivateRoutesAccessDeclinedRoute: PrivateRoutesAccessDeclinedRoute,
  PrivateRoutesEngagementIdRoute: PrivateRoutesEngagementIdRouteWithChildren,
  PrivateRoutesEngagementAddRoute: PrivateRoutesEngagementAddRoute,
  PrivateRoutesMarketplaceIdRoute: PrivateRoutesMarketplaceIdRouteWithChildren,
  PrivateRoutesMarketplaceAddRoute:
    PrivateRoutesMarketplaceAddRouteWithChildren,
  PrivateRoutesMarketplaceReorderRoute: PrivateRoutesMarketplaceReorderRoute,
  PrivateRoutesRedirectGoogleAuthRoute: PrivateRoutesRedirectGoogleAuthRoute,
  PrivateRoutesAccessIndexRoute: PrivateRoutesAccessIndexRoute,
  PrivateRoutesEngagementIndexRoute: PrivateRoutesEngagementIndexRoute,
  PrivateRoutesMarketplaceIndexRoute: PrivateRoutesMarketplaceIndexRoute,
  PrivateRoutesPromptsIndexRoute: PrivateRoutesPromptsIndexRoute,
  PrivateRoutesRedirectAnalyticsConnectProviderRoute:
    PrivateRoutesRedirectAnalyticsConnectProviderRoute,
  PrivateRoutesRedirectAnalyticsListConnectProviderRoute:
    PrivateRoutesRedirectAnalyticsListConnectProviderRoute,
  PrivateRoutesRedirectAnalyticsSigninProviderRoute:
    PrivateRoutesRedirectAnalyticsSigninProviderRoute,
  PrivateRoutesRedirectConnectTiktokBusinessRoute:
    PrivateRoutesRedirectConnectTiktokBusinessRoute,
  PrivateRoutesRedirectHiddenYoutubeListConnectRoute:
    PrivateRoutesRedirectHiddenYoutubeListConnectRoute,
  PrivateRoutesRedirectTalentAnalyticsConnectProviderRoute:
    PrivateRoutesRedirectTalentAnalyticsConnectProviderRoute,
  PrivateRoutesRedirectTalentSigninProviderRoute:
    PrivateRoutesRedirectTalentSigninProviderRoute,
}

const PrivateRoutesRouteWithChildren = PrivateRoutesRoute._addFileChildren(
  PrivateRoutesRouteChildren,
)

interface PublicRoutesTiktokOnboardingRouteChildren {
  PublicRoutesTiktokOnboardingAdAccountRoute: typeof PublicRoutesTiktokOnboardingAdAccountRoute
  PublicRoutesTiktokOnboardingPasswordEnterRoute: typeof PublicRoutesTiktokOnboardingPasswordEnterRoute
  PublicRoutesTiktokOnboardingSelectPlanRoute: typeof PublicRoutesTiktokOnboardingSelectPlanRoute
  PublicRoutesTiktokOnboardingSuccessRoute: typeof PublicRoutesTiktokOnboardingSuccessRoute
  PublicRoutesTiktokOnboardingIndexRoute: typeof PublicRoutesTiktokOnboardingIndexRoute
  PublicRoutesTiktokOnboardingPasswordRegisterTokenRoute: typeof PublicRoutesTiktokOnboardingPasswordRegisterTokenRoute
}

const PublicRoutesTiktokOnboardingRouteChildren: PublicRoutesTiktokOnboardingRouteChildren =
  {
    PublicRoutesTiktokOnboardingAdAccountRoute:
      PublicRoutesTiktokOnboardingAdAccountRoute,
    PublicRoutesTiktokOnboardingPasswordEnterRoute:
      PublicRoutesTiktokOnboardingPasswordEnterRoute,
    PublicRoutesTiktokOnboardingSelectPlanRoute:
      PublicRoutesTiktokOnboardingSelectPlanRoute,
    PublicRoutesTiktokOnboardingSuccessRoute:
      PublicRoutesTiktokOnboardingSuccessRoute,
    PublicRoutesTiktokOnboardingIndexRoute:
      PublicRoutesTiktokOnboardingIndexRoute,
    PublicRoutesTiktokOnboardingPasswordRegisterTokenRoute:
      PublicRoutesTiktokOnboardingPasswordRegisterTokenRoute,
  }

const PublicRoutesTiktokOnboardingRouteWithChildren =
  PublicRoutesTiktokOnboardingRoute._addFileChildren(
    PublicRoutesTiktokOnboardingRouteChildren,
  )

interface PublicRoutesRouteChildren {
  PublicRoutesPrivacyRoute: typeof PublicRoutesPrivacyRoute
  PublicRoutesRedirect_toRoute: typeof PublicRoutesRedirect_toRoute
  PublicRoutesSignInRoute: typeof PublicRoutesSignInRoute
  PublicRoutesTermsRoute: typeof PublicRoutesTermsRoute
  PublicRoutesTermsCombinedRoute: typeof PublicRoutesTermsCombinedRoute
  PublicRoutesTiktokOnboardingRoute: typeof PublicRoutesTiktokOnboardingRouteWithChildren
  PublicRoutesPasswordPassword_forgotRoute: typeof PublicRoutesPasswordPassword_forgotRoute
  PublicRoutesEggReferralRoute: typeof PublicRoutesEggReferralRoute
  PublicRoutesMkpReferralRoute: typeof PublicRoutesMkpReferralRoute
  PublicRoutesSignUpSuccessRoute: typeof PublicRoutesSignUpSuccessRoute
  PublicRoutesSignUpIndexRoute: typeof PublicRoutesSignUpIndexRoute
  PublicRoutesPasswordPassword_registerTokenRoute: typeof PublicRoutesPasswordPassword_registerTokenRoute
  PublicRoutesPasswordPassword_resetTokenRoute: typeof PublicRoutesPasswordPassword_resetTokenRoute
}

const PublicRoutesRouteChildren: PublicRoutesRouteChildren = {
  PublicRoutesPrivacyRoute: PublicRoutesPrivacyRoute,
  PublicRoutesRedirect_toRoute: PublicRoutesRedirect_toRoute,
  PublicRoutesSignInRoute: PublicRoutesSignInRoute,
  PublicRoutesTermsRoute: PublicRoutesTermsRoute,
  PublicRoutesTermsCombinedRoute: PublicRoutesTermsCombinedRoute,
  PublicRoutesTiktokOnboardingRoute:
    PublicRoutesTiktokOnboardingRouteWithChildren,
  PublicRoutesPasswordPassword_forgotRoute:
    PublicRoutesPasswordPassword_forgotRoute,
  PublicRoutesEggReferralRoute: PublicRoutesEggReferralRoute,
  PublicRoutesMkpReferralRoute: PublicRoutesMkpReferralRoute,
  PublicRoutesSignUpSuccessRoute: PublicRoutesSignUpSuccessRoute,
  PublicRoutesSignUpIndexRoute: PublicRoutesSignUpIndexRoute,
  PublicRoutesPasswordPassword_registerTokenRoute:
    PublicRoutesPasswordPassword_registerTokenRoute,
  PublicRoutesPasswordPassword_resetTokenRoute:
    PublicRoutesPasswordPassword_resetTokenRoute,
}

const PublicRoutesRouteWithChildren = PublicRoutesRoute._addFileChildren(
  PublicRoutesRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  PrivateRoutesRoute: PrivateRoutesRouteWithChildren,
  PublicRoutesRoute: PublicRoutesRouteWithChildren,
  NotFoundRoute: NotFoundRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
